/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://dinosaursdoingstuffgames.s3.eu-west-2.amazonaws.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "uXl7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/fEa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) {
  return obj && obj.__esModule ? obj['default'] : obj;
}

var _Motion = __webpack_require__("lxaz");

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__("J1st");

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__("PnSf");

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__("d5UN");

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__("7uOZ");

exports.presets = _interopRequire(_presets);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__("xRMi");

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ "0mEO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1wHk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__("GvBW");

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__("MRQS");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),

/***/ "4GBI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ "6nU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7uOZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),

/***/ "8YJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AX2D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("EBst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process === 'undefined' || !process.env || "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || component;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "BEQ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),

/***/ "BwbV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "EBst":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "EaSk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("EBst");

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /** @jsx h */

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        // preact-compat normally does this
        var children = nextProps.children,
            props = _objectWithoutProperties(nextProps, ['children']);

        if (children && children.length) props.children = children;
        return shallowDiffers(props, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return (0, _preact.h)(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_preact.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

    return SideEffect;
  };

  // Pulled from react-compat
  function shallowDiffers(a, b) {
    for (var i in a) {
      if (!(i in b)) return true;
    }for (var _i in b) {
      if (a[_i] !== b[_i]) return true;
    }return false;
  }
};

/***/ }),

/***/ "Einx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ "F/Ev":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("AX2D");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__("nnEy");

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__("eLVa");

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__("1wHk");

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__("Einx");

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__("MRQS");

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc["aria-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement("div", {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown,
        "aria-modal": "true"
      }, _react2.default.createElement("div", _extends({
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.ariaAttributes(this.props.aria || {}), {
        "data-testid": this.props.testId
      }), this.props.children));
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ "FY7a":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__("EBst")) : typeof define === 'function' && define.amd ? define(['preact'], factory) : global.PreactTransitionGroup = factory(global.preact);
})(this, function (preact) {

	function assign(obj, props) {
		for (var i in props) {
			if (props.hasOwnProperty(i)) obj[i] = props[i];
		}return obj;
	}

	function getKey(vnode, fallback) {
		var key = vnode.attributes && vnode.attributes.key;
		return key === null || key === undefined ? fallback : key;
	}

	function linkRef(component, name) {
		var cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
		return cache[name] || (cache[name] = function (c) {
			component.refs[name] = c;
		});
	}

	function getChildMapping(children) {
		var out = {};
		for (var i = 0; i < children.length; i++) {
			if (children[i] != null) {
				var key = getKey(children[i], i.toString(36));
				out[key] = children[i];
			}
		}
		return out;
	}

	function mergeChildMappings(prev, next) {
		prev = prev || {};
		next = next || {};

		var getValueForKey = function getValueForKey(key) {
			return next.hasOwnProperty(key) ? next[key] : prev[key];
		};

		var nextKeysPending = {};

		var pendingKeys = [];
		for (var prevKey in prev) {
			if (next.hasOwnProperty(prevKey)) {
				if (pendingKeys.length) {
					nextKeysPending[prevKey] = pendingKeys;
					pendingKeys = [];
				}
			} else {
				pendingKeys.push(prevKey);
			}
		}

		var childMapping = {};
		for (var nextKey in next) {
			if (nextKeysPending.hasOwnProperty(nextKey)) {
				for (var i = 0; i < nextKeysPending[nextKey].length; i++) {
					var pendingNextKey = nextKeysPending[nextKey][i];
					childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
				}
			}
			childMapping[nextKey] = getValueForKey(nextKey);
		}

		for (var _i = 0; _i < pendingKeys.length; _i++) {
			childMapping[pendingKeys[_i]] = getValueForKey(pendingKeys[_i]);
		}

		return childMapping;
	}

	var classCallCheck = function classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	};

	var get = function get(object, property, receiver) {
		if (object === null) object = Function.prototype;
		var desc = Object.getOwnPropertyDescriptor(object, property);

		if (desc === undefined) {
			var parent = Object.getPrototypeOf(object);

			if (parent === null) {
				return undefined;
			} else {
				return get(parent, property, receiver);
			}
		} else if ("value" in desc) {
			return desc.value;
		} else {
			var getter = desc.get;

			if (getter === undefined) {
				return undefined;
			}

			return getter.call(receiver);
		}
	};

	var inherits = function inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};

	var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
		var target = {};

		for (var i in obj) {
			if (keys.indexOf(i) >= 0) continue;
			if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
			target[i] = obj[i];
		}

		return target;
	};

	var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};

	var set = function set(object, property, value, receiver) {
		var desc = Object.getOwnPropertyDescriptor(object, property);

		if (desc === undefined) {
			var parent = Object.getPrototypeOf(object);

			if (parent !== null) {
				set(parent, property, value, receiver);
			}
		} else if ("value" in desc && desc.writable) {
			desc.value = value;
		} else {
			var setter = desc.set;

			if (setter !== undefined) {
				setter.call(receiver, value);
			}
		}

		return value;
	};

	var identity = function identity(i) {
		return i;
	};

	var TransitionGroup$1 = function (_Component) {
		inherits(TransitionGroup, _Component);

		function TransitionGroup() {
			var _temp, _this, _ret;

			classCallCheck(this, TransitionGroup);

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.refs = {}, _this.state = {
				children: getChildMapping(_this.props.children || [])
			}, _this.performEnter = function (key) {
				_this.currentlyTransitioningKeys[key] = true;

				var component = _this.refs[key];

				if (component.componentWillEnter) {
					component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
				} else {
					_this._handleDoneEntering(key);
				}
			}, _this.performLeave = function (key) {
				_this.currentlyTransitioningKeys[key] = true;

				var component = _this.refs[key];
				if (component.componentWillLeave) {
					component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
				} else {
					_this._handleDoneLeaving(key);
				}
			}, _temp), possibleConstructorReturn(_this, _ret);
		}

		TransitionGroup.prototype.componentWillMount = function componentWillMount() {
			this.currentlyTransitioningKeys = {};
			this.keysToEnter = [];
			this.keysToLeave = [];
		};

		TransitionGroup.prototype.componentDidMount = function componentDidMount() {
			var initialChildMapping = this.state.children;
			for (var key in initialChildMapping) {
				if (initialChildMapping[key]) {
					this.performAppear(key);
				}
			}
		};

		TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			var nextChildMapping = getChildMapping(nextProps.children || []);
			var prevChildMapping = this.state.children;

			this.setState({
				children: mergeChildMappings(prevChildMapping, nextChildMapping)
			});

			var key = void 0;

			for (key in nextChildMapping) {
				if (nextChildMapping.hasOwnProperty(key)) {
					var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
					if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
						this.keysToEnter.push(key);
					}
				}
			}for (key in prevChildMapping) {
				if (prevChildMapping.hasOwnProperty(key)) {
					var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
					if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
						this.keysToLeave.push(key);
					}
				}
			}
		};

		TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
			var keysToEnter = this.keysToEnter;
			this.keysToEnter = [];
			keysToEnter.forEach(this.performEnter);

			var keysToLeave = this.keysToLeave;
			this.keysToLeave = [];
			keysToLeave.forEach(this.performLeave);
		};

		TransitionGroup.prototype.performAppear = function performAppear(key) {
			this.currentlyTransitioningKeys[key] = true;

			var component = this.refs[key];

			if (component.componentWillAppear) {
				component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
			} else {
				this._handleDoneAppearing(key);
			}
		};

		TransitionGroup.prototype._handleDoneAppearing = function _handleDoneAppearing(key) {
			var component = this.refs[key];
			if (component.componentDidAppear) {
				component.componentDidAppear();
			}

			delete this.currentlyTransitioningKeys[key];

			var currentChildMapping = getChildMapping(this.props.children || []);

			if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
				this.performLeave(key);
			}
		};

		TransitionGroup.prototype._handleDoneEntering = function _handleDoneEntering(key) {
			var component = this.refs[key];
			if (component.componentDidEnter) {
				component.componentDidEnter();
			}

			delete this.currentlyTransitioningKeys[key];

			var currentChildMapping = getChildMapping(this.props.children || []);

			if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
				this.performLeave(key);
			}
		};

		TransitionGroup.prototype._handleDoneLeaving = function _handleDoneLeaving(key) {
			var component = this.refs[key];

			if (component.componentDidLeave) {
				component.componentDidLeave();
			}

			delete this.currentlyTransitioningKeys[key];

			var currentChildMapping = getChildMapping(this.props.children || []);

			if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
				this.performEnter(key);
			} else {
				var children = assign({}, this.state.children);
				delete children[key];
				this.setState({ children: children });
			}
		};

		TransitionGroup.prototype.render = function render(_ref, _ref2) {
			var childFactory = _ref.childFactory;
			var transitionLeave = _ref.transitionLeave;
			var transitionName = _ref.transitionName;
			var transitionAppear = _ref.transitionAppear;
			var transitionEnter = _ref.transitionEnter;
			var transitionLeaveTimeout = _ref.transitionLeaveTimeout;
			var transitionEnterTimeout = _ref.transitionEnterTimeout;
			var transitionAppearTimeout = _ref.transitionAppearTimeout;
			var component = _ref.component;
			var props = objectWithoutProperties(_ref, ['childFactory', 'transitionLeave', 'transitionName', 'transitionAppear', 'transitionEnter', 'transitionLeaveTimeout', 'transitionEnterTimeout', 'transitionAppearTimeout', 'component']);
			var children = _ref2.children;

			var childrenToRender = [];
			for (var key in children) {
				if (children.hasOwnProperty(key)) {
					var child = children[key];
					if (child) {
						var ref = linkRef(this, key),
						    el = preact.cloneElement(childFactory(child), { ref: ref, key: key });
						childrenToRender.push(el);
					}
				}
			}return preact.h(component, props, childrenToRender);
		};

		return TransitionGroup;
	}(preact.Component);
	TransitionGroup$1.defaultProps = {
		component: 'span',
		childFactory: identity
	};

	return TransitionGroup$1;
});
//# sourceMappingURL=preact-transition-group.js.map

/***/ }),

/***/ "GvBW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function warning() {};

if (false) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "J1st":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _mapToZero = __webpack_require__("uEG6");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("4GBI");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("iEfW");

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__("UGHC");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("ommR");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("R0Jm");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("AX2D");

var _react2 = _interopRequireDefault(_react);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = _react2['default'].createClass({
  displayName: 'StaggeredMotion',

  propTypes: {
    // TOOD: warn against putting a config in here
    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.objectOf(_react.PropTypes.number)),
    styles: _react.PropTypes.func.isRequired,
    children: _react.PropTypes.func.isRequired
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  },

  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyles: null,
  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
    var _state = this.state;
    var currentStyles = _state.currentStyles;
    var currentVelocities = _state.currentVelocities;
    var lastIdealStyles = _state.lastIdealStyles;
    var lastIdealVelocities = _state.lastIdealVelocities;

    var someDirty = false;
    for (var i = 0; i < unreadPropStyles.length; i++) {
      var unreadPropStyle = unreadPropStyles[i];
      var dirty = false;

      for (var key in unreadPropStyle) {
        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
          continue;
        }

        var styleValue = unreadPropStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            someDirty = true;
            currentStyles[i] = _extends({}, currentStyles[i]);
            currentVelocities[i] = _extends({}, currentVelocities[i]);
            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
          }
          currentStyles[i][key] = styleValue;
          currentVelocities[i][key] = 0;
          lastIdealStyles[i][key] = styleValue;
          lastIdealVelocities[i][key] = 0;
        }
      }
    }

    if (someDirty) {
      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
    }
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      var destStyles = _this.props.styles(_this.state.lastIdealStyles);

      // check if we need to animate in the first place
      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.accumulatedTime = 0;
        return;
      }

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var newLastIdealStyles = [];
      var newLastIdealVelocities = [];
      var newCurrentStyles = [];
      var newCurrentVelocities = [];

      for (var i = 0; i < destStyles.length; i++) {
        var destStyle = destStyles[i];
        var newCurrentStyle = {};
        var newCurrentVelocity = {};
        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};

        for (var key in destStyle) {
          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
            continue;
          }

          var styleValue = destStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
            for (var j = 0; j < framesToCatchUp; j++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        newCurrentStyles[i] = newCurrentStyle;
        newCurrentVelocities[i] = newCurrentVelocity;
        newLastIdealStyles[i] = newLastIdealStyle;
        newLastIdealVelocities[i] = newLastIdealVelocity;
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyles: newCurrentStyles,
        currentVelocities: newCurrentVelocities,
        lastIdealStyles: newLastIdealStyles,
        lastIdealVelocities: newLastIdealVelocities
      });

      _this.unreadPropStyles = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("EBst");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("y+SO");

// EXTERNAL MODULE: ./node_modules/preact-router/match.js
var match = __webpack_require__("KN6U");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}
// CONCATENATED MODULE: ./node_modules/history/index.js


/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */
var Action;

(function (Action) {
  /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */
  Action["Pop"] = "POP";
  /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */

  Action["Push"] = "PUSH";
  /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */

  Action["Replace"] = "REPLACE";
})(Action || (Action = {}));

var readOnly =  false ? function (obj) {
  return Object.freeze(obj);
} : function (obj) {
  return obj;
};

function warning(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== 'undefined') console.warn(message);

    try {
      // Welcome to debugging history!
      //
      // This error is thrown as a convenience so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message); // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}

var BeforeUnloadEventType = 'beforeunload';
var HashChangeEventType = 'hashchange';
var PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */

function createBrowserHistory(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$window = _options.window,
      window = _options$window === void 0 ? document.defaultView : _options$window;
  var globalHistory = window.history;

  function getIndexAndLocation() {
    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var state = globalHistory.state || {};
    return [state.idx, readOnly({
      pathname: pathname,
      search: search,
      hash: hash,
      state: state.usr || null,
      key: state.key || 'default'
    })];
  }

  var blockedPopTx = null;

  function handlePop() {
    if (blockedPopTx) {
      blockers.call(blockedPopTx);
      blockedPopTx = null;
    } else {
      var nextAction = Action.Pop;

      var _getIndexAndLocation = getIndexAndLocation(),
          nextIndex = _getIndexAndLocation[0],
          nextLocation = _getIndexAndLocation[1];

      if (blockers.length) {
        if (nextIndex != null) {
          var delta = index - nextIndex;

          if (delta) {
            // Revert the POP
            blockedPopTx = {
              action: nextAction,
              location: nextLocation,
              retry: function retry() {
                go(delta * -1);
              }
            };
            go(delta);
          }
        } else {
          // Trying to POP to a location with no index. We did not create
          // this location, so we can't effectively block the navigation.
           false ? warning(false, // TODO: Write up a doc that explains our blocking strategy in
          // detail and link to it here so people can understand better what
          // is going on and how to avoid it.
          "You are trying to block a POP navigation to a location that was not " + "created by the history library. The block will fail silently in " + "production, but in general you should do all navigation with the " + "history library (instead of using window.history.pushState directly) " + "to avoid this situation.") : void 0;
        }
      } else {
        applyTx(nextAction);
      }
    }
  }

  window.addEventListener(PopStateEventType, handlePop);
  var action = Action.Pop;

  var _getIndexAndLocation2 = getIndexAndLocation(),
      index = _getIndexAndLocation2[0],
      location = _getIndexAndLocation2[1];

  var listeners = createEvents();
  var blockers = createEvents();

  if (index == null) {
    index = 0;
    globalHistory.replaceState(_extends({}, globalHistory.state, {
      idx: index
    }), '');
  }

  function createHref(to) {
    return typeof to === 'string' ? to : createPath(to);
  } // state defaults to `null` because `window.history.state` does


  function getNextLocation(to, state) {
    if (state === void 0) {
      state = null;
    }

    return readOnly(_extends({
      pathname: location.pathname,
      hash: '',
      search: ''
    }, typeof to === 'string' ? parsePath(to) : to, {
      state: state,
      key: createKey()
    }));
  }

  function getHistoryStateAndUrl(nextLocation, index) {
    return [{
      usr: nextLocation.state,
      key: nextLocation.key,
      idx: index
    }, createHref(nextLocation)];
  }

  function allowTx(action, location, retry) {
    return !blockers.length || (blockers.call({
      action: action,
      location: location,
      retry: retry
    }), false);
  }

  function applyTx(nextAction) {
    action = nextAction;

    var _getIndexAndLocation3 = getIndexAndLocation();

    index = _getIndexAndLocation3[0];
    location = _getIndexAndLocation3[1];
    listeners.call({
      action: action,
      location: location
    });
  }

  function push(to, state) {
    var nextAction = Action.Push;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      push(to, state);
    }

    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1),
          historyState = _getHistoryStateAndUr[0],
          url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
      // try...catch because iOS limits us to 100 pushState calls :/


      try {
        globalHistory.pushState(historyState, '', url);
      } catch (error) {
        // They are going to lose state here, but there is no real
        // way to warn them about it since the page will refresh...
        window.location.assign(url);
      }

      applyTx(nextAction);
    }
  }

  function replace(to, state) {
    var nextAction = Action.Replace;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      replace(to, state);
    }

    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index),
          historyState = _getHistoryStateAndUr2[0],
          url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading


      globalHistory.replaceState(historyState, '', url);
      applyTx(nextAction);
    }
  }

  function go(delta) {
    globalHistory.go(delta);
  }

  var history = {
    get action() {
      return action;
    },

    get location() {
      return location;
    },

    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    back: function back() {
      go(-1);
    },
    forward: function forward() {
      go(1);
    },
    listen: function listen(listener) {
      return listeners.push(listener);
    },
    block: function block(blocker) {
      var unblock = blockers.push(blocker);

      if (blockers.length === 1) {
        window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
      }

      return function () {
        unblock(); // Remove the beforeunload listener so the document may
        // still be salvageable in the pagehide event.
        // See https://html.spec.whatwg.org/#unloading-documents

        if (!blockers.length) {
          window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
        }
      };
    }
  };
  return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */

function createHashHistory(options) {
  if (options === void 0) {
    options = {};
  }

  var _options2 = options,
      _options2$window = _options2.window,
      window = _options2$window === void 0 ? document.defaultView : _options2$window;
  var globalHistory = window.history;

  function getIndexAndLocation() {
    var _parsePath = parsePath(window.location.hash.substr(1)),
        _parsePath$pathname = _parsePath.pathname,
        pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname,
        _parsePath$search = _parsePath.search,
        search = _parsePath$search === void 0 ? '' : _parsePath$search,
        _parsePath$hash = _parsePath.hash,
        hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;

    var state = globalHistory.state || {};
    return [state.idx, readOnly({
      pathname: pathname,
      search: search,
      hash: hash,
      state: state.usr || null,
      key: state.key || 'default'
    })];
  }

  var blockedPopTx = null;

  function handlePop() {
    if (blockedPopTx) {
      blockers.call(blockedPopTx);
      blockedPopTx = null;
    } else {
      var nextAction = Action.Pop;

      var _getIndexAndLocation4 = getIndexAndLocation(),
          nextIndex = _getIndexAndLocation4[0],
          nextLocation = _getIndexAndLocation4[1];

      if (blockers.length) {
        if (nextIndex != null) {
          var delta = index - nextIndex;

          if (delta) {
            // Revert the POP
            blockedPopTx = {
              action: nextAction,
              location: nextLocation,
              retry: function retry() {
                go(delta * -1);
              }
            };
            go(delta);
          }
        } else {
          // Trying to POP to a location with no index. We did not create
          // this location, so we can't effectively block the navigation.
           false ? warning(false, // TODO: Write up a doc that explains our blocking strategy in
          // detail and link to it here so people can understand better
          // what is going on and how to avoid it.
          "You are trying to block a POP navigation to a location that was not " + "created by the history library. The block will fail silently in " + "production, but in general you should do all navigation with the " + "history library (instead of using window.history.pushState directly) " + "to avoid this situation.") : void 0;
        }
      } else {
        applyTx(nextAction);
      }
    }
  }

  window.addEventListener(PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
  // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event

  window.addEventListener(HashChangeEventType, function () {
    var _getIndexAndLocation5 = getIndexAndLocation(),
        nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.


    if (createPath(nextLocation) !== createPath(location)) {
      handlePop();
    }
  });
  var action = Action.Pop;

  var _getIndexAndLocation6 = getIndexAndLocation(),
      index = _getIndexAndLocation6[0],
      location = _getIndexAndLocation6[1];

  var listeners = createEvents();
  var blockers = createEvents();

  if (index == null) {
    index = 0;
    globalHistory.replaceState(_extends({}, globalHistory.state, {
      idx: index
    }), '');
  }

  function getBaseHref() {
    var base = document.querySelector('base');
    var href = '';

    if (base && base.getAttribute('href')) {
      var url = window.location.href;
      var hashIndex = url.indexOf('#');
      href = hashIndex === -1 ? url : url.slice(0, hashIndex);
    }

    return href;
  }

  function createHref(to) {
    return getBaseHref() + '#' + (typeof to === 'string' ? to : createPath(to));
  }

  function getNextLocation(to, state) {
    if (state === void 0) {
      state = null;
    }

    return readOnly(_extends({
      pathname: location.pathname,
      hash: '',
      search: ''
    }, typeof to === 'string' ? parsePath(to) : to, {
      state: state,
      key: createKey()
    }));
  }

  function getHistoryStateAndUrl(nextLocation, index) {
    return [{
      usr: nextLocation.state,
      key: nextLocation.key,
      idx: index
    }, createHref(nextLocation)];
  }

  function allowTx(action, location, retry) {
    return !blockers.length || (blockers.call({
      action: action,
      location: location,
      retry: retry
    }), false);
  }

  function applyTx(nextAction) {
    action = nextAction;

    var _getIndexAndLocation7 = getIndexAndLocation();

    index = _getIndexAndLocation7[0];
    location = _getIndexAndLocation7[1];
    listeners.call({
      action: action,
      location: location
    });
  }

  function push(to, state) {
    var nextAction = Action.Push;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      push(to, state);
    }

     false ? warning(nextLocation.pathname.charAt(0) === '/', "Relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")") : void 0;

    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1),
          historyState = _getHistoryStateAndUr3[0],
          url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
      // try...catch because iOS limits us to 100 pushState calls :/


      try {
        globalHistory.pushState(historyState, '', url);
      } catch (error) {
        // They are going to lose state here, but there is no real
        // way to warn them about it since the page will refresh...
        window.location.assign(url);
      }

      applyTx(nextAction);
    }
  }

  function replace(to, state) {
    var nextAction = Action.Replace;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      replace(to, state);
    }

     false ? warning(nextLocation.pathname.charAt(0) === '/', "Relative pathnames are not supported in hash history.replace(" + JSON.stringify(to) + ")") : void 0;

    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index),
          historyState = _getHistoryStateAndUr4[0],
          url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading


      globalHistory.replaceState(historyState, '', url);
      applyTx(nextAction);
    }
  }

  function go(delta) {
    globalHistory.go(delta);
  }

  var history = {
    get action() {
      return action;
    },

    get location() {
      return location;
    },

    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    back: function back() {
      go(-1);
    },
    forward: function forward() {
      go(1);
    },
    listen: function listen(listener) {
      return listeners.push(listener);
    },
    block: function block(blocker) {
      var unblock = blockers.push(blocker);

      if (blockers.length === 1) {
        window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
      }

      return function () {
        unblock(); // Remove the beforeunload listener so the document may
        // still be salvageable in the pagehide event.
        // See https://html.spec.whatwg.org/#unloading-documents

        if (!blockers.length) {
          window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
        }
      };
    }
  };
  return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */

function createMemoryHistory(options) {
  if (options === void 0) {
    options = {};
  }

  var _options3 = options,
      _options3$initialEntr = _options3.initialEntries,
      initialEntries = _options3$initialEntr === void 0 ? ['/'] : _options3$initialEntr,
      initialIndex = _options3.initialIndex;
  var entries = initialEntries.map(function (entry) {
    var location = readOnly(_extends({
      pathname: '/',
      search: '',
      hash: '',
      state: null,
      key: createKey()
    }, typeof entry === 'string' ? parsePath(entry) : entry));
     false ? warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(entry) + ")") : void 0;
    return location;
  });
  var index = clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
  var action = Action.Pop;
  var location = entries[index];
  var listeners = createEvents();
  var blockers = createEvents();

  function createHref(to) {
    return typeof to === 'string' ? to : createPath(to);
  }

  function getNextLocation(to, state) {
    if (state === void 0) {
      state = null;
    }

    return readOnly(_extends({
      pathname: location.pathname,
      search: '',
      hash: ''
    }, typeof to === 'string' ? parsePath(to) : to, {
      state: state,
      key: createKey()
    }));
  }

  function allowTx(action, location, retry) {
    return !blockers.length || (blockers.call({
      action: action,
      location: location,
      retry: retry
    }), false);
  }

  function applyTx(nextAction, nextLocation) {
    action = nextAction;
    location = nextLocation;
    listeners.call({
      action: action,
      location: location
    });
  }

  function push(to, state) {
    var nextAction = Action.Push;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      push(to, state);
    }

     false ? warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in memory history.push(" + JSON.stringify(to) + ")") : void 0;

    if (allowTx(nextAction, nextLocation, retry)) {
      index += 1;
      entries.splice(index, entries.length, nextLocation);
      applyTx(nextAction, nextLocation);
    }
  }

  function replace(to, state) {
    var nextAction = Action.Replace;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      replace(to, state);
    }

     false ? warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(to) + ")") : void 0;

    if (allowTx(nextAction, nextLocation, retry)) {
      entries[index] = nextLocation;
      applyTx(nextAction, nextLocation);
    }
  }

  function go(delta) {
    var nextIndex = clamp(index + delta, 0, entries.length - 1);
    var nextAction = Action.Pop;
    var nextLocation = entries[nextIndex];

    function retry() {
      go(delta);
    }

    if (allowTx(nextAction, nextLocation, retry)) {
      index = nextIndex;
      applyTx(nextAction, nextLocation);
    }
  }

  var history = {
    get index() {
      return index;
    },

    get action() {
      return action;
    },

    get location() {
      return location;
    },

    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    back: function back() {
      go(-1);
    },
    forward: function forward() {
      go(1);
    },
    listen: function listen(listener) {
      return listeners.push(listener);
    },
    block: function block(blocker) {
      return blockers.push(blocker);
    }
  };
  return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}

function promptBeforeUnload(event) {
  // Cancel the event.
  event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.

  event.returnValue = '';
}

function createEvents() {
  var handlers = [];
  return {
    get length() {
      return handlers.length;
    },

    push: function push(fn) {
      handlers.push(fn);
      return function () {
        handlers = handlers.filter(function (handler) {
          return handler !== fn;
        });
      };
    },
    call: function call(arg) {
      handlers.forEach(function (fn) {
        return fn && fn(arg);
      });
    }
  };
}

function createKey() {
  return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */

function createPath(_ref) {
  var _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === void 0 ? '/' : _ref$pathname,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? '' : _ref$search,
      _ref$hash = _ref.hash,
      hash = _ref$hash === void 0 ? '' : _ref$hash;
  if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
  if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
  return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */

function parsePath(path) {
  var parsedPath = {};

  if (path) {
    var hashIndex = path.indexOf('#');

    if (hashIndex >= 0) {
      parsedPath.hash = path.substr(hashIndex);
      path = path.substr(0, hashIndex);
    }

    var searchIndex = path.indexOf('?');

    if (searchIndex >= 0) {
      parsedPath.search = path.substr(searchIndex);
      path = path.substr(0, searchIndex);
    }

    if (path) {
      parsedPath.pathname = path;
    }
  }

  return parsedPath;
}


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./components/cards/index.scss
var cards = __webpack_require__("8YJ7");
var cards_default = /*#__PURE__*/__webpack_require__.n(cards);

// EXTERNAL MODULE: ./components/layout/subheader/subheader.scss
var subheader = __webpack_require__("VU8D");
var subheader_default = /*#__PURE__*/__webpack_require__.n(subheader);

// CONCATENATED MODULE: ./components/layout/subheader/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var subheader_SubHeader = function (_Component) {
    _inherits(SubHeader, _Component);

    function SubHeader() {
        _classCallCheck(this, SubHeader);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SubHeader.prototype.renderHeading = function renderHeading() {
        var _ref = this.props || {},
            heading = _ref.heading;

        if (!!heading) {
            return Object(preact_min["h"])(
                'h1',
                { className: 'fancy-heading' },
                Object(preact_min["h"])(
                    'span',
                    null,
                    heading
                )
            );
        }
    };

    SubHeader.prototype.renderSubHeading = function renderSubHeading() {
        var _ref2 = this.props || {},
            subheading = _ref2.subheading;

        if (!!subheading) {
            return Object(preact_min["h"])(
                'h3',
                { className: 'subheading' },
                subheading
            );
        }
    };

    SubHeader.prototype.render = function render() {
        return Object(preact_min["h"])(
            'div',
            { className: 'subheader-wrapper' },
            this.renderHeading(),
            this.renderSubHeading()
        );
    };

    return SubHeader;
}(preact_min["Component"]);

/* harmony default export */ var layout_subheader = (subheader_SubHeader);
// CONCATENATED MODULE: ./components/related/index.js
function related__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function related__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function related__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



__webpack_require__("N1qc");

/*
class Related extends Component {

	constructor(props) {
		super(props);
		this.state = {
			products: [],
			loading:false
		};
	}
	fetchRelatedProducts(related,products,loading){
        if (!!related && related.length && !products.length && !loading){
            this.setState({loading:true});
            Promise.all(related.sort(()=>{
                // random-ish-ize array
                return .5 - Math.random();
            }).filter((item,index)=>{
                // get first 4 items
                return index < 4;
            }).map(unique =>
                // fetch products
				fetch(`https://charlottefilshie.com/${unique}?json=true`).then(resp => {
					try {
						return resp.json();
					} catch (e) {
						return {};
					}
				})
            )).then(products => {
                this.setState({products, loading:false});
            }).catch(e => {
				this.setState({loading:false});
			});

        }
	}
    componentWillMount(props,state){
        console.log('componentWillMount', this.props, this.state);

        const {products, loading} = this.state;
        const {related} = this.props;
        console.log('componentWillUpdate', this.props);

		this.fetchRelatedProducts(related,products,loading);

	}
    componentDidMount(props){
        console.log('componentDidMount',props);
    }
	componentWillUpdate(props) {

        const {products, loading} = this.state;
        const {related} = props;

        this.fetchRelatedProducts(related,products,loading);
	}

	renderProducts(){
		const {products} = this.state;

		if(!products.length){
			return (<h3>There are no related products</h3>);
		}
		return products.map(product => {
            let prod = product.breadcrumbs[product.breadcrumbs.length-1];
            let inStock = product.stock === 'In Stock';
			return (
				<a className="related-product" href={prod.href || null} target="_blank">
                    <img src={product.thumb} />
					<span className={'related-product__title'}>{product.heading_title}</span>
					<span className={'related-product__price'}>{product.price}</span>

				</a>
			)
		})
	}


	render(){

		let {products, loading} = this.state;

		if (loading){
			return (<h3 className={'related-products__loading'}>Loading</h3>);
		}

		if(!products.length){
			return null;
		}

		return (
			<div className="related-products__wrapper">
                <SubHeader heading={'Related Products'} />
                <div className="related-products">
					{this.renderProducts()}
				</div>
			</div>
		);
	}
}
*/

var Related = function (_Component) {
	related__inherits(Related, _Component);

	function Related() {
		related__classCallCheck(this, Related);

		return related__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Related.prototype.render = function render() {
		return null;
	};

	return Related;
}(preact_min["Component"]);

/* harmony default export */ var components_related = (Related);
// CONCATENATED MODULE: ./components/cards/index.js


function cards__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cards__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function cards__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var cards__ref = Object(preact_min["h"])(
  'h1',
  null,
  'You Win!'
);

var cards__ref2 = Object(preact_min["h"])(
  'h1',
  null,
  'Loading'
);

var cards__ref4 = Object(preact_min["h"])(
  'h2',
  null,
  'Select Difficulty'
);

var cards_CardMatch = function (_Component) {
  cards__inherits(CardMatch, _Component);

  function CardMatch(props) {
    cards__classCallCheck(this, CardMatch);

    var _this = cards__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      difficulty: null,
      _cards: null,
      cards: null,
      remaining: null,
      duplicateCards: [],
      randomCards: [],
      matchedCards: [],
      flippedCards: [],
      related: []
    };
    return _this;
  }

  CardMatch.prototype.componentWillMount = function componentWillMount(props) {
    var _this2 = this;

    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
    if (this.props.matches && this.props.matches['activity-id']) {
      this.setState({ loading: true });
      fetch('/assets/cards/' + this.props.matches['activity-id'] + '.json').then(function (response) {
        return response.json();
      }).then(function (cardsJSON) {
        console.log('setting bundle');
        _this2.setState({
          _cards: cardsJSON.cards,
          remaining: cardsJSON.cards.length,
          toptext: cardsJSON.toptext,
          bottomtext: cardsJSON.bottomtext,
          heading: cardsJSON.heading,
          related: cardsJSON.related
        });
      }).catch(function (error) {
        _this2.setState({ error: "Bad Bundle" });
      });
    } else {
      this.setState({ error: "No Bundle" });
    }
  };

  CardMatch.prototype.componentDidMount = function componentDidMount() {};

  CardMatch.prototype.handleClick = function handleClick(name, index) {
    var _this3 = this;

    if (this.state.flippedCards.length == 2) {
      setTimeout(function () {
        _this3.check();
      }, 750);
    } else {
      var framework = {
        name: name,
        index: index
      };
      var matchedCards = this.state.matchedCards;
      var cards = this.state.flippedCards;
      matchedCards[index].close = false;
      cards.push(framework);
      this.setState({
        flippedCards: cards,
        matchedCards: matchedCards
      });
      if (this.state.flippedCards.length == 2) {
        setTimeout(function () {
          _this3.check();
        }, 750);
      }
    }
  };

  CardMatch.prototype.check = function check() {
    var matchedCards = this.state.matchedCards;
    if (this.state.flippedCards[0] && this.state.flippedCards[1]) {
      if (this.state.flippedCards[0].name == this.state.flippedCards[1].name && this.state.flippedCards[0].index != this.state.flippedCards[1].index) {
        matchedCards[this.state.flippedCards[0].index].complete = true;
        matchedCards[this.state.flippedCards[1].index].complete = true;
      } else {
        matchedCards[this.state.flippedCards[0].index].close = true;
        matchedCards[this.state.flippedCards[1].index].close = true;
      }
      this.setState({
        matchedCards: matchedCards,
        flippedCards: [],
        remaining: matchedCards.filter(function (c) {
          return !c.complete;
        }).length
      });
    }
  };

  CardMatch.prototype.start = function start() {
    if (!this.state.cards) {
      console.log('no cards');
      return false;
    }
    var matchedCards = [];
    this.state.duplicateCards = this.state.cards.concat(this.state.cards);
    this.state.randomCards = this.shuffle(this.state.duplicateCards);
    this.state.randomCards.map(function (name, index) {
      matchedCards.push({
        name: name,
        close: true,
        complete: false,
        fail: false
      });
    });
    this.state.matchedCards = matchedCards;
  };

  CardMatch.prototype.shuffle = function shuffle(array) {
    var currentIndex = array.length,
        temporaryValue = void 0,
        randomIndex = void 0;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  };

  CardMatch.prototype.setDifficulty = function setDifficulty(cardsNum) {
    if (cardsNum) {
      this.setState({
        'cards': this.state._cards.slice(0, cardsNum),
        'difficulty': cardsNum
      });
      this.start();
    } else {
      this.setState({
        'cards': null,
        'difficulty': 0,
        'remaining': true,
        'matchedCards': []
      });
    }
  };

  CardMatch.prototype.winningText = function winningText() {
    if (this.state.cards && !this.state.remaining) {
      return cards__ref;
    }
  };

  CardMatch.prototype.render = function render() {
    var _this4 = this;

    if (!this.state.cards && !this.state.remaining) {
      return cards__ref2;
    }

    var _ref3 = this.state || {},
        toptext = _ref3.toptext,
        bottomtext = _ref3.bottomtext,
        difficulty = _ref3.difficulty,
        heading = _ref3.heading,
        subheading = _ref3.subheading,
        related = _ref3.related;

    if (!difficulty) {
      return Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
          'div',
          { className: 'cards-game' },
          Object(preact_min["h"])(layout_subheader, { heading: heading, subheading: subheading }),
          Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: toptext } }),
          cards__ref4,
          Object(preact_min["h"])(
            'button',
            { className: 'button yellow', onClick: function onClick() {
                _this4.setDifficulty(4);
              } },
            'Easy'
          ),
          Object(preact_min["h"])(
            'button',
            { className: 'button orange', onClick: function onClick() {
                _this4.setDifficulty(6);
              } },
            'Medium'
          ),
          Object(preact_min["h"])(
            'button',
            { className: 'button pink', onClick: function onClick() {
                _this4.setDifficulty(10);
              } },
            'Hard'
          ),
          Object(preact_min["h"])(
            'button',
            { className: 'button purple', onClick: function onClick() {
                _this4.setDifficulty(14);
              } },
            'Very Hard'
          )
        ),
        Object(preact_min["h"])(components_related, { related: related })
      );
    }

    return Object(preact_min["h"])(
      'div',
      { className: 'cards-game' },
      Object(preact_min["h"])(layout_subheader, { heading: heading, subheading: subheading }),
      Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: toptext } }),
      this.winningText(),
      Object(preact_min["h"])(
        'button',
        { className: 'button green', onClick: function onClick() {
            _this4.setDifficulty(0);
          } },
        'Reset'
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'playground cards-' + this.state.cards.length * 2 },
        this.state.matchedCards.map(function (framework, index) {
          return Object(preact_min["h"])(cards_Card, { framework: framework.name, click: function click() {
              _this4.handleClick(framework.name, index);
            }, close: framework.close, complete: framework.complete });
        })
      ),
      Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: bottomtext } }),
      Object(preact_min["h"])(components_related, { related: related })
    );
  };

  return CardMatch;
}(preact_min["Component"]);

var _ref5 = Object(preact_min["h"])('div', { className: 'front' });

var cards_Card = function (_Component2) {
  cards__inherits(Card, _Component2);

  function Card(props) {
    cards__classCallCheck(this, Card);

    var _this5 = cards__possibleConstructorReturn(this, _Component2.call(this, props));

    _this5.state = {};
    return _this5;
  }

  Card.prototype.clicked = function clicked(framework) {
    this.props.click(framework);
  };

  Card.prototype.render = function render() {
    var _this6 = this;

    return Object(preact_min["h"])(
      'div',
      { className: "card" + (!this.props.close ? ' opened' : '') + (this.props.complete ? ' matched' : ''), onClick: function onClick() {
          return _this6.clicked(_this6.props.framework);
        } },
      _ref5,
      Object(preact_min["h"])('div', { className: 'back', style: { backgroundImage: 'url(/assets/cards/' + this.props.framework + '.png)' } })
    );
  };

  return Card;
}(preact_min["Component"]);

/* harmony default export */ var components_cards = (cards_CardMatch);
// EXTERNAL MODULE: ./components/spot/index.scss
var components_spot = __webpack_require__("m0iP");
var spot_default = /*#__PURE__*/__webpack_require__.n(components_spot);

// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__("sW0/");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./components/spot/index.js
var spot__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function spot__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function spot__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function spot__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var spot__ref = Object(preact_min["h"])(
  'h1',
  null,
  'You Win!'
);

var spot__ref2 = Object(preact_min["h"])('div', { className: 'winning hidden' });

var spot_Spot = function (_Component) {
  spot__inherits(Spot, _Component);

  function Spot() {
    var _temp, _this, _ret;

    spot__classCallCheck(this, Spot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = spot__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { error: false, spot: {}, zoom: false, found: [], hasWon: false }, _temp), spot__possibleConstructorReturn(_this, _ret);
  }

  Spot.prototype.componentWillMount = function componentWillMount(props) {
    var _this2 = this;

    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
    if (this.props.matches && this.props.matches['activity-id']) {
      var basepath = window.location.host.includes('localhost') ? '/' : '/';
      this.setState({ loading: true });
      fetch(basepath + 'assets/spot/' + this.props.matches['activity-id'] + '.json').then(function (response) {
        return response.json();
      }).then(function (spotJSON) {
        console.log('setting bundle');
        _this2.setState({ spot: spotJSON });
      }).catch(function (error) {
        _this2.setState({ error: 'Bad Bundle' });
      });
    } else {
      this.setState({ error: 'No Bundle' });
    }
  };

  Spot.prototype.setThumbs = function setThumbs() {};

  Spot.prototype.componentWillUpdate = function componentWillUpdate(props, state) {
    var _this3 = this;

    var is_cheating = false;
    var _state$spot = state.spot,
        imgsrc = _state$spot.imgsrc,
        data = _state$spot.data;


    if (!state.spot) {
      return;
    }

    var image = spot__extends({ image: null }, data);
    var clickRadius = 40;
    if (!!state.spot.data && !!state.spot.data.radius) {
      clickRadius = state.spot.data.radius;
    }
    this.canvas = document.getElementById('canvas_game');
    var canvas = this.canvas;
    var context = this.canvas.getContext('2d');
    var onClick = void 0;

    var draw = function draw(context, differences) {
      if (image != null && image.image) {
        context.drawImage(image.image, 0, 0, 1000, image.single ? 1000 : 1332);
        if (differences != null) {
          for (var i = 0; i < image.positions.length; i++) {
            if (differences[i]) {
              drawCircle(context, image.positions[i].x, image.positions[i].y);
              if (!image.single) {
                drawCircle(context, image.positions[i].x, image.positions[i].y - 1332 / 2);
              }
            }

            // xxx yyyy xxx
            if (!_this3.tempCanvas) {
              _this3.tempCanvas = document.createElement('canvas');
            }
            if (!_this3.thumbs) {
              _this3.thumbs = new Array(image.positions.length);
            }
            if (!_this3.thumbs[i]) {
              var newCanvas = _this3.tempCanvas;
              newCanvas.width = 60;
              newCanvas.height = 60;
              var newContext = newCanvas.getContext('2d');
              newContext.drawImage(_this3.canvas, image.positions[i].x - 30, image.positions[i].y - 30, 60, 60, 0, 0, 60, 60);
              var xurl = newCanvas.toDataURL();
              _this3.thumbs[i] = xurl;
            }
            // xxx yyyy xxx
          }
        }
      }
    };

    //Drawing of circle
    var drawCircle = function drawCircle(context, x, y) {
      context.beginPath();
      context.lineWidth = 3;
      context.strokeStyle = '#FF00ff';
      context.arc(x, y, clickRadius, 0, 2 * Math.PI);
      context.stroke();
    };

    //Function to load images into array
    var load = function load(context, callback) {
      var img = new Image();
      img.onload = function () {
        image.image = img;
        //Making sure images are loaded before continuing
        if (callback != null) {
          callback(context, img);
        }
      };
      var basepath = window.location.host.includes('localhost') ? '/' : '/';
      img.src = basepath + 'assets/spot/' + imgsrc;
    };

    //Distance between two points
    var getDistance = function getDistance(x1, y1, x2, y2) {
      var x = x1 - x2;
      var y = y1 - y2;
      return Math.sqrt(x * x + y * y);
    };

    //Main content
    //Befin game
    var play = function play(imageData) {
      if (!imageData.positions) return;
      var level = 0;
      var image = void 0;
      var loadLevel = function loadLevel() {
        image = null;
        if (!_this3.state.found.length) {
          _this3.setState({ found: new Array(imageData.positions.length) });
        }

        // let foundAll = this.state.found.filter(f => !!f).length >= imageData.positions.length;
        // if(foundAll){
        //     this.setState({hasWon: true});
        // }

        var foundArr = _this3.state.found;
        if (imageData.is_cheating) {
          foundArr = new Array(imageData.positions.length).fill(true);
        }

        load(context, function (context, img) {
          draw(context, foundArr);
        });
      };

      //Seeing if click is in circle radius

      var click = function click(x, y) {
        var image = imageData;
        if (image) {
          if (y < 1332 / 2 && !image.single) {
            y += 1332 / 2;
          }

          var shortestDistance = clickRadius;
          var index = null;
          for (var i = 0; i < image.positions.length; i++) {
            var position = image.positions[i];
            var distance = getDistance(x, y, position.x, position.y);
            if (distance <= shortestDistance) {
              shortestDistance = distance;
              index = i;
            }
          }
          if (index != null) {
            var found = spot__extends(_this3.state.found);
            found[index] = true;
            _this3.setState({ found: found });
            draw(context, _this3.state.found);
            try {
              //toastr.clear();
              //toastr["info"]("Have found: " + image.positions[index].message)
            } catch (e) {}
          }
          var finished = true;
          for (var i = 0; i < image.positions.length; i++) {
            if (!_this3.state.found[i]) {
              finished = false;
              break;
            }
          }
        }
      };
      _this3.onClick = click;
      loadLevel(level);
    };

    //Playing game!!!
    play(image);
  };

  Spot.prototype.canvasClick = function canvasClick(ev) {
    if (this.onClick) {
      var canvas = this.canvas;
      var client = this.canvas.getBoundingClientRect();
      var actualWidth = client.width;
      var actualHeight = client.height;
      var width = canvas.width;
      var height = canvas.height;
      var ax = ev.clientX - client.left;
      var ay = ev.clientY - client.top;
      var x = width * ax / actualWidth;
      var y = height * ay / actualHeight;
      this.onClick(x, y);
    }
  };

  Spot.prototype.playAgain = function playAgain() {
    // const {spot} = this.state;
    // if(!!spot.data && !!spot.data.positions){
    //     // let foundArray = new Array(spot.data.positions.length);
    //     // this.setState({found:foundArray});
    //     window.location.reload();
    // }
    window.location.reload();
  };

  Spot.prototype.backGames = function backGames() {
    Object(preact_router_es["route"])('/', true);
  };

  Spot.prototype.renderWinnings = function renderWinnings(hasWon) {
    var _this4 = this;

    if (hasWon) {
      return Object(preact_min["h"])(
        'div',
        { className: 'winning' },
        Object(preact_min["h"])(
          'div',
          { className: 'winning__inner' },
          spot__ref,
          Object(preact_min["h"])(
            'button',
            { className: 'button green', onClick: function onClick() {
                return _this4.playAgain();
              } },
            'Play Again'
          ),
          Object(preact_min["h"])(
            'button',
            { className: 'button blue', onClick: function onClick() {
                return _this4.backGames();
              } },
            'Back to Games'
          )
        )
      );
    }
    return spot__ref2;
  };

  Spot.prototype.render = function render() {
    var _this5 = this;

    if (this.state.error) {
      return Object(preact_min["h"])(
        'h1',
        null,
        'Error ',
        this.state.error
      );
    }

    var _ref3 = this.state.spot || {},
        subheading = _ref3.subheading,
        toptext = _ref3.toptext,
        bottomtext = _ref3.bottomtext;

    var templist = Array.from({ length: 20 }, function (v, k) {
      return k + 1;
    });

    var _state = this.state,
        spot = _state.spot,
        found = _state.found;

    var matchList = [];
    var canvasHeight = 1332;
    var scoreClassName = 'score__list';
    var isSingle = false;
    var showThumbs = false;

    if (spot.data) {
      if (spot.data.positions) {
        matchList = spot.data.positions.map(function (s, i) {
          return {
            message: s.message,
            thumb: s.thumb || false,
            found: !!found[i]
          };
        });
      }
      if (spot.data.single) {
        canvasHeight = 1000;
      }
      if (spot.data.single) {
        scoreClassName = 'score__list score__list__single';
        isSingle = true;
      }
      if (spot.data.show_thumbs) {
        showThumbs = true;
      }
    }
    // {!!foundAll && (<div><h1>You Won</h1></div>)}
    var matchesNum = matchList.filter(function (ml) {
      return ml.found;
    }).length;
    var basepath = window.location.host.includes('localhost') ? '/' : '/';
    return Object(preact_min["h"])(
      'div',
      { className: 'spot-game' },
      Object(preact_min["h"])(layout_subheader, { heading: spot.heading, subheading: spot.subheading }),
      Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: toptext } }),
      Object(preact_min["h"])(
        'div',
        { className: 'spot-game__wrapper' },
        Object(preact_min["h"])(
          'div',
          { className: 'spot-game__canvas' },
          this.renderWinnings(matchList.length && matchesNum >= matchList.length),
          Object(preact_min["h"])('canvas', { id: 'canvas_game', width: '1000', height: canvasHeight, onClick: function onClick(ev) {
              _this5.canvasClick(ev);
            } })
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'spot-game__score' },
          Object(preact_min["h"])(
            'h3',
            { className: 'score__heading' },
            'Found ',
            matchesNum,
            '/',
            matchList.length
          ),
          Object(preact_min["h"])(
            'ul',
            { className: scoreClassName },
            matchList.map(function (ml, i) {
              var scoreStyle = {};
              if (ml.thumb) {
                scoreStyle.backgroundImage = 'url(' + basepath + 'assets/spot/' + _this5.props.matches['activity-id'] + '/' + ml.thumb + ')';
                scoreStyle.backgroundSize = '100%';
              } else if (ml.found && _this5.thumbs && !!_this5.thumbs[i]) {
                scoreStyle.backgroundImage = 'url(' + _this5.thumbs[i] + ')';
              }
              var msg = isSingle ? ml.message : ml.found ? ml.message : 'Not Found Yet';
              var imgNum = isSingle ? '' : ml.found ? '' : i + 1;
              return Object(preact_min["h"])(
                'li',
                { className: ml.found ? 'active' : 'inactive' },
                Object(preact_min["h"])(
                  'div',
                  { className: 'score__image', style: scoreStyle },
                  imgNum
                ),
                Object(preact_min["h"])(
                  'span',
                  { className: 'score__text ' },
                  msg
                )
              );
            })
          )
        )
      ),
      Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: bottomtext } }),
      Object(preact_min["h"])(components_related, { related: spot.related })
    );
  };

  return Spot;
}(preact_min["Component"]);

/* harmony default export */ var components_spot_0 = (spot_Spot);
// CONCATENATED MODULE: ./components/boardgame/index.js
var boardgame__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function boardgame__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function boardgame__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function boardgame__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__("0mEO");


//import Fullscreen from "../helper/fullscreen";

var elem = {
    x: 0,
    y: 900,
    width: 100,
    height: 100,
    name: 'player 1',
    fill: '#BADA55',
    pos: 1
};
var elem2 = {
    x: 0,
    y: 900,
    name: 'player 2',
    width: 100,
    height: 100,
    fill: '#BADA55',
    pos: 1
};

var BASE_PATH = ''; //'/dinosaurs-doing-stuff'

var Fullscreen = function Fullscreen(f) {
    return f;
};

var boardgame__ref5 = Object(preact_min["h"])(
    'h1',
    null,
    'Loading'
);

var _ref6 = Object(preact_min["h"])(
    'div',
    { className: 'game__wrapper' },
    Object(preact_min["h"])(
        'div',
        { className: 'game__canvas' },
        Object(preact_min["h"])('canvas', { id: 'canvas_game', width: '1000', height: '1000' })
    )
);

var boardgame_BoardGame = function (_Component) {
    boardgame__inherits(BoardGame, _Component);

    function BoardGame() {
        var _temp, _this, _ret;

        boardgame__classCallCheck(this, BoardGame);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = boardgame__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { error: false, hasWon: false, loading: false, players: [], isFull: false }, _this.goFull = function () {
            _this.setState({ isFull: true });
        }, _this.requestAnimFrame = function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
        }, _temp), boardgame__possibleConstructorReturn(_this, _ret);
    }

    BoardGame.prototype.loadImages = function loadImages() {
        var _this2 = this;

        var _ref = this.state.game.data || {},
            images = _ref.images;

        if (!images) return;

        images.forEach(function (img) {
            img.img = new Image();
            img.img.onload = function () {
                img.loaded = true;
                console.log(img.img, 'loaded');
                var newState = { game: boardgame__extends(_this2.state.game, { data: { images: images } }) };
                _this2.setState({
                    newState: newState
                });
                var loadingImages = images.filter(function (i) {
                    return !i.loaded;
                }).length > 0;
                _this2.setState({ loading: loadingImages });
            };
            img.img.src = BASE_PATH + '/assets/boardgame/' + img.src;
        });
    };

    BoardGame.prototype.imageByName = function imageByName(name) {
        var _ref2 = this.state.game.data || {},
            images = _ref2.images;

        return images.find(function (i) {
            return i.name === name;
        });
    };

    BoardGame.prototype.componentWillUpdate = function componentWillUpdate(props, state) {
        console.log('componentWillUpdate', state);
        var data = state.game.data;

        var loadingImages = data.images.filter(function (i) {
            return !i.loaded;
        }).length;

        if (!state.game || state.loading) {
            return;
        }
        if (document.getElementById("canvas_game") && !this.ctx) {
            this.ctx = document.getElementById("canvas_game").getContext("2d");
            console.log('yes canvas');
        } else {
            console.log('no canvas');
        }
        if (!loadingImages && this.ctx) {
            this.animloop();
        };
    };

    BoardGame.prototype.animate = function animate() {
        var players = this.state.players.players;

        if (this.ctx) {
            console.log('anim');
            this.ctx.clearRect(0, 0, 1000, 1000);
            this.ctx.drawImage(this.imageByName('bg').img, 0, 0, 1200, 1200, 0, 0, 1000, 1000);
            this.ctx.drawImage(this.imageByName('foreground').img, 0, 0, 1200, 1200, 0, 0, 1000, 1000);
            //ctx.fillRect( elem.x, elem.y, elem.width, elem.height );
            this.ctx.drawImage(this.imageByName('pirate').img, 0, 0, 120, 120, elem.x + 10, elem.y + 10, 80, 80);
            this.ctx.drawImage(this.imageByName('hero').img, 0, 0, 120, 120, elem2.x + 10, elem2.y + 10, 80, 80);
        }
    };

    BoardGame.prototype.animloop = function animloop() {
        console.log('animloop');
        this.requestAnimFrame(this.animloop);
        this.animate();
    };

    BoardGame.prototype.componentWillMount = function componentWillMount(props) {
        var _this3 = this;

        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
        if (this.props.matches && this.props.matches['activity-id']) {
            this.setState({ loading: true });
            fetch(BASE_PATH + '/assets/boardgame/' + this.props.matches['activity-id'] + '.json').then(function (response) {
                return response.json();
            }).then(function (gameJSON) {
                _this3.setState({ game: gameJSON, loading: 'Loading Images' });
                _this3.loadImages();
            }).catch(function (error) {
                _this3.setState({ error: "Bad Bundle" });
            });
        } else {
            this.setState({ error: "No Bundle" });
        }
    };

    BoardGame.prototype.render = function render() {
        var _this4 = this;

        var _ref3 = this.state.game || {},
            data = _ref3.data;

        var _ref4 = this.state.spot || {},
            toptext = _ref4.toptext,
            bottomtext = _ref4.bottomtext;

        return Object(preact_min["h"])(
            'div',
            { className: 'board-game' },
            this.state.error && Object(preact_min["h"])(
                'h1',
                null,
                'Error ',
                this.state.error
            ),
            this.state.loading && boardgame__ref5,
            Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: toptext } }),
            Object(preact_min["h"])(
                Fullscreen,
                {
                    enabled: this.state.isFull,
                    onChange: function onChange(isFull) {
                        return _this4.setState({ isFull: isFull });
                    }
                },
                _ref6
            ),
            Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: bottomtext } })
        );
    };

    return BoardGame;
}(preact_min["Component"]);

/* harmony default export */ var boardgame = (boardgame_BoardGame);
// EXTERNAL MODULE: ./components/layout/index.scss
var layout = __webpack_require__("NZpJ");
var layout_default = /*#__PURE__*/__webpack_require__.n(layout);

// EXTERNAL MODULE: ./node_modules/react-ga/dist/react-ga.js
var react_ga = __webpack_require__("kEtg");
var react_ga_default = /*#__PURE__*/__webpack_require__.n(react_ga);

// CONCATENATED MODULE: ./components/layout/index.js


function layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function layout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





react_ga_default.a.initialize('UA-121213692-1');

var layout__ref = Object(preact_min["h"])(
    'ul',
    { className: 'layout__nav' },
    Object(preact_min["h"])(
        'li',
        null,
        Object(preact_min["h"])(
            match["Link"],
            { href: '/' },
            '< Back to games'
        )
    )
);

var layout__ref2 = Object(preact_min["h"])(
    'div',
    { className: 'footer' },
    Object(preact_min["h"])(
        'small',
        null,
        'All Images \xA9 Dinosaurs Doing Stuff 2022',
        Object(preact_min["h"])('br', null),
        'No reproduction without express permission'
    )
);

var layout_Layout = function (_Component) {
    layout__inherits(Layout, _Component);

    function Layout() {
        layout__classCallCheck(this, Layout);

        return layout__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Layout.prototype.render = function render(props, state) {
        var isHome = props.isHome;
        if (typeof window !== "undefined") {
            react_ga_default.a.pageview(window.location.pathname + window.location.search);
        }
        return Object(preact_min["h"])(
            'div',
            { className: 'wrapper' },
            !isHome && layout__ref,
            Object(preact_min["h"])(
                'div',
                { className: 'layout__content' },
                props.children
            ),
            layout__ref2
        );
    };

    return Layout;
}(preact_min["Component"]);

/* harmony default export */ var components_layout = (layout_Layout);
// EXTERNAL MODULE: ./components/downloads/index.scss
var components_downloads = __webpack_require__("6nU4");
var downloads_default = /*#__PURE__*/__webpack_require__.n(components_downloads);

// CONCATENATED MODULE: ./components/downloads/index.js


function downloads__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function downloads__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function downloads__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var downloads__ref = Object(preact_min["h"])(
	'h1',
	null,
	'Loading Downloads'
);

var downloads__ref3 = Object(preact_min["h"])('br', null);

var downloads__ref4 = Object(preact_min["h"])(
	'a',
	{ href: 'http://instagram.com/charlottefilshie', target: '_blank' },
	'@charlottefilshie'
);

var downloads__ref5 = Object(preact_min["h"])(
	'em',
	null,
	Object(preact_min["h"])(
		'a',
		{ href: 'https://www.instagram.com/explore/tags/dinosaursdoingstuff/' },
		'#dinosaursdoingstuff'
	)
);

var downloads_Downloads = function (_Component) {
	downloads__inherits(Downloads, _Component);

	function Downloads(props) {
		downloads__classCallCheck(this, Downloads);

		var _this = downloads__possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			downloads: false
		};
		return _this;
	}

	Downloads.prototype.componentWillMount = function componentWillMount(props) {
		var _this2 = this;

		if (typeof window !== 'undefined') {
			window.scrollTo(0, 0);
		}
		this.setState({ loading: true });
		var basepath = window.location.host.includes('localhost') ? '/' : '/';
		fetch(basepath + 'assets/downloads/downloads.json').then(function (response) {
			return response.json();
		}).then(function (downloadsJSON) {

			_this2.setState({
				downloads: downloadsJSON,
				loading: false
			});
		}).catch(function (error) {
			_this2.setState({ downloads: false });
		});
	};

	Downloads.prototype.componentDidMount = function componentDidMount() {};

	Downloads.prototype.render = function render() {
		if (!this.state.downloads) {
			return downloads__ref;
		}

		var _ref2 = this.state || {},
		    downloads = _ref2.downloads;

		var basepath = window.location.host.includes('localhost') ? '/' : '/';
		return Object(preact_min["h"])(
			'div',
			null,
			Object(preact_min["h"])(
				'p',
				{ style: { textAlign: 'center' } },
				'Just click on the colouring sheet to download the PDF then print and colour!',
				downloads__ref3,
				'Share your coloured sheets on Instagram ',
				downloads__ref4,
				' ',
				downloads__ref5
			),
			downloads.items && downloads.items.map(function (e) {
				var activityribbon = e.ribbon ? Object(preact_min["h"])(
					'div',
					{ 'class': 'ribbon' },
					Object(preact_min["h"])(
						'em',
						{ 'class': 'ribbon--inner' },
						e.ribbon
					)
				) : null;
				return Object(preact_min["h"])(
					'a',
					{ className: 'layout__activity', target: '_blank', download: e.file, href: basepath + 'assets/downloads/' + e.file },
					activityribbon,
					Object(preact_min["h"])('img', { src: basepath + e.thumb }),
					Object(preact_min["h"])(
						'span',
						null,
						e.subtitle
					),
					Object(preact_min["h"])(
						'h4',
						null,
						e.title
					)
				);
			}),
			Object(preact_min["h"])(
				'p',
				{ style: { textAlign: 'center', width: '100%', float: 'left', clear: 'both' } },
				'Not for distribution or re-sale, if you would like to share, please credit me in full.'
			)
		);
	};

	return Downloads;
}(preact_min["Component"]);

/* harmony default export */ var components_downloads_0 = (downloads_Downloads);
// EXTERNAL MODULE: ./components/puzzle/index.scss
var puzzle = __webpack_require__("SfWW");
var puzzle_default = /*#__PURE__*/__webpack_require__.n(puzzle);

// EXTERNAL MODULE: ./node_modules/react-puzzle/dist/react-puzzle.js
var react_puzzle = __webpack_require__("pr2F");
var react_puzzle_default = /*#__PURE__*/__webpack_require__.n(react_puzzle);

// CONCATENATED MODULE: ./components/puzzle/index.js


function puzzle__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function puzzle__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function puzzle__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var puzzle_SlidePuzzle = function (_Component) {
	puzzle__inherits(SlidePuzzle, _Component);

	function SlidePuzzle(props) {
		puzzle__classCallCheck(this, SlidePuzzle);

		var _this = puzzle__possibleConstructorReturn(this, _Component.call(this, props));

		_this.ref = null;

		_this.setRef = function (dom) {
			return _this.ref = dom;
		};

		_this.state = {
			started: false,
			moves: 0,
			solved: false
		};
		return _this;
	}

	SlidePuzzle.prototype.componentWillMount = function componentWillMount(props) {};

	SlidePuzzle.prototype.componentDidMount = function componentDidMount() {};

	SlidePuzzle.prototype.render = function render() {
		var _this2 = this;

		var basepath = window.location.host.includes('localhost') ? '/' : '/';
		return Object(preact_min["h"])(
			'div',
			null,
			this.props.matches['activity-id'],
			Object(preact_min["h"])(react_puzzle["SlidingPuzzle"], { ref: this.setRef, src: 'https://scontent-lhr8-1.cdninstagram.com/v/t51.2885-15/sh0.08/e35/s640x640/55906307_2260339794189784_8427209178500981818_n.jpg?_nc_ht=scontent-lhr8-1.cdninstagram.com&_nc_cat=104&_nc_ohc=MUmrdqma0vUAX_cb7dO&oh=fa7d4b4fd2b8abf1cddb43911aea3ed5&oe=5ECCA66A', rows: 3, cols: 3,
				onMove: function onMove() {
					_this2.setState({ moves: _this2.state.moves + 1 });
				},
				onSolve: function onSolve() {
					_this2.setState({ solved: true });
				}
			}),
			Object(preact_min["h"])(
				'p',
				{ style: { textAlign: 'center', width: '100%', float: 'left', clear: 'both' } },
				Object(preact_min["h"])(
					'button',
					{ className: 'button green', onClick: function onClick() {
							_this2.ref.shuffle();
							_this2.setState({ started: true, moves: 0, solved: false });
						} },
					this.state.started ? 'Restart' : 'Start'
				)
			),
			Object(preact_min["h"])(
				'p',
				{ style: { textAlign: 'center', width: '100%', float: 'left', clear: 'both' } },
				this.state.solved ? 'Solved in ' : '',
				this.state.moves,
				' moves'
			),
			Object(preact_min["h"])(
				'p',
				{ style: { textAlign: 'center', width: '100%', float: 'left', clear: 'both' } },
				'Click "Start" to start, then click a piece to move it to the empty space. The aim is to slide the pieces top get the puzzle back together'
			)
		);
	};

	return SlidePuzzle;
}(preact_min["Component"]);

/* harmony default export */ var components_puzzle = (puzzle_SlidePuzzle);
// EXTERNAL MODULE: ./node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("m8+U");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./node_modules/preact-transition-group/dist/preact-transition-group.js
var preact_transition_group = __webpack_require__("FY7a");
var preact_transition_group_default = /*#__PURE__*/__webpack_require__.n(preact_transition_group);

// CONCATENATED MODULE: ./node_modules/liquid-route/Components/LiquidRoute/LiquidAnimator.jsx
var LiquidAnimator__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function LiquidAnimator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LiquidAnimator__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LiquidAnimator__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var defaultOpts = {
  duration: 300,
  fill: 'forwards',
  easing: 'ease-out'
};

var LiquidAnimator_LiquidAnimator = function (_Component) {
  LiquidAnimator__inherits(LiquidAnimator, _Component);

  function LiquidAnimator() {
    LiquidAnimator__classCallCheck(this, LiquidAnimator);

    return LiquidAnimator__possibleConstructorReturn(this, _Component.call(this));
  }

  LiquidAnimator.prototype.componentWillEnter = function componentWillEnter(cb) {
    this.props.onSetCurrentAnimation && this.props.onSetCurrentAnimation();
    var animation = this.props.getEntryAnimation();
    if (!this.container.animate || !animation) {
      return cb();
    }
    var animationOptions = LiquidAnimator__extends({}, defaultOpts, animation.options);
    this.container.animate(animation.animation, animationOptions).onfinish = function () {
      cb();
    };
  };

  LiquidAnimator.prototype.componentWillLeave = function componentWillLeave(cb) {
    var _this2 = this;

    var animation = this.props.getExitAnimation();
    if (!this.container.animate || !animation) {
      return cb();
    }
    var animationOptions = LiquidAnimator__extends({}, defaultOpts, animation.options);
    this.container.animate(animation.animation, animationOptions).onfinish = function () {
      var reversedAnimation = animation.animation.reverse();
      _this2.container.animate(reversedAnimation, {
        duration: 1,
        fill: 'forwards'
      });
      cb();
    };
  };

  LiquidAnimator.prototype.render = function render() {
    var _this3 = this;

    return Object(preact_min["h"])(
      'div',
      { className: 'liquid-container' },
      Object(preact_min["h"])(
        'div',
        {
          className: 'liquid-pageholder',
          ref: function ref(container) {
            _this3.container = container;
          }
        },
        this.props.children
      )
    );
  };

  return LiquidAnimator;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./node_modules/preact-async-route/dist/index.js
var dist = __webpack_require__("dOKB");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/liquid-route/Components/LiquidRoute/LiquidRoute.jsx
var LiquidRoute__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function LiquidRoute__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LiquidRoute__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LiquidRoute__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var currentAnimation = null;

var LiquidRoute_LiquidRoute = function (_Component) {
  LiquidRoute__inherits(LiquidRoute, _Component);

  function LiquidRoute() {
    LiquidRoute__classCallCheck(this, LiquidRoute);

    return LiquidRoute__possibleConstructorReturn(this, _Component.call(this));
  }

  LiquidRoute.prototype.getEntryAnimation = function getEntryAnimation() {
    return currentAnimation && currentAnimation.getEntryAnimation() || null;
  };

  LiquidRoute.prototype.getExitAnimation = function getExitAnimation() {
    return currentAnimation && currentAnimation.getExitAnimation() || null;
  };

  LiquidRoute.prototype.setCurrentAnimation = function setCurrentAnimation() {
    currentAnimation = this.props.animator;
  };

  LiquidRoute.prototype.render = function render(props) {
    var _this2 = this;

    return Object(preact_min["h"])(
      preact_transition_group_default.a,
      null,
      Object(preact_min["h"])(
        LiquidAnimator_LiquidAnimator,
        LiquidRoute__extends({
          getEntryAnimation: function getEntryAnimation() {
            return _this2.getEntryAnimation();
          },
          getExitAnimation: function getExitAnimation() {
            return _this2.getExitAnimation();
          },
          key: props.url,
          onSetCurrentAnimation: function onSetCurrentAnimation() {
            _this2.setCurrentAnimation();
          }
        }, props),
        Object(preact_min["h"])(dist_default.a, props)
      )
    );
  };

  return LiquidRoute;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./node_modules/liquid-route/Components/AnimationDefinations/fade.js
var faderAnimationStart = {
	opacity: 0
};

var faderAnimationEnd = {
	opacity: 1
};

/* harmony default export */ var fade = ({
	getEntryAnimation: function getEntryAnimation() {
		return {
			animation: [faderAnimationStart, faderAnimationEnd]
		};
	},
	getExitAnimation: function getExitAnimation() {
		return {
			animation: [faderAnimationEnd, faderAnimationStart]
		};
	}
});
// CONCATENATED MODULE: ./node_modules/liquid-route/Components/AnimationDefinations/pop.js
var poperAnimationStart = {
	transform: 'scale(0.5)',
	opacity: 0
};

var poperAnimationEnd = {
	transform: 'scale(1)',
	opacity: 1
};

/* harmony default export */ var pop = ({
	getEntryAnimation: function getEntryAnimation() {
		return {
			animation: [poperAnimationStart, poperAnimationEnd]
		};
	},
	getExitAnimation: function getExitAnimation() {
		return {
			animation: [poperAnimationEnd, poperAnimationStart]
		};
	}
});
// CONCATENATED MODULE: ./node_modules/liquid-route/Components/AnimationDefinations/slideLeft.js
var slideLeftEntryAnimationStart = {
	transform: 'translateX(100%)',
	opacity: 0
};

var slideLeftEntryAnimationEnd = {
	transform: 'translateX(0%)',
	opacity: 1
};

var slideLeftExitAnimationStart = {
	transform: 'translateX(0%)',
	opacity: 1
};

var slideLeftExitAnimationEnd = {
	transform: 'translateX(-100%)',
	opacity: 0
};

/* harmony default export */ var slideLeft = ({
	getEntryAnimation: function getEntryAnimation() {
		return {
			animation: [slideLeftEntryAnimationStart, slideLeftEntryAnimationEnd]
		};
	},
	getExitAnimation: function getExitAnimation() {
		return {
			animation: [slideLeftExitAnimationStart, slideLeftExitAnimationEnd]
		};
	}

});
// CONCATENATED MODULE: ./node_modules/liquid-route/Components/AnimationDefinations/appearFromRight.js
var appearFromRight_slideLeftEntryAnimationStart = {
	transform: 'translateX(40%)',
	opacity: 0
};

var appearFromRight_slideLeftEntryAnimationEnd = {
	transform: 'translateX(0%)',
	opacity: 1
};

var appearFromRight_slideLeftExitAnimationStart = {
	opacity: 1
};

var appearFromRight_slideLeftExitAnimationEnd = {
	opacity: 0
};

/* harmony default export */ var appearFromRight = ({
	getEntryAnimation: function getEntryAnimation() {
		return {
			animation: [appearFromRight_slideLeftEntryAnimationStart, appearFromRight_slideLeftEntryAnimationEnd]
		};
	},
	getExitAnimation: function getExitAnimation() {
		return {
			animation: [appearFromRight_slideLeftExitAnimationStart, appearFromRight_slideLeftExitAnimationEnd]
		};
	}

});
// CONCATENATED MODULE: ./node_modules/liquid-route/Components/AnimationDefinations/appearFromBottom.js
var appearFromBottom_slideLeftEntryAnimationStart = {
	transform: 'translateY(40%)',
	opacity: 0
};

var appearFromBottom_slideLeftEntryAnimationEnd = {
	transform: 'translateY(0%)',
	opacity: 1
};

var appearFromBottom_slideLeftExitAnimationStart = {
	opacity: 1
};

var appearFromBottom_slideLeftExitAnimationEnd = {
	opacity: 0.8
};

/* harmony default export */ var appearFromBottom = ({
	getEntryAnimation: function getEntryAnimation() {
		return {
			animation: [appearFromBottom_slideLeftEntryAnimationStart, appearFromBottom_slideLeftEntryAnimationEnd]
		};
	},
	getExitAnimation: function getExitAnimation() {
		return {
			animation: [appearFromBottom_slideLeftExitAnimationStart, appearFromBottom_slideLeftExitAnimationEnd]
		};
	}

});
// CONCATENATED MODULE: ./node_modules/liquid-route/Components/AnimationDefinations/pushAndSlide.js
var pushAndSlide_slideLeftExitAnimationStart = {
	transform: 'scale(1) translateX(0%)'
};

var slideLeftExitAnimationPush = {
	transform: 'scale(0.5) translateX(0%)'
};

var pushAndSlide_slideLeftExitAnimationEnd = {
	transform: 'scale(0.5) translateX(-200%)'
};

var slideLeftExitAnimationPlacebo = {
	transform: 'scale(0.5) translateX(200%)'
};

var pushAndSlide_slideLeftEntryAnimationStart = {
	transform: 'scale(0.5) translateX(200%)',
	offset: 0.6
};

var slideLeftEntryAnimationZoom = {
	transform: 'scale(0.5) translateX(0%)'
};

var pushAndSlide_slideLeftEntryAnimationEnd = {
	transform: 'scale(1) translateX(0%)'
};

/* harmony default export */ var pushAndSlide = ({
	getEntryAnimation: function getEntryAnimation() {
		return {
			animation: [slideLeftExitAnimationPlacebo, pushAndSlide_slideLeftEntryAnimationStart, slideLeftEntryAnimationZoom, pushAndSlide_slideLeftEntryAnimationEnd],
			options: {
				duration: 1400
			}
		};
	},
	getExitAnimation: function getExitAnimation() {
		return {
			animation: [pushAndSlide_slideLeftExitAnimationStart, slideLeftExitAnimationPush, pushAndSlide_slideLeftExitAnimationEnd],
			options: {
				duration: 900
			}
		};
	}

});
// CONCATENATED MODULE: ./node_modules/liquid-route/index.js








/* harmony default export */ var liquid_route = (LiquidRoute_LiquidRoute);

// EXTERNAL MODULE: ./node_modules/liquid-route/style.css
var style = __webpack_require__("TSt5");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./index.js


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var activities = [{
    title: 'Hidden Object',
    unique: 'hidden-object',
    thumb: '/thumbs/seek-find-thumb.png',
    type: 'spot',
    label: 'Seek and Find'
}, {
    title: 'Memory Game',
    unique: 'match-pairs-classic',
    thumb: '/thumbs/match-pairs-thumb.png',
    type: 'match',
    ribbon: "Multiple Difficulties",
    ribbonColor: "pink"
}, {
    title: 'River',
    unique: 'river',
    thumb: '/thumbs/river-thumb.png',
    type: 'spot'
}, {
    title: 'Pirate Beach',
    unique: 'pirate',
    thumb: '/thumbs/pirate-thumb.png',
    type: 'spot'
}, {
    title: 'Suchomimus',
    unique: 'suchomimus',
    thumb: '/thumbs/suchomimus-thumb.png',
    type: 'spot',
    ribbon: "Easy",
    ribbonColor: "yellow"
}, {
    title: 'Gryposaurus',
    unique: 'gryposaurus',
    thumb: '/thumbs/gryposaurus-thumb.png',
    type: 'spot',
    ribbon: "Easy",
    ribbonColor: "yellow"
}, {
    title: 'Edmontonia',
    unique: 'edmontonia',
    thumb: '/thumbs/edmontonia-thumb.png',
    type: 'spot',
    ribbon: "Easy",
    ribbonColor: "yellow"
}, {
    title: 'Halloween',
    unique: 'halloween',
    thumb: '/thumbs/halloween.png',
    type: 'spot'
}];
var onRouteChange = function onRouteChange() {
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
    }
};

var index__ref2 = Object(preact_min["h"])(
    components_layout,
    { 'default': true },
    Object(preact_min["h"])(
        preact_router_es["default"],
        null,
        Object(preact_min["h"])(components_cards, { path: '/activity/match/:activity-id' }),
        Object(preact_min["h"])(components_spot_0, { path: '/activity/spot/:activity-id' }),
        Object(preact_min["h"])(boardgame, { path: '/activity/boardgame/:activity-id' }),
        Object(preact_min["h"])(components_puzzle, { path: '/activity/slidepuzzle/:activity-id' })
    )
);

var index_Main = function Main() {
    return Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(Helmet_default.a, {
            htmlAttributes: { lang: "en", amp: undefined } // amp takes no value
            , title: 'Dinosaurs Doing Stuff',
            meta: [{ name: "description", content: "Dinosaur Activities" }, { property: "og:type", content: "article" }],
            link: [{ rel: "apple-touch-icon", sizes: "57x57", href: "/assets/icon/apple-icon-57x57.png" }, { rel: "apple-touch-icon", sizes: "60x60", href: "/assets/icon/apple-icon-60x60.png" }, { rel: "apple-touch-icon", sizes: "72x72", href: "/assets/icon/apple-icon-72x72.png" }, { rel: "apple-touch-icon", sizes: "76x76", href: "/assets/icon/apple-icon-76x76.png" }, { rel: "apple-touch-icon", sizes: "114x114", href: "/assets/icon/apple-icon-114x114.png" }, { rel: "apple-touch-icon", sizes: "120x120", href: "/assets/icon/apple-icon-120x120.png" }, { rel: "apple-touch-icon", sizes: "144x144", href: "/assets/icon/apple-icon-144x144.png" }, { rel: "apple-touch-icon", sizes: "152x152", href: "/assets/icon/apple-icon-152x152.png" }, { rel: "apple-touch-icon", sizes: "180x180", href: "/assets/icon/apple-icon-180x180.png" }, { rel: "icon", type: "image/png", sizes: "192x192", href: "/assets/icon//android-icon-192x192.png" }, { rel: "icon", type: "image/png", sizes: "32x32", href: "/assets/icon/favicon-32x32.png" }, { rel: "icon", type: "image/png", sizes: "96x96", href: "/assets/icon/favicon-96x96.png" }, { rel: "icon", type: "image/png", sizes: "16x16", href: "/assets/icon/favicon-16x16.png" }]
        }),
        Object(preact_min["h"])(
            preact_router_es["default"],
            { history: createHashHistory(), onChange: onRouteChange() },
            index__ref,
            index__ref2
        )
    );
};

var index_App = function (_Component) {
    index__inherits(App, _Component);

    function App() {
        index__classCallCheck(this, App);

        return index__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    App.prototype.renderActivitycard = function renderActivitycard(activity) {
        var cardType = '';
        switch (activity.type) {
            case 'spot':
                cardType = 'Spot The Difference';
                break;
            case 'match':
                cardType = 'Match The Cards';
                break;
            case 'boardgame':
                cardType = 'Board Game';
                break;
        }
        cardType = activity.label || cardType;
        if (!!activity.coming_soon) cardType = 'Coming Soon';
        var activityribbonClass = "ribbon " + (activity.ribbonColor ? activity.ribbonColor : '');
        var activityribbon = activity.ribbon ? Object(preact_min["h"])(
            'div',
            { 'class': activityribbonClass },
            Object(preact_min["h"])(
                'em',
                { 'class': 'ribbon--inner' },
                activity.ribbon
            )
        ) : null;
        return Object(preact_min["h"])(
            match["Link"],
            { className: 'layout__activity' + (!!activity.coming_soon ? ' activity--soon' : ''), href: !activity.coming_soon ? '/activity/' + activity.type + '/' + activity.unique : '#' },
            activityribbon,
            Object(preact_min["h"])('img', { src: '/assets' + activity.thumb }),
            Object(preact_min["h"])(
                'span',
                null,
                cardType
            ),
            Object(preact_min["h"])(
                'h4',
                null,
                activity.title
            )
        );
    };

    App.prototype.render = function render() {
        var _this2 = this;

        return Object(preact_min["h"])(
            'div',
            { className: 'layout__activities' },
            activities.map(function (a) {
                return _this2.renderActivitycard(a);
            })
        );
    };

    return App;
}(preact_min["Component"]);

// render(<Main />, document.body);


var index__ref = Object(preact_min["h"])(
    components_layout,
    { path: '', isHome: 'true' },
    Object(preact_min["h"])(index_App, null)
);

/* harmony default export */ var index_0 = __webpack_exports__["default"] = (index_Main);

/***/ }),

/***/ "KN6U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("EBst");

var _preactRouter = __webpack_require__("y+SO");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "KSGD":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("Q4WQ")();
}

/***/ }),

/***/ "MRQS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__("u4m+");

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),

/***/ "N1qc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NZpJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PnSf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _mapToZero = __webpack_require__("uEG6");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("4GBI");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("iEfW");

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__("QvX2");

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__("UGHC");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("ommR");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("R0Jm");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("AX2D");

var _react2 = _interopRequireDefault(_react);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = _react2['default'].createClass({
  displayName: 'TransitionMotion',

  propTypes: {
    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      key: _react.PropTypes.string.isRequired,
      data: _react.PropTypes.any,
      style: _react.PropTypes.objectOf(_react.PropTypes.number).isRequired
    })),
    styles: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.arrayOf(_react.PropTypes.shape({
      key: _react.PropTypes.string.isRequired,
      data: _react.PropTypes.any,
      style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired
    }))]).isRequired,
    children: _react.PropTypes.func.isRequired,
    willLeave: _react.PropTypes.func,
    willEnter: _react.PropTypes.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      }
    };
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync = mergeAndSync(
    // Because this is an old-style React.createClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync[0];
    var currentStyles = _mergeAndSync[1];
    var currentVelocities = _mergeAndSync[2];
    var lastIdealStyles = _mergeAndSync[3];
    var lastIdealVelocities = _mergeAndSync[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  },

  unmounting: false,
  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyles: null,
  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);

    var mergedPropsStyles = _mergeAndSync2[0];
    var currentStyles = _mergeAndSync2[1];
    var currentVelocities = _mergeAndSync2[2];
    var lastIdealStyles = _mergeAndSync2[3];
    var lastIdealVelocities = _mergeAndSync2[4];

    for (var i = 0; i < unreadPropStyles.length; i++) {
      var unreadPropStyle = unreadPropStyles[i].style;
      var dirty = false;

      for (var key in unreadPropStyle) {
        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
          continue;
        }

        var styleValue = unreadPropStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyles[i] = _extends({}, currentStyles[i]);
            currentVelocities[i] = _extends({}, currentVelocities[i]);
            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            mergedPropsStyles[i] = {
              key: mergedPropsStyles[i].key,
              data: mergedPropsStyles[i].data,
              style: _extends({}, mergedPropsStyles[i].style)
            };
          }
          currentStyles[i][key] = styleValue;
          currentVelocities[i][key] = 0;
          lastIdealStyles[i][key] = styleValue;
          lastIdealVelocities[i][key] = 0;
          mergedPropsStyles[i].style[key] = styleValue;
        }
      }
    }

    // unlike the other 2 components, we can't detect staleness and optionally
    // opt out of setState here. each style object's data might contain new
    // stuff we're not/cannot compare
    this.setState({
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      mergedPropsStyles: mergedPropsStyles,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities
    });
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    if (this.unmounting) {
      return;
    }
    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      var propStyles = _this.props.styles;
      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

      // check if we need to animate in the first place
      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.accumulatedTime = 0;
        return;
      }

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var newMergedPropsStyles = _mergeAndSync3[0];
      var newCurrentStyles = _mergeAndSync3[1];
      var newCurrentVelocities = _mergeAndSync3[2];
      var newLastIdealStyles = _mergeAndSync3[3];
      var newLastIdealVelocities = _mergeAndSync3[4];

      for (var i = 0; i < newMergedPropsStyles.length; i++) {
        var newMergedPropsStyle = newMergedPropsStyles[i].style;
        var newCurrentStyle = {};
        var newCurrentVelocity = {};
        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};

        for (var key in newMergedPropsStyle) {
          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
            continue;
          }

          var styleValue = newMergedPropsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = newLastIdealStyles[i][key];
            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
            for (var j = 0; j < framesToCatchUp; j++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        newLastIdealStyles[i] = newLastIdealStyle;
        newLastIdealVelocities[i] = newLastIdealVelocity;
        newCurrentStyles[i] = newCurrentStyle;
        newCurrentVelocities[i] = newCurrentVelocity;
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyles: newCurrentStyles,
        currentVelocities: newCurrentVelocities,
        lastIdealStyles: newLastIdealStyles,
        lastIdealVelocities: newLastIdealVelocities,
        mergedPropsStyles: newMergedPropsStyles
      });

      _this.unreadPropStyles = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

/***/ }),

/***/ "Q4WQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("e6+Q");
var invariant = __webpack_require__("cxPT");
var ReactPropTypesSecret = __webpack_require__("gt/O");

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "QvX2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ "R0Jm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),

/***/ "R8mX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



/***/ }),

/***/ "SfWW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TSt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UGHC":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function () {
  var getNanoSeconds, hrtime, loadTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(this);

/***/ }),

/***/ "VU8D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WOkU":
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;

exports.shim = shim;
function shim(obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
}

/***/ }),

/***/ "cxPT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "d5UN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports['default'] = spring;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _presets = __webpack_require__("7uOZ");

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),

/***/ "dOKB":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__("EBst")) : typeof define === 'function' && define.amd ? define(['preact'], factory) : global['preact-async-route'] = factory(global.preact);
})(this, function (preact) {
	'use strict';

	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}return target;
	};

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var AsyncRoute = function (_Component) {
		_inherits(AsyncRoute, _Component);

		function AsyncRoute() {
			_classCallCheck(this, AsyncRoute);

			var _this = _possibleConstructorReturn(this, _Component.call(this));

			_this.state = {
				componentData: null
			};
			return _this;
		}

		AsyncRoute.prototype.loadComponent = function loadComponent() {
			var _this2 = this;

			if (this.props.component) {
				return this.setState({
					componentData: this.props.component
				});
			}
			var componentData = this.props.getComponent(this.props.url, function (_ref) {
				var component = _ref.component;

				// Named param for making callback future proof
				if (component) {
					_this2.setState({
						componentData: component
					});
				}
			}, _extends({}, this.props, this.props.matches));

			// In case returned value was a promise
			if (componentData && componentData.then) {
				// IIFE to check if a later ending promise was creating a race condition
				// Check test case for more info
				(function (url) {
					componentData.then(function (component) {
						if (url !== _this2.props.url) {
							_this2.setState({ componentData: null }, function () {
								_this2.loadComponent();
							});
							return;
						}
						_this2.setState({
							componentData: component
						});
					});
				})(this.props.url);
			}
		};

		AsyncRoute.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			var _this3 = this;

			if (this.props.path && this.props.path !== nextProps.path) {
				this.setState({
					componentData: null
				}, function () {
					_this3.loadComponent();
				});
			}
		};

		AsyncRoute.prototype.componentWillMount = function componentWillMount() {
			this.loadComponent();
		};

		AsyncRoute.prototype.render = function render() {
			if (this.state.componentData) {
				return preact.h(this.state.componentData, this.props);
			} else if (this.props.loading) {
				var loadingComponent = this.props.loading();
				return loadingComponent;
			}
			return null;
		};

		return AsyncRoute;
	}(preact.Component);

	return AsyncRoute;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "e6+Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "eLVa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__("BwbV");

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),

/***/ "gt/O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "hlyO":
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__("WOkU");
var isArguments = __webpack_require__("n/RL");

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

    // 7.3. Other pairs that do not both pass typeof value == 'object',
    // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

    // 7.4. For all other Object pairs, including Array objects, equivalence is
    // determined by having the same number of owned properties (as verified
    // with Object.prototype.hasOwnProperty.call), the same set of keys
    // (although not necessarily the same order), equivalent values for every
    // corresponding key, and an identical 'prototype' property. Note: this
    // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
};

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {
    //happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length) return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}

/***/ }),

/***/ "iEfW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),

/***/ "kEtg":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
  if (true) module.exports = factory(__webpack_require__("AX2D"), __webpack_require__("KSGD"));else if (typeof define === 'function' && define.amd) define(["react", "prop-types"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 2);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = warn;
      function warn(s) {
        console.warn('[react-ga]', s);
      }

      /***/
    },
    /* 1 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = trim;
      // GA strings need to have leading/trailing whitespace trimmed, and not all
      // browsers have String.prototoype.trim().

      function trim(s) {
        return s.replace(/^\s+|\s+$/g, '');
      }

      /***/
    },
    /* 2 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }return target;
      };

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.initialize = initialize;
      exports.ga = ga;
      exports.set = set;
      exports.send = send;
      exports.pageview = pageview;
      exports.modalview = modalview;
      exports.timing = timing;
      exports.event = event;
      exports.exception = exception;
      exports.outboundLink = outboundLink;

      var _format2 = __webpack_require__(3);

      var _format3 = _interopRequireDefault(_format2);

      var _removeLeadingSlash = __webpack_require__(6);

      var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);

      var _trim = __webpack_require__(1);

      var _trim2 = _interopRequireDefault(_trim);

      var _loadGA = __webpack_require__(7);

      var _loadGA2 = _interopRequireDefault(_loadGA);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      var _log = __webpack_require__(8);

      var _log2 = _interopRequireDefault(_log);

      var _testModeAPI = __webpack_require__(9);

      var _testModeAPI2 = _interopRequireDefault(_testModeAPI);

      var _OutboundLink = __webpack_require__(10);

      var _OutboundLink2 = _interopRequireDefault(_OutboundLink);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
        }return target;
      }

      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }return arr2;
        } else {
          return Array.from(arr);
        }
      } /**
         * React Google Analytics Module
         *
         * @package react-ga
         * @author  Adam Lofting <adam@mozillafoundation.org>
         *          Atul Varma <atul@mozillafoundation.org>
         */

      /**
       * Utilities
       */

      var _debug = false;
      var _titleCase = true;
      var _testMode = false;
      var _alwaysSendToDefaultTracker = true;

      var internalGa = function internalGa() {
        var _window;

        if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
        if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
        return (_window = window).ga.apply(_window, arguments);
      };

      function _format(s) {
        return (0, _format3.default)(s, _titleCase);
      }

      function _gaCommand(trackerNames) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var command = args[0];
        if (typeof internalGa === 'function') {
          if (typeof command !== 'string') {
            (0, _warn2.default)('ga command must be a string');
            return;
          }

          if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(undefined, args);
          if (Array.isArray(trackerNames)) {
            trackerNames.forEach(function (name) {
              internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
            });
          }
        }
      }

      function _initialize(gaTrackingID, options) {
        if (!gaTrackingID) {
          (0, _warn2.default)('gaTrackingID is required in initialize()');
          return;
        }

        if (options) {
          if (options.debug && options.debug === true) {
            _debug = true;
          }

          if (options.titleCase === false) {
            _titleCase = false;
          }
        }

        if (options && options.gaOptions) {
          internalGa('create', gaTrackingID, options.gaOptions);
        } else {
          internalGa('create', gaTrackingID, 'auto');
        }
      }

      function initialize(configsOrTrackingId, options) {
        if (options && options.testMode === true) {
          _testMode = true;
        } else {
          if (typeof window === 'undefined') {
            return false;
          }

          (0, _loadGA2.default)(options);
        }

        _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

        if (Array.isArray(configsOrTrackingId)) {
          configsOrTrackingId.forEach(function (config) {
            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
              (0, _warn2.default)('All configs must be an object');
              return;
            }
            _initialize(config.trackingId, config);
          });
        } else {
          _initialize(configsOrTrackingId, options);
        }
        return true;
      }

      /**
       * ga:
       * Returns the original GA object.
       */
      function ga() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (args.length > 0) {
          internalGa.apply(undefined, args);
          if (_debug) {
            (0, _log2.default)('called ga(\'arguments\');');
            (0, _log2.default)('with arguments: ' + JSON.stringify(args));
          }
        }

        return window.ga;
      }

      /**
       * set:
       * GA tracker set method
       * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function set(fieldsObject, trackerNames) {
        if (!fieldsObject) {
          (0, _warn2.default)('`fieldsObject` is required in .set()');
          return;
        }

        if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
          (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
          return;
        }

        if (Object.keys(fieldsObject).length === 0) {
          (0, _warn2.default)('empty `fieldsObject` given to .set()');
        }

        _gaCommand(trackerNames, 'set', fieldsObject);

        if (_debug) {
          (0, _log2.default)('called ga(\'set\', fieldsObject);');
          (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
        }
      }

      /**
       * send:
       * Clone of the low level `ga.send` method
       * WARNING: No validations will be applied to this
       * @param  {Object} fieldObject - field object for tracking different analytics
       * @param  {Array} trackerNames - trackers to send the command to
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function send(fieldObject, trackerNames) {
        _gaCommand(trackerNames, 'send', fieldObject);
        if (_debug) {
          (0, _log2.default)('called ga(\'send\', fieldObject);');
          (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
          (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
        }
      }

      /**
       * pageview:
       * Basic GA pageview tracking
       * @param  {String} path - the current page page e.g. '/about'
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       * @param {String} title - (optional) the page title e. g. 'My Website'
       */
      function pageview(rawPath, trackerNames, title) {
        if (!rawPath) {
          (0, _warn2.default)('path is required in .pageview()');
          return;
        }

        var path = (0, _trim2.default)(rawPath);
        if (path === '') {
          (0, _warn2.default)('path cannot be an empty string in .pageview()');
          return;
        }

        var extraFields = {};
        if (title) {
          extraFields.title = title;
        }

        if (typeof ga === 'function') {
          _gaCommand(trackerNames, 'send', _extends({
            hitType: 'pageview',
            page: path
          }, extraFields));

          if (_debug) {
            (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
            var extraLog = '';
            if (title) {
              extraLog = ' and title: ' + title;
            }
            (0, _log2.default)('with path: ' + path + extraLog);
          }
        }
      }

      /**
       * modalview:
       * a proxy to basic GA pageview tracking to consistently track
       * modal views that are an equivalent UX to a traditional pageview
       * @param  {String} modalName e.g. 'add-or-edit-club'
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function modalview(rawModalName, trackerNames) {
        if (!rawModalName) {
          (0, _warn2.default)('modalName is required in .modalview(modalName)');
          return;
        }

        var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));

        if (modalName === '') {
          (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
          return;
        }

        if (typeof ga === 'function') {
          var path = '/modal/' + modalName;
          _gaCommand(trackerNames, 'send', 'pageview', path);

          if (_debug) {
            (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
            (0, _log2.default)('with path: ' + path);
          }
        }
      }

      /**
       * timing:
       * GA timing
       * @param args.category {String} required
       * @param args.variable {String} required
       * @param args.value  {Int}  required
       * @param args.label  {String} required
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function timing() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            category = _ref.category,
            variable = _ref.variable,
            value = _ref.value,
            label = _ref.label;

        var trackerNames = arguments[1];

        if (typeof ga === 'function') {
          if (!category || !variable || !value || typeof value !== 'number') {
            (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'timing',
            timingCategory: _format(category),
            timingVar: _format(variable),
            timingValue: value
          };

          if (label) {
            fieldObject.timingLabel = _format(label);
          }

          send(fieldObject, trackerNames);
        }
      }

      /**
       * event:
       * GA event tracking
       * @param args.category {String} required
       * @param args.action {String} required
       * @param args.label {String} optional
       * @param args.value {Int} optional
       * @param args.nonInteraction {boolean} optional
       * @param args.transport {string} optional
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function event() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var trackerNames = arguments[1];

        var category = _ref2.category,
            action = _ref2.action,
            label = _ref2.label,
            value = _ref2.value,
            nonInteraction = _ref2.nonInteraction,
            transport = _ref2.transport,
            args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);

        if (typeof ga === 'function') {
          // Simple Validation
          if (!category || !action) {
            (0, _warn2.default)('args.category AND args.action are required in event()');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'event',
            eventCategory: _format(category),
            eventAction: _format(action)
          };

          // Optional Fields
          if (label) {
            fieldObject.eventLabel = _format(label);
          }

          if (typeof value !== 'undefined') {
            if (typeof value !== 'number') {
              (0, _warn2.default)('Expected `args.value` arg to be a Number.');
            } else {
              fieldObject.eventValue = value;
            }
          }

          if (typeof nonInteraction !== 'undefined') {
            if (typeof nonInteraction !== 'boolean') {
              (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
            } else {
              fieldObject.nonInteraction = nonInteraction;
            }
          }

          if (typeof transport !== 'undefined') {
            if (typeof transport !== 'string') {
              (0, _warn2.default)('`args.transport` must be a string.');
            } else {
              if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
                (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
              }

              fieldObject.transport = transport;
            }
          }

          Object.keys(args).filter(function (key) {
            return key.substr(0, 'dimension'.length) === 'dimension';
          }).forEach(function (key) {
            fieldObject[key] = args[key];
          });

          Object.keys(args).filter(function (key) {
            return key.substr(0, 'metric'.length) === 'metric';
          }).forEach(function (key) {
            fieldObject[key] = args[key];
          });

          // Send to GA
          send(fieldObject, trackerNames);
        }
      }

      /**
       * exception:
       * GA exception tracking
       * @param args.description {String} optional
       * @param args.fatal {boolean} optional
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function exception(_ref3, trackerNames) {
        var description = _ref3.description,
            fatal = _ref3.fatal;

        if (typeof ga === 'function') {
          // Required Fields
          var fieldObject = {
            hitType: 'exception'
          };

          // Optional Fields
          if (description) {
            fieldObject.exDescription = _format(description);
          }

          if (typeof fatal !== 'undefined') {
            if (typeof fatal !== 'boolean') {
              (0, _warn2.default)('`args.fatal` must be a boolean.');
            } else {
              fieldObject.exFatal = fatal;
            }
          }

          // Send to GA
          send(fieldObject, trackerNames);
        }
      }

      var plugin = exports.plugin = {
        /**
         * require:
         * GA requires a plugin
         * @param name {String} e.g. 'ecommerce' or 'myplugin'
         * @param options {Object} optional e.g {path: '/log', debug: true}
         */
        require: function require(rawName, options) {
          if (typeof ga === 'function') {
            // Required Fields
            if (!rawName) {
              (0, _warn2.default)('`name` is required in .require()');
              return;
            }

            var name = (0, _trim2.default)(rawName);
            if (name === '') {
              (0, _warn2.default)('`name` cannot be an empty string in .require()');
              return;
            }

            // Optional Fields
            if (options) {
              if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
                (0, _warn2.default)('Expected `options` arg to be an Object');
                return;
              }

              if (Object.keys(options).length === 0) {
                (0, _warn2.default)('Empty `options` given to .require()');
              }

              ga('require', name, options);

              if (_debug) {
                (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
              }
            } else {
              ga('require', name);

              if (_debug) {
                (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
              }
            }
          }
        },

        /**
         * execute:
         * GA execute action for plugin
         * Takes variable number of arguments
         * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
         * @param action {String} e.g. 'addItem' or 'myCustomAction'
         * @param actionType {String} optional e.g. 'detail'
         * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
         */
        execute: function execute(pluginName, action) {
          var payload = void 0;
          var actionType = void 0;

          if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
            payload = arguments.length <= 2 ? undefined : arguments[2];
          } else {
            actionType = arguments.length <= 2 ? undefined : arguments[2];
            payload = arguments.length <= 3 ? undefined : arguments[3];
          }

          if (typeof ga === 'function') {
            if (typeof pluginName !== 'string') {
              (0, _warn2.default)('Expected `pluginName` arg to be a String.');
            } else if (typeof action !== 'string') {
              (0, _warn2.default)('Expected `action` arg to be a String.');
            } else {
              var command = pluginName + ':' + action;
              payload = payload || null;
              if (actionType && payload) {
                ga(command, actionType, payload);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                  (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
                }
              } else if (payload) {
                ga(command, payload);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                  (0, _log2.default)('with payload: ' + JSON.stringify(payload));
                }
              } else {
                ga(command);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                }
              }
            }
          }
        }
      };

      /**
       * outboundLink:
       * GA outboundLink tracking
       * @param args.label {String} e.g. url, or 'Create an Account'
       * @param {function} hitCallback - Called after processing a hit.
       */
      function outboundLink(args, hitCallback, trackerNames) {
        if (typeof hitCallback !== 'function') {
          (0, _warn2.default)('hitCallback function is required');
          return;
        }

        if (typeof ga === 'function') {
          // Simple Validation
          if (!args || !args.label) {
            (0, _warn2.default)('args.label is required in outboundLink()');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'event',
            eventCategory: 'Outbound',
            eventAction: 'Click',
            eventLabel: _format(args.label)
          };

          var safetyCallbackCalled = false;
          var safetyCallback = function safetyCallback() {
            // This prevents a delayed response from GA
            // causing hitCallback from being fired twice
            safetyCallbackCalled = true;

            hitCallback();
          };

          // Using a timeout to ensure the execution of critical application code
          // in the case when the GA server might be down
          // or an ad blocker prevents sending the data

          // register safety net timeout:
          var t = setTimeout(safetyCallback, 250);

          var clearableCallbackForGA = function clearableCallbackForGA() {
            clearTimeout(t);
            if (!safetyCallbackCalled) {
              hitCallback();
            }
          };

          fieldObject.hitCallback = clearableCallbackForGA;

          // Send to GA
          send(fieldObject, trackerNames);
        } else {
          // if ga is not defined, return the callback so the application
          // continues to work as expected
          setTimeout(hitCallback, 0);
        }
      }

      _OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
      _OutboundLink2.default.trackLink = outboundLink;
      var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
      var testModeAPI = exports.testModeAPI = _testModeAPI2.default;

      exports.default = {
        initialize: initialize,
        ga: ga,
        set: set,
        send: send,
        pageview: pageview,
        modalview: modalview,
        timing: timing,
        event: event,
        exception: exception,
        plugin: plugin,
        outboundLink: outboundLink,
        OutboundLink: OutboundLink,
        testModeAPI: _testModeAPI2.default
      };

      /***/
    },
    /* 3 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = format;

      var _mightBeEmail = __webpack_require__(4);

      var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);

      var _toTitleCase = __webpack_require__(5);

      var _toTitleCase2 = _interopRequireDefault(_toTitleCase);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var redacted = 'REDACTED (Potential Email Address)';

      function format(s, titleCase) {
        if ((0, _mightBeEmail2.default)(s)) {
          (0, _warn2.default)('This arg looks like an email address, redacting.');
          return redacted;
        }

        if (titleCase) {
          return (0, _toTitleCase2.default)(s);
        }

        return s;
      }

      /***/
    },
    /* 4 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = mightBeEmail;
      // See if s could be an email address. We don't want to send personal data like email.
      // https://support.google.com/analytics/answer/2795983?hl=en
      function mightBeEmail(s) {
        // There's no point trying to validate rfc822 fully, just look for ...@...
        return (/[^@]+@[^@]+/.test(s)
        );
      }

      /***/
    },
    /* 5 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = toTitleCase;

      var _trim = __webpack_require__(1);

      var _trim2 = _interopRequireDefault(_trim);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
                                                                                                      * To Title Case 2.1 - http://individed.com/code/to-title-case/
                                                                                                      * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
                                                                                                      * https://github.com/gouch/to-title-case
                                                                                                      */

      function toTitleCase(string) {
        return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
          if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
            return match.toLowerCase();
          }

          if (match.substr(1).search(/[A-Z]|\../) > -1) {
            return match;
          }

          return match.charAt(0).toUpperCase() + match.substr(1);
        });
      }

      /***/
    },
    /* 6 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = removeLeadingSlash;
      function removeLeadingSlash(string) {
        if (string.substring(0, 1) === '/') {
          return string.substring(1);
        }

        return string;
      }

      /***/
    },
    /* 7 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      exports.default = function (options) {
        // https://developers.google.com/analytics/devguides/collection/analyticsjs/
        /* eslint-disable */
        (function (i, s, o, g, r, a, m) {
          i['GoogleAnalyticsObject'] = r;
          i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
          }, i[r].l = 1 * new Date();
          a = s.createElement(o), m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
        /* eslint-enable */
      };

      /***/
    },
    /* 8 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = log;
      function log(s) {
        console.info('[react-ga]', s);
      }

      /***/
    },
    /* 9 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var gaCalls = exports.gaCalls = [];

      exports.default = {
        calls: gaCalls,
        ga: function ga() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          gaCalls.push([].concat(args));
        }
      };

      /***/
    },
    /* 10 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _react = __webpack_require__(11);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(12);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var NEWTAB = '_blank';
      var MIDDLECLICK = 1;

      var OutboundLink = function (_Component) {
        _inherits(OutboundLink, _Component);

        function OutboundLink() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, OutboundLink);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
            var _this$props = _this.props,
                target = _this$props.target,
                eventLabel = _this$props.eventLabel,
                to = _this$props.to,
                onClick = _this$props.onClick;

            var eventMeta = { label: eventLabel };
            var sameTarget = target !== NEWTAB;
            var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

            if (sameTarget && normalClick) {
              event.preventDefault();
              OutboundLink.trackLink(eventMeta, function () {
                window.location.href = to;
              });
            } else {
              OutboundLink.trackLink(eventMeta, function () {});
            }

            if (onClick) {
              onClick(event);
            }
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(OutboundLink, [{
          key: 'render',
          value: function render() {
            var props = _extends({}, this.props, {
              href: this.props.to,
              onClick: this.handleClick
            });
            delete props.eventLabel;
            return _react2.default.createElement('a', props);
          }
        }]);

        return OutboundLink;
      }(_react.Component);

      OutboundLink.propTypes = {
        eventLabel: _propTypes2.default.string.isRequired,
        target: _propTypes2.default.string,
        to: _propTypes2.default.string,
        onClick: _propTypes2.default.func
      };
      OutboundLink.defaultProps = {
        target: null,
        to: null,
        onClick: null
      };

      OutboundLink.trackLink = function () {
        (0, _warn2.default)('ga tracking not enabled');
      };

      exports.default = OutboundLink;

      /***/
    },
    /* 11 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

      /***/
    },
    /* 12 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

      /***/
    }]
    /******/)
  );
});

/***/ }),

/***/ "lxaz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _mapToZero = __webpack_require__("uEG6");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("4GBI");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("iEfW");

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__("UGHC");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("ommR");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("R0Jm");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("AX2D");

var _react2 = _interopRequireDefault(_react);

var msPerFrame = 1000 / 60;

var Motion = _react2['default'].createClass({
  displayName: 'Motion',

  propTypes: {
    // TOOD: warn against putting a config in here
    defaultStyle: _react.PropTypes.objectOf(_react.PropTypes.number),
    style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired,
    children: _react.PropTypes.func.isRequired,
    onRest: _react.PropTypes.func
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  },

  wasAnimating: false,
  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyle: null,
  // after checking for unreadPropStyle != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
    var dirty = false;
    var _state = this.state;
    var currentStyle = _state.currentStyle;
    var currentVelocity = _state.currentVelocity;
    var lastIdealStyle = _state.lastIdealStyle;
    var lastIdealVelocity = _state.lastIdealVelocity;

    for (var key in destStyle) {
      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
        continue;
      }

      var styleValue = destStyle[key];
      if (typeof styleValue === 'number') {
        if (!dirty) {
          dirty = true;
          currentStyle = _extends({}, currentStyle);
          currentVelocity = _extends({}, currentVelocity);
          lastIdealStyle = _extends({}, lastIdealStyle);
          lastIdealVelocity = _extends({}, lastIdealVelocity);
        }

        currentStyle[key] = styleValue;
        currentVelocity[key] = 0;
        lastIdealStyle[key] = styleValue;
        lastIdealVelocity[key] = 0;
      }
    }

    if (dirty) {
      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
    }
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      // check if we need to animate in the first place
      var propsStyle = _this.props.style;
      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
        if (_this.wasAnimating && _this.props.onRest) {
          _this.props.onRest();
        }

        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.wasAnimating = false;
        _this.accumulatedTime = 0;
        return;
      }

      _this.wasAnimating = true;

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var newLastIdealStyle = {};
      var newLastIdealVelocity = {};
      var newCurrentStyle = {};
      var newCurrentVelocity = {};

      for (var key in propsStyle) {
        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
          continue;
        }

        var styleValue = propsStyle[key];
        if (typeof styleValue === 'number') {
          newCurrentStyle[key] = styleValue;
          newCurrentVelocity[key] = 0;
          newLastIdealStyle[key] = styleValue;
          newLastIdealVelocity[key] = 0;
        } else {
          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
          for (var i = 0; i < framesToCatchUp; i++) {
            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            newLastIdealStyleValue = _stepper[0];
            newLastIdealVelocityValue = _stepper[1];
          }

          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

          var nextIdealX = _stepper2[0];
          var nextIdealV = _stepper2[1];

          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
          newLastIdealStyle[key] = newLastIdealStyleValue;
          newLastIdealVelocity[key] = newLastIdealVelocityValue;
        }
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyle: newCurrentStyle,
        currentVelocity: newCurrentVelocity,
        lastIdealStyle: newLastIdealStyle,
        lastIdealVelocity: newLastIdealVelocity
      });

      _this.unreadPropStyle = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = Motion;
module.exports = exports['default'];

/***/ }),

/***/ "m0iP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m8+U":
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _preact = __webpack_require__("EBst");

var _preactSideEffect = __webpack_require__("EaSk");

var _preactSideEffect2 = _interopRequireDefault(_preactSideEffect);

var _deepEqual = __webpack_require__("hlyO");

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__("qZLH");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var HELMET_ATTRIBUTE = "data-preact-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = generateHtmlAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + " " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + ">" + encodeSpecialCharacters(title) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + " " + attributeHtml + (isSelfClosing ? ">" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var generateTitleAsPreactComponent = function generateTitleAsPreactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var initProps = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    var props = Object.keys(attributes).reduce(function (obj, key) {
        obj[key] = attributes[key];
        return obj;
    }, initProps);

    return [(0, _preact.h)(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsPreactComponent = function generateTagsAsPreactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return (0, _preact.h)(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsPreactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsPreactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

/**
 * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
 * @param {String} title: "Title"
 * @param {String} defaultTitle: "Default Title"
 * @param {String} titleTemplate: "MySite.com - %s"
 * @param {Object} titleAttributes: {"itemprop": "name"}
 * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
 * @param {Array} meta: [{"name": "description", "content": "Test description"}]
 * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
 * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
 * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
 * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
 * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
 */
var Helmet = function Helmet(WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        _inherits(HelmetWrapper, _Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var props = _extends({}, nextProps);
                if (!props.children || !props.children.length) {
                    delete props.children;
                }
                return !(0, _deepEqual2.default)(this.props, props);
            }
        }, {
            key: "render",
            value: function render() {
                return (0, _preact.h)(WrappedComponent, this.props);
            }
        }], [{
            key: "canUseDOM",

            // WrappedComponent.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                WrappedComponent.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_preact.Component), _class.peek = WrappedComponent.peek, _class.rewind = function () {
        var mappedState = WrappedComponent.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    }, _temp;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;

    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;

        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _preactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

exports.default = Helmet(HelmetSideEffects);
module.exports = exports["default"];

/***/ }),

/***/ "n/RL":
/***/ (function(module, exports) {

var supportsArgumentsClass = function () {
  return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object) {
  return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
};

/***/ }),

/***/ "nNV/":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(this);

//# sourceMappingURL=performance-now.js.map

/***/ }),

/***/ "nnEy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__("BwbV");

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ "ommR":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("nNV/"),
    root = typeof window === 'undefined' ? global : window,
    vendors = ['moz', 'webkit'],
    suffix = 'AnimationFrame',
    raf = root['request' + suffix],
    caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for (var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
  var last = 0,
      id = 0,
      queue = [],
      frameDuration = 1000 / 60;

  raf = function raf(callback) {
    if (queue.length === 0) {
      var _now = now(),
          next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function () {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for (var i = 0; i < cp.length; i++) {
          if (!cp[i].cancelled) {
            try {
              cp[i].callback(last);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id;
  };

  caf = function caf(handle) {
    for (var i = 0; i < queue.length; i++) {
      if (queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

module.exports = function (fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn);
};
module.exports.cancel = function () {
  caf.apply(root, arguments);
};
module.exports.polyfill = function (object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "p7hS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("AX2D");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("AX2D");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__("F/Ev");

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__("1wHk");

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__("MRQS");

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__("R8mX");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;

      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};

(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),

/***/ "pr2F":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if (true) module.exports = factory(__webpack_require__("AX2D"), __webpack_require__("/fEa"));else if (typeof define === 'function' && define.amd) define(["react", "react-motion"], factory);else if (typeof exports === 'object') exports["ReactPuzzle"] = factory(require("react"), require("react-motion"));else root["ReactPuzzle"] = factory(root["React"], root["ReactMotion"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_163__) {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};

			/******/ // The require function
			/******/function __webpack_require__(moduleId) {

				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId])
					/******/return installedModules[moduleId].exports;

				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/exports: {},
					/******/id: moduleId,
					/******/loaded: false
					/******/ };

				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

				/******/ // Flag the module as loaded
				/******/module.loaded = true;

				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}

			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;

			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;

			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "";

			/******/ // Load entry module and return exports
			/******/return __webpack_require__(0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/*!**********************!*\
    !*** ./src/index.js ***!
    \**********************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			exports.SlidingPuzzle = undefined;

			var _sliding = __webpack_require__( /*! ./sliding/ */52);

			var _sliding2 = _interopRequireDefault(_sliding);

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { default: obj };
			}

			exports.SlidingPuzzle = _sliding2.default;

			/***/
		},
		/* 1 */
		/*!***************************!*\
    !*** ./~/lodash/_root.js ***!
    \***************************/
		/***/function (module, exports, __webpack_require__) {

			var freeGlobal = __webpack_require__( /*! ./_freeGlobal */38);

			/** Detect free variable `self`. */
			var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

			/** Used as a reference to the global object. */
			var root = freeGlobal || freeSelf || Function('return this')();

			module.exports = root;

			/***/
		},
		/* 2 */
		/*!********************************!*\
    !*** ./~/lodash/_getNative.js ***!
    \********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseIsNative = __webpack_require__( /*! ./_baseIsNative */84),
			    getValue = __webpack_require__( /*! ./_getValue */111);

			/**
    * Gets the native function at `key` of `object`.
    *
    * @private
    * @param {Object} object The object to query.
    * @param {string} key The key of the method to get.
    * @returns {*} Returns the function if it's native, else `undefined`.
    */
			function getNative(object, key) {
				var value = getValue(object, key);
				return baseIsNative(value) ? value : undefined;
			}

			module.exports = getNative;

			/***/
		},
		/* 3 */
		/*!******************************!*\
    !*** ./~/lodash/isObject.js ***!
    \******************************/
		/***/function (module, exports) {

			/**
    * Checks if `value` is the
    * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
    * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
    *
    * @static
    * @memberOf _
    * @since 0.1.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is an object, else `false`.
    * @example
    *
    * _.isObject({});
    * // => true
    *
    * _.isObject([1, 2, 3]);
    * // => true
    *
    * _.isObject(_.noop);
    * // => true
    *
    * _.isObject(null);
    * // => false
    */
			function isObject(value) {
				var type = typeof value;
				return value != null && (type == 'object' || type == 'function');
			}

			module.exports = isObject;

			/***/
		},
		/* 4 */
		/*!*********************************!*\
    !*** ./~/lodash/_baseGetTag.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var Symbol = __webpack_require__( /*! ./_Symbol */17),
			    getRawTag = __webpack_require__( /*! ./_getRawTag */109),
			    objectToString = __webpack_require__( /*! ./_objectToString */137);

			/** `Object#toString` result references. */
			var nullTag = '[object Null]',
			    undefinedTag = '[object Undefined]';

			/** Built-in value references. */
			var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

			/**
    * The base implementation of `getTag` without fallbacks for buggy environments.
    *
    * @private
    * @param {*} value The value to query.
    * @returns {string} Returns the `toStringTag`.
    */
			function baseGetTag(value) {
				if (value == null) {
					return value === undefined ? undefinedTag : nullTag;
				}
				value = Object(value);
				return symToStringTag && symToStringTag in value ? getRawTag(value) : objectToString(value);
			}

			module.exports = baseGetTag;

			/***/
		},
		/* 5 */
		/*!**********************************!*\
    !*** ./~/lodash/isObjectLike.js ***!
    \**********************************/
		/***/function (module, exports) {

			/**
    * Checks if `value` is object-like. A value is object-like if it's not `null`
    * and has a `typeof` result of "object".
    *
    * @static
    * @memberOf _
    * @since 4.0.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
    * @example
    *
    * _.isObjectLike({});
    * // => true
    *
    * _.isObjectLike([1, 2, 3]);
    * // => true
    *
    * _.isObjectLike(_.noop);
    * // => false
    *
    * _.isObjectLike(null);
    * // => false
    */
			function isObjectLike(value) {
				return value != null && typeof value == 'object';
			}

			module.exports = isObjectLike;

			/***/
		},
		/* 6 */
		/*!*******************************************!*\
    !*** ./~/core-decorators/lib/autobind.js ***!
    \*******************************************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, '__esModule', {
				value: true
			});
			exports['default'] = autobind;

			function _toConsumableArray(arr) {
				if (Array.isArray(arr)) {
					for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
						arr2[i] = arr[i];
					}return arr2;
				} else {
					return Array.from(arr);
				}
			}

			var _privateUtils = __webpack_require__( /*! ./private/utils */26);

			var defineProperty = Object.defineProperty;
			var getPrototypeOf = Object.getPrototypeOf;

			function bind(fn, context) {
				if (fn.bind) {
					return fn.bind(context);
				} else {
					return function __autobind__() {
						return fn.apply(context, arguments);
					};
				}
			}

			var mapStore = undefined;

			function getBoundSuper(obj, fn) {
				if (typeof WeakMap === 'undefined') {
					throw new Error('Using @autobind on ' + fn.name + '() requires WeakMap support due to its use of super.' + fn.name + '()\n      See https://github.com/jayphelps/core-decorators.js/issues/20');
				}

				if (!mapStore) {
					mapStore = new WeakMap();
				}

				if (mapStore.has(obj) === false) {
					mapStore.set(obj, new WeakMap());
				}

				var superStore = mapStore.get(obj);

				if (superStore.has(fn) === false) {
					superStore.set(fn, bind(fn, obj));
				}

				return superStore.get(fn);
			}

			function autobindClass(klass) {
				var descs = (0, _privateUtils.getOwnPropertyDescriptors)(klass.prototype);
				var keys = (0, _privateUtils.getOwnKeys)(descs);

				for (var i = 0, l = keys.length; i < l; i++) {
					var key = keys[i];
					var desc = descs[key];

					if (typeof desc.value !== 'function' || key === 'constructor') {
						continue;
					}

					defineProperty(klass.prototype, key, autobindMethod(klass.prototype, key, desc));
				}
			}

			function autobindMethod(target, key, _ref) {
				var fn = _ref.value;
				var configurable = _ref.configurable;
				var enumerable = _ref.enumerable;

				if (typeof fn !== 'function') {
					throw new SyntaxError('@autobind can only be used on functions, not: ' + fn);
				}

				var constructor = target.constructor;

				return {
					configurable: configurable,
					enumerable: enumerable,

					get: function get() {
						// Class.prototype.key lookup
						// Someone accesses the property directly on the prototype on which it is
						// actually defined on, i.e. Class.prototype.hasOwnProperty(key)
						if (this === target) {
							return fn;
						}

						// Class.prototype.key lookup
						// Someone accesses the property directly on a prototype but it was found
						// up the chain, not defined directly on it
						// i.e. Class.prototype.hasOwnProperty(key) == false && key in Class.prototype
						if (this.constructor !== constructor && getPrototypeOf(this).constructor === constructor) {
							return fn;
						}

						// Autobound method calling super.sameMethod() which is also autobound and so on.
						if (this.constructor !== constructor && key in this.constructor.prototype) {
							return getBoundSuper(this, fn);
						}

						var boundFn = bind(fn, this);

						defineProperty(this, key, {
							configurable: true,
							writable: true,
							// NOT enumerable when it's a bound method
							enumerable: false,
							value: boundFn
						});

						return boundFn;
					},
					set: (0, _privateUtils.createDefaultSetter)(key)
				};
			}

			function handle(args) {
				if (args.length === 1) {
					return autobindClass.apply(undefined, _toConsumableArray(args));
				} else {
					return autobindMethod.apply(undefined, _toConsumableArray(args));
				}
			}

			function autobind() {
				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}

				if (args.length === 0) {
					return function () {
						return handle(arguments);
					};
				} else {
					return handle(args);
				}
			}

			module.exports = exports['default'];

			/***/
		},
		/* 7 */
		/*!********************************!*\
    !*** ./~/lodash/_ListCache.js ***!
    \********************************/
		/***/function (module, exports, __webpack_require__) {

			var listCacheClear = __webpack_require__( /*! ./_listCacheClear */123),
			    listCacheDelete = __webpack_require__( /*! ./_listCacheDelete */124),
			    listCacheGet = __webpack_require__( /*! ./_listCacheGet */125),
			    listCacheHas = __webpack_require__( /*! ./_listCacheHas */126),
			    listCacheSet = __webpack_require__( /*! ./_listCacheSet */127);

			/**
    * Creates an list cache object.
    *
    * @private
    * @constructor
    * @param {Array} [entries] The key-value pairs to cache.
    */
			function ListCache(entries) {
				var index = -1,
				    length = entries == null ? 0 : entries.length;

				this.clear();
				while (++index < length) {
					var entry = entries[index];
					this.set(entry[0], entry[1]);
				}
			}

			// Add methods to `ListCache`.
			ListCache.prototype.clear = listCacheClear;
			ListCache.prototype['delete'] = listCacheDelete;
			ListCache.prototype.get = listCacheGet;
			ListCache.prototype.has = listCacheHas;
			ListCache.prototype.set = listCacheSet;

			module.exports = ListCache;

			/***/
		},
		/* 8 */
		/*!***********************************!*\
    !*** ./~/lodash/_assocIndexOf.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var eq = __webpack_require__( /*! ./eq */22);

			/**
    * Gets the index at which the `key` is found in `array` of key-value pairs.
    *
    * @private
    * @param {Array} array The array to inspect.
    * @param {*} key The key to search for.
    * @returns {number} Returns the index of the matched value, else `-1`.
    */
			function assocIndexOf(array, key) {
				var length = array.length;
				while (length--) {
					if (eq(array[length][0], key)) {
						return length;
					}
				}
				return -1;
			}

			module.exports = assocIndexOf;

			/***/
		},
		/* 9 */
		/*!*********************************!*\
    !*** ./~/lodash/_copyObject.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var assignValue = __webpack_require__( /*! ./_assignValue */32),
			    baseAssignValue = __webpack_require__( /*! ./_baseAssignValue */33);

			/**
    * Copies properties of `source` to `object`.
    *
    * @private
    * @param {Object} source The object to copy properties from.
    * @param {Array} props The property identifiers to copy.
    * @param {Object} [object={}] The object to copy properties to.
    * @param {Function} [customizer] The function to customize copied values.
    * @returns {Object} Returns `object`.
    */
			function copyObject(source, props, object, customizer) {
				var isNew = !object;
				object || (object = {});

				var index = -1,
				    length = props.length;

				while (++index < length) {
					var key = props[index];

					var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

					if (newValue === undefined) {
						newValue = source[key];
					}
					if (isNew) {
						baseAssignValue(object, key, newValue);
					} else {
						assignValue(object, key, newValue);
					}
				}
				return object;
			}

			module.exports = copyObject;

			/***/
		},
		/* 10 */
		/*!*********************************!*\
    !*** ./~/lodash/_getMapData.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var isKeyable = __webpack_require__( /*! ./_isKeyable */121);

			/**
    * Gets the data for `map`.
    *
    * @private
    * @param {Object} map The map to query.
    * @param {string} key The reference key.
    * @returns {*} Returns the map data.
    */
			function getMapData(map, key) {
				var data = map.__data__;
				return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
			}

			module.exports = getMapData;

			/***/
		},
		/* 11 */
		/*!***********************************!*\
    !*** ./~/lodash/_nativeCreate.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var getNative = __webpack_require__( /*! ./_getNative */2);

			/* Built-in method references that are verified to be native. */
			var nativeCreate = getNative(Object, 'create');

			module.exports = nativeCreate;

			/***/
		},
		/* 12 */
		/*!*****************************!*\
    !*** ./~/lodash/isArray.js ***!
    \*****************************/
		/***/function (module, exports) {

			/**
    * Checks if `value` is classified as an `Array` object.
    *
    * @static
    * @memberOf _
    * @since 0.1.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is an array, else `false`.
    * @example
    *
    * _.isArray([1, 2, 3]);
    * // => true
    *
    * _.isArray(document.body.children);
    * // => false
    *
    * _.isArray('abc');
    * // => false
    *
    * _.isArray(_.noop);
    * // => false
    */
			var isArray = Array.isArray;

			module.exports = isArray;

			/***/
		},
		/* 13 */
		/*!*********************************!*\
    !*** ./~/lodash/isArrayLike.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var isFunction = __webpack_require__( /*! ./isFunction */47),
			    isLength = __webpack_require__( /*! ./isLength */48);

			/**
    * Checks if `value` is array-like. A value is considered array-like if it's
    * not a function and has a `value.length` that's an integer greater than or
    * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
    *
    * @static
    * @memberOf _
    * @since 4.0.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
    * @example
    *
    * _.isArrayLike([1, 2, 3]);
    * // => true
    *
    * _.isArrayLike(document.body.children);
    * // => true
    *
    * _.isArrayLike('abc');
    * // => true
    *
    * _.isArrayLike(_.noop);
    * // => false
    */
			function isArrayLike(value) {
				return value != null && isLength(value.length) && !isFunction(value);
			}

			module.exports = isArrayLike;

			/***/
		},
		/* 14 */
		/*!**************************!*\
    !*** ./~/lodash/keys.js ***!
    \**************************/
		/***/function (module, exports, __webpack_require__) {

			var arrayLikeKeys = __webpack_require__( /*! ./_arrayLikeKeys */28),
			    baseKeys = __webpack_require__( /*! ./_baseKeys */86),
			    isArrayLike = __webpack_require__( /*! ./isArrayLike */13);

			/**
    * Creates an array of the own enumerable property names of `object`.
    *
    * **Note:** Non-object values are coerced to objects. See the
    * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
    * for more details.
    *
    * @static
    * @since 0.1.0
    * @memberOf _
    * @category Object
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of property names.
    * @example
    *
    * function Foo() {
    *   this.a = 1;
    *   this.b = 2;
    * }
    *
    * Foo.prototype.c = 3;
    *
    * _.keys(new Foo);
    * // => ['a', 'b'] (iteration order is not guaranteed)
    *
    * _.keys('hi');
    * // => ['0', '1']
    */
			function keys(object) {
				return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
			}

			module.exports = keys;

			/***/
		},
		/* 15 */
		/*!**************************************************************************************!*\
    !*** external {"root":"React","amd":"react","commonjs":"react","commonjs2":"react"} ***!
    \**************************************************************************************/
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

			/***/
		},
		/* 16 */
		/*!**************************!*\
    !*** ./~/lodash/_Map.js ***!
    \**************************/
		/***/function (module, exports, __webpack_require__) {

			var getNative = __webpack_require__( /*! ./_getNative */2),
			    root = __webpack_require__( /*! ./_root */1);

			/* Built-in method references that are verified to be native. */
			var Map = getNative(root, 'Map');

			module.exports = Map;

			/***/
		},
		/* 17 */
		/*!*****************************!*\
    !*** ./~/lodash/_Symbol.js ***!
    \*****************************/
		/***/function (module, exports, __webpack_require__) {

			var root = __webpack_require__( /*! ./_root */1);

			/** Built-in value references. */
			var Symbol = root.Symbol;

			module.exports = Symbol;

			/***/
		},
		/* 18 */
		/*!***************************************!*\
    !*** ./~/lodash/_cloneArrayBuffer.js ***!
    \***************************************/
		/***/function (module, exports, __webpack_require__) {

			var Uint8Array = __webpack_require__( /*! ./_Uint8Array */65);

			/**
    * Creates a clone of `arrayBuffer`.
    *
    * @private
    * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
    * @returns {ArrayBuffer} Returns the cloned array buffer.
    */
			function cloneArrayBuffer(arrayBuffer) {
				var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
				new Uint8Array(result).set(new Uint8Array(arrayBuffer));
				return result;
			}

			module.exports = cloneArrayBuffer;

			/***/
		},
		/* 19 */
		/*!*********************************!*\
    !*** ./~/lodash/_getSymbols.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var overArg = __webpack_require__( /*! ./_overArg */21),
			    stubArray = __webpack_require__( /*! ./stubArray */50);

			/* Built-in method references for those with the same name as other `lodash` methods. */
			var nativeGetSymbols = Object.getOwnPropertySymbols;

			/**
    * Creates an array of the own enumerable symbols of `object`.
    *
    * @private
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of symbols.
    */
			var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

			module.exports = getSymbols;

			/***/
		},
		/* 20 */
		/*!**********************************!*\
    !*** ./~/lodash/_isPrototype.js ***!
    \**********************************/
		/***/function (module, exports) {

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/**
    * Checks if `value` is likely a prototype object.
    *
    * @private
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
    */
			function isPrototype(value) {
				var Ctor = value && value.constructor,
				    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

				return value === proto;
			}

			module.exports = isPrototype;

			/***/
		},
		/* 21 */
		/*!******************************!*\
    !*** ./~/lodash/_overArg.js ***!
    \******************************/
		/***/function (module, exports) {

			/**
    * Creates a unary function that invokes `func` with its argument transformed.
    *
    * @private
    * @param {Function} func The function to wrap.
    * @param {Function} transform The argument transform.
    * @returns {Function} Returns the new function.
    */
			function overArg(func, transform) {
				return function (arg) {
					return func(transform(arg));
				};
			}

			module.exports = overArg;

			/***/
		},
		/* 22 */
		/*!************************!*\
    !*** ./~/lodash/eq.js ***!
    \************************/
		/***/function (module, exports) {

			/**
    * Performs a
    * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    * comparison between two values to determine if they are equivalent.
    *
    * @static
    * @memberOf _
    * @since 4.0.0
    * @category Lang
    * @param {*} value The value to compare.
    * @param {*} other The other value to compare.
    * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
    * @example
    *
    * var object = { 'a': 1 };
    * var other = { 'a': 1 };
    *
    * _.eq(object, object);
    * // => true
    *
    * _.eq(object, other);
    * // => false
    *
    * _.eq('a', 'a');
    * // => true
    *
    * _.eq('a', Object('a'));
    * // => false
    *
    * _.eq(NaN, NaN);
    * // => true
    */
			function eq(value, other) {
				return value === other || value !== value && other !== other;
			}

			module.exports = eq;

			/***/
		},
		/* 23 */
		/*!********************************!*\
    !*** ./src/sliding/styles.css ***!
    \********************************/
		/***/function (module, exports, __webpack_require__) {

			// style-loader: Adds some css to the DOM by adding a <style> tag

			// load the styles
			var content = __webpack_require__( /*! !./../../~/css-loader?modules!./styles.css */57);
			if (typeof content === 'string') content = [[module.id, content, '']];
			// add the styles to the DOM
			var update = __webpack_require__( /*! ./../../~/style-loader/addStyles.js */162)(content, {});
			if (content.locals) module.exports = content.locals;
			// Hot Module Replacement
			if (false) {
				// When the styles change, update the <style> tags
				if (!content.locals) {
					module.hot.accept("!!./../../node_modules/css-loader/index.js?modules!./styles.css", function () {
						var newContent = require("!!./../../node_modules/css-loader/index.js?modules!./styles.css");
						if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];
						update(newContent);
					});
				}
				// When the module is disposed, remove the <style> tags
				module.hot.dispose(function () {
					update();
				});
			}

			/***/
		},
		/* 24 */
		/*!***********************************!*\
    !*** (webpack)/buildin/module.js ***!
    \***********************************/
		/***/function (module, exports) {

			module.exports = function (module) {
				if (!module.webpackPolyfill) {
					module.deprecate = function () {};
					module.paths = [];
					// module.parent = undefined by default
					module.children = [];
					module.webpackPolyfill = 1;
				}
				return module;
			};

			/***/
		},
		/* 25 */
		/*!******************************!*\
    !*** ./src/sliding/utils.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			exports.isSolvable = isSolvable;
			exports.isSolved = isSolved;
			exports.getMatrixPosition = getMatrixPosition;
			exports.getVisualPosition = getVisualPosition;
			exports.shuffleNumbers = shuffleNumbers;
			exports.canSwapNumbers = canSwapNumbers;
			exports.swapNumbers = swapNumbers;

			var _clone = __webpack_require__( /*! lodash/clone */150);

			var _clone2 = _interopRequireDefault(_clone);

			var _shuffle = __webpack_require__( /*! lodash/shuffle */157);

			var _shuffle2 = _interopRequireDefault(_shuffle);

			var _without = __webpack_require__( /*! lodash/without */161);

			var _without2 = _interopRequireDefault(_without);

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { default: obj };
			}

			// Checks if the puzzle can be solved.
			//
			// Examples:
			//   isSolvable([3, 7, 6, 0, 5, 1, 2, 4, 8], 3, 3) // => false
			//   isSolvable([6, 4, 5, 0, 1, 2, 3, 7, 8], 3, 3) // => true
			function isSolvable(numbers, rows, cols) {
				var product = 1;
				for (var i = 1, l = rows * cols - 1; i <= l; i++) {
					for (var j = i + 1, m = l + 1; j <= m; j++) {
						product *= (numbers[i - 1] - numbers[j - 1]) / (i - j);
					}
				}
				return Math.round(product) === 1;
			}

			// Checks if the puzzle is solved.
			//
			// Examples:
			//   isSolved([6, 4, 5, 0, 1, 2, 3, 7, 8]) // => false
			//   isSolved([0, 1, 2, 3, 4, 5, 6, 7, 8]) // => true
			function isSolved(numbers) {
				for (var i = 0, l = numbers.length; i < l; i++) {
					if (numbers[i] !== i) {
						return false;
					}
				}
				return true;
			}

			// Get the row and column from a linear index.
			function getMatrixPosition(index, rows, cols) {
				return {
					row: Math.floor(index / cols),
					col: index % cols
				};
			}

			// Get the X and Y coordinates from a row and column.
			function getVisualPosition(_ref, width, height, margin) {
				var row = _ref.row,
				    col = _ref.col;

				return {
					x: col * width + margin,
					y: row * height + margin
				};
			}

			// Generates a shuffle that is solvable.
			function shuffleNumbers(numbers, rows, cols, hole) {
				do {
					numbers = (0, _shuffle2.default)((0, _without2.default)(numbers, hole)).concat(hole);
				} while (isSolved(numbers) || !isSolvable(numbers, rows, cols));
				return numbers;
			}

			// Checks if two indices can be swapped because they are adjacent.
			function canSwapNumbers(src, dest, rows, cols) {
				var _getMatrixPosition = getMatrixPosition(src, rows, cols),
				    srcRow = _getMatrixPosition.row,
				    srcCol = _getMatrixPosition.col;

				var _getMatrixPosition2 = getMatrixPosition(dest, rows, cols),
				    destRow = _getMatrixPosition2.row,
				    destCol = _getMatrixPosition2.col;

				return Math.abs(srcRow - destRow) + Math.abs(srcCol - destCol) === 1;
			}

			// Swaps two indices.
			function swapNumbers(numbers, src, dest) {
				numbers = (0, _clone2.default)(numbers);
				var _ref2 = [numbers[dest], numbers[src]];
				numbers[src] = _ref2[0];
				numbers[dest] = _ref2[1];

				return numbers;
			}

			/***/
		},
		/* 26 */
		/*!************************************************!*\
    !*** ./~/core-decorators/lib/private/utils.js ***!
    \************************************************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, '__esModule', {
				value: true
			});
			var _slice = Array.prototype.slice;

			var _createDecoratedClass = function () {
				function defineProperties(target, descriptors, initializers) {
					for (var i = 0; i < descriptors.length; i++) {
						var descriptor = descriptors[i];var decorators = descriptor.decorators;var key = descriptor.key;delete descriptor.key;delete descriptor.decorators;descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor || descriptor.initializer) descriptor.writable = true;if (decorators) {
							for (var f = 0; f < decorators.length; f++) {
								var decorator = decorators[f];if (typeof decorator === 'function') {
									descriptor = decorator(target, key, descriptor) || descriptor;
								} else {
									throw new TypeError('The decorator for method ' + descriptor.key + ' is of the invalid type ' + typeof decorator);
								}
							}if (descriptor.initializer !== undefined) {
								initializers[key] = descriptor;continue;
							}
						}Object.defineProperty(target, key, descriptor);
					}
				}return function (Constructor, protoProps, staticProps, protoInitializers, staticInitializers) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps, protoInitializers);if (staticProps) defineProperties(Constructor, staticProps, staticInitializers);return Constructor;
				};
			}();

			exports.isDescriptor = isDescriptor;
			exports.decorate = decorate;
			exports.metaFor = metaFor;
			exports.getOwnPropertyDescriptors = getOwnPropertyDescriptors;
			exports.createDefaultSetter = createDefaultSetter;

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { 'default': obj };
			}

			function _toConsumableArray(arr) {
				if (Array.isArray(arr)) {
					for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
						arr2[i] = arr[i];
					}return arr2;
				} else {
					return Array.from(arr);
				}
			}

			function _classCallCheck(instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError('Cannot call a class as a function');
				}
			}

			function _defineDecoratedPropertyDescriptor(target, key, descriptors) {
				var _descriptor = descriptors[key];if (!_descriptor) return;var descriptor = {};for (var _key in _descriptor) {
					descriptor[_key] = _descriptor[_key];
				}descriptor.value = descriptor.initializer ? descriptor.initializer.call(target) : undefined;Object.defineProperty(target, key, descriptor);
			}

			var _lazyInitialize = __webpack_require__( /*! ../lazy-initialize */56);

			var _lazyInitialize2 = _interopRequireDefault(_lazyInitialize);

			var defineProperty = Object.defineProperty;
			var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
			var getOwnPropertyNames = Object.getOwnPropertyNames;
			var getOwnPropertySymbols = Object.getOwnPropertySymbols;

			function isDescriptor(desc) {
				if (!desc || !desc.hasOwnProperty) {
					return false;
				}

				var keys = ['value', 'initializer', 'get', 'set'];

				for (var i = 0, l = keys.length; i < l; i++) {
					if (desc.hasOwnProperty(keys[i])) {
						return true;
					}
				}

				return false;
			}

			function decorate(handleDescriptor, entryArgs) {
				if (isDescriptor(entryArgs[entryArgs.length - 1])) {
					return handleDescriptor.apply(undefined, _toConsumableArray(entryArgs).concat([[]]));
				} else {
					return function () {
						return handleDescriptor.apply(undefined, _slice.call(arguments).concat([entryArgs]));
					};
				}
			}

			var Meta = function () {
				var _instanceInitializers = {};

				function Meta() {
					_classCallCheck(this, Meta);

					_defineDecoratedPropertyDescriptor(this, 'debounceTimeoutIds', _instanceInitializers);

					_defineDecoratedPropertyDescriptor(this, 'throttleTimeoutIds', _instanceInitializers);

					_defineDecoratedPropertyDescriptor(this, 'throttlePreviousTimestamps', _instanceInitializers);
				}

				_createDecoratedClass(Meta, [{
					key: 'debounceTimeoutIds',
					decorators: [_lazyInitialize2['default']],
					initializer: function initializer() {
						return {};
					},
					enumerable: true
				}, {
					key: 'throttleTimeoutIds',
					decorators: [_lazyInitialize2['default']],
					initializer: function initializer() {
						return {};
					},
					enumerable: true
				}, {
					key: 'throttlePreviousTimestamps',
					decorators: [_lazyInitialize2['default']],
					initializer: function initializer() {
						return {};
					},
					enumerable: true
				}], null, _instanceInitializers);

				return Meta;
			}();

			var META_KEY = typeof Symbol === 'function' ? Symbol('__core_decorators__') : '__core_decorators__';

			function metaFor(obj) {
				if (obj.hasOwnProperty(META_KEY) === false) {
					defineProperty(obj, META_KEY, {
						// Defaults: NOT enumerable, configurable, or writable
						value: new Meta()
					});
				}

				return obj[META_KEY];
			}

			var getOwnKeys = getOwnPropertySymbols ? function (object) {
				return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
			} : getOwnPropertyNames;

			exports.getOwnKeys = getOwnKeys;

			function getOwnPropertyDescriptors(obj) {
				var descs = {};

				getOwnKeys(obj).forEach(function (key) {
					return descs[key] = getOwnPropertyDescriptor(obj, key);
				});

				return descs;
			}

			function createDefaultSetter(key) {
				return function set(newValue) {
					Object.defineProperty(this, key, {
						configurable: true,
						writable: true,
						// IS enumerable when reassigned by the outside word
						enumerable: true,
						value: newValue
					});

					return newValue;
				};
			}

			/***/
		},
		/* 27 */
		/*!*******************************!*\
    !*** ./~/lodash/_MapCache.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var mapCacheClear = __webpack_require__( /*! ./_mapCacheClear */128),
			    mapCacheDelete = __webpack_require__( /*! ./_mapCacheDelete */129),
			    mapCacheGet = __webpack_require__( /*! ./_mapCacheGet */130),
			    mapCacheHas = __webpack_require__( /*! ./_mapCacheHas */131),
			    mapCacheSet = __webpack_require__( /*! ./_mapCacheSet */132);

			/**
    * Creates a map cache object to store key-value pairs.
    *
    * @private
    * @constructor
    * @param {Array} [entries] The key-value pairs to cache.
    */
			function MapCache(entries) {
				var index = -1,
				    length = entries == null ? 0 : entries.length;

				this.clear();
				while (++index < length) {
					var entry = entries[index];
					this.set(entry[0], entry[1]);
				}
			}

			// Add methods to `MapCache`.
			MapCache.prototype.clear = mapCacheClear;
			MapCache.prototype['delete'] = mapCacheDelete;
			MapCache.prototype.get = mapCacheGet;
			MapCache.prototype.has = mapCacheHas;
			MapCache.prototype.set = mapCacheSet;

			module.exports = MapCache;

			/***/
		},
		/* 28 */
		/*!************************************!*\
    !*** ./~/lodash/_arrayLikeKeys.js ***!
    \************************************/
		/***/function (module, exports, __webpack_require__) {

			var baseTimes = __webpack_require__( /*! ./_baseTimes */93),
			    isArguments = __webpack_require__( /*! ./isArguments */152),
			    isArray = __webpack_require__( /*! ./isArray */12),
			    isBuffer = __webpack_require__( /*! ./isBuffer */46),
			    isIndex = __webpack_require__( /*! ./_isIndex */41),
			    isTypedArray = __webpack_require__( /*! ./isTypedArray */155);

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/**
    * Creates an array of the enumerable property names of the array-like `value`.
    *
    * @private
    * @param {*} value The value to query.
    * @param {boolean} inherited Specify returning inherited property names.
    * @returns {Array} Returns the array of property names.
    */
			function arrayLikeKeys(value, inherited) {
				var isArr = isArray(value),
				    isArg = !isArr && isArguments(value),
				    isBuff = !isArr && !isArg && isBuffer(value),
				    isType = !isArr && !isArg && !isBuff && isTypedArray(value),
				    skipIndexes = isArr || isArg || isBuff || isType,
				    result = skipIndexes ? baseTimes(value.length, String) : [],
				    length = result.length;

				for (var key in value) {
					if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
					// Safari 9 has enumerable `arguments.length` in strict mode.
					key == 'length' ||
					// Node.js 0.10 has enumerable non-index properties on buffers.
					isBuff && (key == 'offset' || key == 'parent') ||
					// PhantomJS 2 has enumerable non-index properties on typed arrays.
					isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
					// Skip index properties.
					isIndex(key, length)))) {
						result.push(key);
					}
				}
				return result;
			}

			module.exports = arrayLikeKeys;

			/***/
		},
		/* 29 */
		/*!*******************************!*\
    !*** ./~/lodash/_arrayMap.js ***!
    \*******************************/
		/***/function (module, exports) {

			/**
    * A specialized version of `_.map` for arrays without support for iteratee
    * shorthands.
    *
    * @private
    * @param {Array} [array] The array to iterate over.
    * @param {Function} iteratee The function invoked per iteration.
    * @returns {Array} Returns the new mapped array.
    */
			function arrayMap(array, iteratee) {
				var index = -1,
				    length = array == null ? 0 : array.length,
				    result = Array(length);

				while (++index < length) {
					result[index] = iteratee(array[index], index, array);
				}
				return result;
			}

			module.exports = arrayMap;

			/***/
		},
		/* 30 */
		/*!********************************!*\
    !*** ./~/lodash/_arrayPush.js ***!
    \********************************/
		/***/function (module, exports) {

			/**
    * Appends the elements of `values` to `array`.
    *
    * @private
    * @param {Array} array The array to modify.
    * @param {Array} values The values to append.
    * @returns {Array} Returns `array`.
    */
			function arrayPush(array, values) {
				var index = -1,
				    length = values.length,
				    offset = array.length;

				while (++index < length) {
					array[offset + index] = values[index];
				}
				return array;
			}

			module.exports = arrayPush;

			/***/
		},
		/* 31 */
		/*!**********************************!*\
    !*** ./~/lodash/_arrayReduce.js ***!
    \**********************************/
		/***/function (module, exports) {

			/**
    * A specialized version of `_.reduce` for arrays without support for
    * iteratee shorthands.
    *
    * @private
    * @param {Array} [array] The array to iterate over.
    * @param {Function} iteratee The function invoked per iteration.
    * @param {*} [accumulator] The initial value.
    * @param {boolean} [initAccum] Specify using the first element of `array` as
    *  the initial value.
    * @returns {*} Returns the accumulated value.
    */
			function arrayReduce(array, iteratee, accumulator, initAccum) {
				var index = -1,
				    length = array == null ? 0 : array.length;

				if (initAccum && length) {
					accumulator = array[++index];
				}
				while (++index < length) {
					accumulator = iteratee(accumulator, array[index], index, array);
				}
				return accumulator;
			}

			module.exports = arrayReduce;

			/***/
		},
		/* 32 */
		/*!**********************************!*\
    !*** ./~/lodash/_assignValue.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseAssignValue = __webpack_require__( /*! ./_baseAssignValue */33),
			    eq = __webpack_require__( /*! ./eq */22);

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/**
    * Assigns `value` to `key` of `object` if the existing value is not equivalent
    * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    * for equality comparisons.
    *
    * @private
    * @param {Object} object The object to modify.
    * @param {string} key The key of the property to assign.
    * @param {*} value The value to assign.
    */
			function assignValue(object, key, value) {
				var objValue = object[key];
				if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
					baseAssignValue(object, key, value);
				}
			}

			module.exports = assignValue;

			/***/
		},
		/* 33 */
		/*!**************************************!*\
    !*** ./~/lodash/_baseAssignValue.js ***!
    \**************************************/
		/***/function (module, exports, __webpack_require__) {

			var defineProperty = __webpack_require__( /*! ./_defineProperty */37);

			/**
    * The base implementation of `assignValue` and `assignMergeValue` without
    * value checks.
    *
    * @private
    * @param {Object} object The object to modify.
    * @param {string} key The key of the property to assign.
    * @param {*} value The value to assign.
    */
			function baseAssignValue(object, key, value) {
				if (key == '__proto__' && defineProperty) {
					defineProperty(object, key, {
						'configurable': true,
						'enumerable': true,
						'value': value,
						'writable': true
					});
				} else {
					object[key] = value;
				}
			}

			module.exports = baseAssignValue;

			/***/
		},
		/* 34 */
		/*!*************************************!*\
    !*** ./~/lodash/_baseGetAllKeys.js ***!
    \*************************************/
		/***/function (module, exports, __webpack_require__) {

			var arrayPush = __webpack_require__( /*! ./_arrayPush */30),
			    isArray = __webpack_require__( /*! ./isArray */12);

			/**
    * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
    * `keysFunc` and `symbolsFunc` to get the enumerable property names and
    * symbols of `object`.
    *
    * @private
    * @param {Object} object The object to query.
    * @param {Function} keysFunc The function to get the keys of `object`.
    * @param {Function} symbolsFunc The function to get the symbols of `object`.
    * @returns {Array} Returns the array of property names and symbols.
    */
			function baseGetAllKeys(object, keysFunc, symbolsFunc) {
				var result = keysFunc(object);
				return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
			}

			module.exports = baseGetAllKeys;

			/***/
		},
		/* 35 */
		/*!********************************!*\
    !*** ./~/lodash/_baseUnary.js ***!
    \********************************/
		/***/function (module, exports) {

			/**
    * The base implementation of `_.unary` without support for storing metadata.
    *
    * @private
    * @param {Function} func The function to cap arguments for.
    * @returns {Function} Returns the new capped function.
    */
			function baseUnary(func) {
				return function (value) {
					return func(value);
				};
			}

			module.exports = baseUnary;

			/***/
		},
		/* 36 */
		/*!********************************!*\
    !*** ./~/lodash/_copyArray.js ***!
    \********************************/
		/***/function (module, exports) {

			/**
    * Copies the values of `source` to `array`.
    *
    * @private
    * @param {Array} source The array to copy values from.
    * @param {Array} [array=[]] The array to copy values to.
    * @returns {Array} Returns `array`.
    */
			function copyArray(source, array) {
				var index = -1,
				    length = source.length;

				array || (array = Array(length));
				while (++index < length) {
					array[index] = source[index];
				}
				return array;
			}

			module.exports = copyArray;

			/***/
		},
		/* 37 */
		/*!*************************************!*\
    !*** ./~/lodash/_defineProperty.js ***!
    \*************************************/
		/***/function (module, exports, __webpack_require__) {

			var getNative = __webpack_require__( /*! ./_getNative */2);

			var defineProperty = function () {
				try {
					var func = getNative(Object, 'defineProperty');
					func({}, '', {});
					return func;
				} catch (e) {}
			}();

			module.exports = defineProperty;

			/***/
		},
		/* 38 */
		/*!*********************************!*\
    !*** ./~/lodash/_freeGlobal.js ***!
    \*********************************/
		/***/function (module, exports) {

			/* WEBPACK VAR INJECTION */(function (global) {
				/** Detect free variable `global` from Node.js. */
				var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

				module.exports = freeGlobal;

				/* WEBPACK VAR INJECTION */
			}).call(exports, function () {
				return this;
			}());

			/***/
		},
		/* 39 */
		/*!***********************************!*\
    !*** ./~/lodash/_getPrototype.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var overArg = __webpack_require__( /*! ./_overArg */21);

			/** Built-in value references. */
			var getPrototype = overArg(Object.getPrototypeOf, Object);

			module.exports = getPrototype;

			/***/
		},
		/* 40 */
		/*!***********************************!*\
    !*** ./~/lodash/_getSymbolsIn.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var arrayPush = __webpack_require__( /*! ./_arrayPush */30),
			    getPrototype = __webpack_require__( /*! ./_getPrototype */39),
			    getSymbols = __webpack_require__( /*! ./_getSymbols */19),
			    stubArray = __webpack_require__( /*! ./stubArray */50);

			/* Built-in method references for those with the same name as other `lodash` methods. */
			var nativeGetSymbols = Object.getOwnPropertySymbols;

			/**
    * Creates an array of the own and inherited enumerable symbols of `object`.
    *
    * @private
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of symbols.
    */
			var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
				var result = [];
				while (object) {
					arrayPush(result, getSymbols(object));
					object = getPrototype(object);
				}
				return result;
			};

			module.exports = getSymbolsIn;

			/***/
		},
		/* 41 */
		/*!******************************!*\
    !*** ./~/lodash/_isIndex.js ***!
    \******************************/
		/***/function (module, exports) {

			/** Used as references for various `Number` constants. */
			var MAX_SAFE_INTEGER = 9007199254740991;

			/** Used to detect unsigned integer values. */
			var reIsUint = /^(?:0|[1-9]\d*)$/;

			/**
    * Checks if `value` is a valid array-like index.
    *
    * @private
    * @param {*} value The value to check.
    * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
    * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
    */
			function isIndex(value, length) {
				length = length == null ? MAX_SAFE_INTEGER : length;
				return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
			}

			module.exports = isIndex;

			/***/
		},
		/* 42 */
		/*!**********************************!*\
    !*** ./~/lodash/_shuffleSelf.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseRandom = __webpack_require__( /*! ./_baseRandom */88);

			/**
    * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
    *
    * @private
    * @param {Array} array The array to shuffle.
    * @param {number} [size=array.length] The size of `array`.
    * @returns {Array} Returns `array`.
    */
			function shuffleSelf(array, size) {
				var index = -1,
				    length = array.length,
				    lastIndex = length - 1;

				size = size === undefined ? length : size;
				while (++index < size) {
					var rand = baseRandom(index, lastIndex),
					    value = array[rand];

					array[rand] = array[index];
					array[index] = value;
				}
				array.length = size;
				return array;
			}

			module.exports = shuffleSelf;

			/***/
		},
		/* 43 */
		/*!*******************************!*\
    !*** ./~/lodash/_toSource.js ***!
    \*******************************/
		/***/function (module, exports) {

			/** Used for built-in method references. */
			var funcProto = Function.prototype;

			/** Used to resolve the decompiled source of functions. */
			var funcToString = funcProto.toString;

			/**
    * Converts `func` to its source code.
    *
    * @private
    * @param {Function} func The function to convert.
    * @returns {string} Returns the source code.
    */
			function toSource(func) {
				if (func != null) {
					try {
						return funcToString.call(func);
					} catch (e) {}
					try {
						return func + '';
					} catch (e) {}
				}
				return '';
			}

			module.exports = toSource;

			/***/
		},
		/* 44 */
		/*!***************************!*\
    !*** ./~/lodash/clamp.js ***!
    \***************************/
		/***/function (module, exports, __webpack_require__) {

			var baseClamp = __webpack_require__( /*! ./_baseClamp */76),
			    toNumber = __webpack_require__( /*! ./toNumber */51);

			/**
    * Clamps `number` within the inclusive `lower` and `upper` bounds.
    *
    * @static
    * @memberOf _
    * @since 4.0.0
    * @category Number
    * @param {number} number The number to clamp.
    * @param {number} [lower] The lower bound.
    * @param {number} upper The upper bound.
    * @returns {number} Returns the clamped number.
    * @example
    *
    * _.clamp(-10, -5, 5);
    * // => -5
    *
    * _.clamp(10, -5, 5);
    * // => 5
    */
			function clamp(number, lower, upper) {
				if (upper === undefined) {
					upper = lower;
					lower = undefined;
				}
				if (upper !== undefined) {
					upper = toNumber(upper);
					upper = upper === upper ? upper : 0;
				}
				if (lower !== undefined) {
					lower = toNumber(lower);
					lower = lower === lower ? lower : 0;
				}
				return baseClamp(toNumber(number), lower, upper);
			}

			module.exports = clamp;

			/***/
		},
		/* 45 */
		/*!******************************!*\
    !*** ./~/lodash/identity.js ***!
    \******************************/
		/***/function (module, exports) {

			/**
    * This method returns the first argument it receives.
    *
    * @static
    * @since 0.1.0
    * @memberOf _
    * @category Util
    * @param {*} value Any value.
    * @returns {*} Returns `value`.
    * @example
    *
    * var object = { 'a': 1 };
    *
    * console.log(_.identity(object) === object);
    * // => true
    */
			function identity(value) {
				return value;
			}

			module.exports = identity;

			/***/
		},
		/* 46 */
		/*!******************************!*\
    !*** ./~/lodash/isBuffer.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			/* WEBPACK VAR INJECTION */(function (module) {
				var root = __webpack_require__( /*! ./_root */1),
				    stubFalse = __webpack_require__( /*! ./stubFalse */158);

				/** Detect free variable `exports`. */
				var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

				/** Detect free variable `module`. */
				var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

				/** Detect the popular CommonJS extension `module.exports`. */
				var moduleExports = freeModule && freeModule.exports === freeExports;

				/** Built-in value references. */
				var Buffer = moduleExports ? root.Buffer : undefined;

				/* Built-in method references for those with the same name as other `lodash` methods. */
				var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

				/**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
				var isBuffer = nativeIsBuffer || stubFalse;

				module.exports = isBuffer;

				/* WEBPACK VAR INJECTION */
			}).call(exports, __webpack_require__( /*! ./../webpack/buildin/module.js */24)(module));

			/***/
		},
		/* 47 */
		/*!********************************!*\
    !*** ./~/lodash/isFunction.js ***!
    \********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseGetTag = __webpack_require__( /*! ./_baseGetTag */4),
			    isObject = __webpack_require__( /*! ./isObject */3);

			/** `Object#toString` result references. */
			var asyncTag = '[object AsyncFunction]',
			    funcTag = '[object Function]',
			    genTag = '[object GeneratorFunction]',
			    proxyTag = '[object Proxy]';

			/**
    * Checks if `value` is classified as a `Function` object.
    *
    * @static
    * @memberOf _
    * @since 0.1.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is a function, else `false`.
    * @example
    *
    * _.isFunction(_);
    * // => true
    *
    * _.isFunction(/abc/);
    * // => false
    */
			function isFunction(value) {
				if (!isObject(value)) {
					return false;
				}
				// The use of `Object#toString` avoids issues with the `typeof` operator
				// in Safari 9 which returns 'object' for typed arrays and other constructors.
				var tag = baseGetTag(value);
				return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
			}

			module.exports = isFunction;

			/***/
		},
		/* 48 */
		/*!******************************!*\
    !*** ./~/lodash/isLength.js ***!
    \******************************/
		/***/function (module, exports) {

			/** Used as references for various `Number` constants. */
			var MAX_SAFE_INTEGER = 9007199254740991;

			/**
    * Checks if `value` is a valid array-like length.
    *
    * **Note:** This method is loosely based on
    * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
    *
    * @static
    * @memberOf _
    * @since 4.0.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
    * @example
    *
    * _.isLength(3);
    * // => true
    *
    * _.isLength(Number.MIN_VALUE);
    * // => false
    *
    * _.isLength(Infinity);
    * // => false
    *
    * _.isLength('3');
    * // => false
    */
			function isLength(value) {
				return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
			}

			module.exports = isLength;

			/***/
		},
		/* 49 */
		/*!****************************!*\
    !*** ./~/lodash/keysIn.js ***!
    \****************************/
		/***/function (module, exports, __webpack_require__) {

			var arrayLikeKeys = __webpack_require__( /*! ./_arrayLikeKeys */28),
			    baseKeysIn = __webpack_require__( /*! ./_baseKeysIn */87),
			    isArrayLike = __webpack_require__( /*! ./isArrayLike */13);

			/**
    * Creates an array of the own and inherited enumerable property names of `object`.
    *
    * **Note:** Non-object values are coerced to objects.
    *
    * @static
    * @memberOf _
    * @since 3.0.0
    * @category Object
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of property names.
    * @example
    *
    * function Foo() {
    *   this.a = 1;
    *   this.b = 2;
    * }
    *
    * Foo.prototype.c = 3;
    *
    * _.keysIn(new Foo);
    * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
    */
			function keysIn(object) {
				return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
			}

			module.exports = keysIn;

			/***/
		},
		/* 50 */
		/*!*******************************!*\
    !*** ./~/lodash/stubArray.js ***!
    \*******************************/
		/***/function (module, exports) {

			/**
    * This method returns a new empty array.
    *
    * @static
    * @memberOf _
    * @since 4.13.0
    * @category Util
    * @returns {Array} Returns the new empty array.
    * @example
    *
    * var arrays = _.times(2, _.stubArray);
    *
    * console.log(arrays);
    * // => [[], []]
    *
    * console.log(arrays[0] === arrays[1]);
    * // => false
    */
			function stubArray() {
				return [];
			}

			module.exports = stubArray;

			/***/
		},
		/* 51 */
		/*!******************************!*\
    !*** ./~/lodash/toNumber.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			var isObject = __webpack_require__( /*! ./isObject */3),
			    isSymbol = __webpack_require__( /*! ./isSymbol */154);

			/** Used as references for various `Number` constants. */
			var NAN = 0 / 0;

			/** Used to match leading and trailing whitespace. */
			var reTrim = /^\s+|\s+$/g;

			/** Used to detect bad signed hexadecimal string values. */
			var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

			/** Used to detect binary string values. */
			var reIsBinary = /^0b[01]+$/i;

			/** Used to detect octal string values. */
			var reIsOctal = /^0o[0-7]+$/i;

			/** Built-in method references without a dependency on `root`. */
			var freeParseInt = parseInt;

			/**
    * Converts `value` to a number.
    *
    * @static
    * @memberOf _
    * @since 4.0.0
    * @category Lang
    * @param {*} value The value to process.
    * @returns {number} Returns the number.
    * @example
    *
    * _.toNumber(3.2);
    * // => 3.2
    *
    * _.toNumber(Number.MIN_VALUE);
    * // => 5e-324
    *
    * _.toNumber(Infinity);
    * // => Infinity
    *
    * _.toNumber('3.2');
    * // => 3.2
    */
			function toNumber(value) {
				if (typeof value == 'number') {
					return value;
				}
				if (isSymbol(value)) {
					return NAN;
				}
				if (isObject(value)) {
					var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
					value = isObject(other) ? other + '' : other;
				}
				if (typeof value != 'string') {
					return value === 0 ? value : +value;
				}
				value = value.replace(reTrim, '');
				var isBinary = reIsBinary.test(value);
				return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
			}

			module.exports = toNumber;

			/***/
		},
		/* 52 */
		/*!******************************!*\
    !*** ./src/sliding/index.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			exports.default = undefined;

			var _extends = Object.assign || function (target) {
				for (var i = 1; i < arguments.length; i++) {
					var source = arguments[i];for (var key in source) {
						if (Object.prototype.hasOwnProperty.call(source, key)) {
							target[key] = source[key];
						}
					}
				}return target;
			};

			var _createClass = function () {
				function defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
					}
				}return function (Constructor, protoProps, staticProps) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
				};
			}();

			var _desc, _value, _class;

			var _react = __webpack_require__( /*! react */15);

			var _react2 = _interopRequireDefault(_react);

			var _autobind = __webpack_require__( /*! core-decorators/lib/autobind */6);

			var _autobind2 = _interopRequireDefault(_autobind);

			var _clamp = __webpack_require__( /*! lodash/clamp */44);

			var _clamp2 = _interopRequireDefault(_clamp);

			var _wrapper = __webpack_require__( /*! ./wrapper */55);

			var _wrapper2 = _interopRequireDefault(_wrapper);

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { default: obj };
			}

			function _classCallCheck(instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			}

			function _possibleConstructorReturn(self, call) {
				if (!self) {
					throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
				}return call && (typeof call === "object" || typeof call === "function") ? call : self;
			}

			function _inherits(subClass, superClass) {
				if (typeof superClass !== "function" && superClass !== null) {
					throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
				}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
			}

			function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
				var desc = {};
				Object['ke' + 'ys'](descriptor).forEach(function (key) {
					desc[key] = descriptor[key];
				});
				desc.enumerable = !!desc.enumerable;
				desc.configurable = !!desc.configurable;

				if ('value' in desc || desc.initializer) {
					desc.writable = true;
				}

				desc = decorators.slice().reverse().reduce(function (desc, decorator) {
					return decorator(target, property, desc) || desc;
				}, desc);

				if (context && desc.initializer !== void 0) {
					desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
					desc.initializer = undefined;
				}

				if (desc.initializer === void 0) {
					Object['define' + 'Property'](target, property, desc);
					desc = null;
				}

				return desc;
			}

			var SlidingPuzzle = (_class = function (_Component) {
				_inherits(SlidingPuzzle, _Component);

				function SlidingPuzzle() {
					_classCallCheck(this, SlidingPuzzle);

					return _possibleConstructorReturn(this, (SlidingPuzzle.__proto__ || Object.getPrototypeOf(SlidingPuzzle)).apply(this, arguments));
				}

				_createClass(SlidingPuzzle, [{
					key: 'handlePuzzleRef',
					value: function handlePuzzleRef(puzzle) {
						this._puzzle = puzzle;
					}
				}, {
					key: 'shuffle',
					value: function shuffle() {
						this._puzzle.shuffle();
					}
				}, {
					key: 'render',
					value: function render() {
						var _props = this.props,
						    rows = _props.rows,
						    cols = _props.cols,
						    hole = _props.hole;

						var clampedRows = (0, _clamp2.default)(rows, 3, 9);
						var clampedCols = (0, _clamp2.default)(cols, 3, 9);
						var clampedHole = (0, _clamp2.default)(hole, 0, rows * cols - 1);

						return _react2.default.createElement(_wrapper2.default, _extends({}, this.props, {
							rows: clampedRows,
							cols: clampedCols,
							hole: clampedHole,
							ref: this.handlePuzzleRef
						}));
					}
				}]);

				return SlidingPuzzle;
			}(_react.Component), _applyDecoratedDescriptor(_class.prototype, 'handlePuzzleRef', [_autobind2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handlePuzzleRef'), _class.prototype), _class);
			SlidingPuzzle.propTypes = {
				rows: _react.PropTypes.number,
				cols: _react.PropTypes.number,
				hole: _react.PropTypes.number,
				minWidth: _react.PropTypes.number,
				minHeight: _react.PropTypes.number,
				maxWidth: _react.PropTypes.number,
				maxHeight: _react.PropTypes.number,
				margin: _react.PropTypes.number,
				color: _react.PropTypes.string,
				src: _react.PropTypes.string,
				onLoad: _react.PropTypes.func,
				onMove: _react.PropTypes.func,
				onSolve: _react.PropTypes.func,
				onError: _react.PropTypes.func
			};
			SlidingPuzzle.defaultProps = {
				rows: 4,
				cols: 4,
				hole: Infinity,
				minWidth: 0,
				minHeight: 0,
				maxWidth: Infinity,
				maxHeight: Infinity,
				margin: 0,
				color: '#ccc',
				src: null
			};
			exports.default = SlidingPuzzle;

			/***/
		},
		/* 53 */
		/*!*****************************!*\
    !*** ./src/sliding/tile.js ***!
    \*****************************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			exports.default = undefined;

			var _extends = Object.assign || function (target) {
				for (var i = 1; i < arguments.length; i++) {
					var source = arguments[i];for (var key in source) {
						if (Object.prototype.hasOwnProperty.call(source, key)) {
							target[key] = source[key];
						}
					}
				}return target;
			};

			var _createClass = function () {
				function defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
					}
				}return function (Constructor, protoProps, staticProps) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
				};
			}();

			var _desc, _value, _class;

			var _react = __webpack_require__( /*! react */15);

			var _react2 = _interopRequireDefault(_react);

			var _reactMotion = __webpack_require__( /*! react-motion */163);

			var _autobind = __webpack_require__( /*! core-decorators/lib/autobind */6);

			var _autobind2 = _interopRequireDefault(_autobind);

			var _utils = __webpack_require__( /*! ./utils */25);

			var _styles = __webpack_require__( /*! ./styles.css */23);

			var _styles2 = _interopRequireDefault(_styles);

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { default: obj };
			}

			function _classCallCheck(instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			}

			function _possibleConstructorReturn(self, call) {
				if (!self) {
					throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
				}return call && (typeof call === "object" || typeof call === "function") ? call : self;
			}

			function _inherits(subClass, superClass) {
				if (typeof superClass !== "function" && superClass !== null) {
					throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
				}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
			}

			function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
				var desc = {};
				Object['ke' + 'ys'](descriptor).forEach(function (key) {
					desc[key] = descriptor[key];
				});
				desc.enumerable = !!desc.enumerable;
				desc.configurable = !!desc.configurable;

				if ('value' in desc || desc.initializer) {
					desc.writable = true;
				}

				desc = decorators.slice().reverse().reduce(function (desc, decorator) {
					return decorator(target, property, desc) || desc;
				}, desc);

				if (context && desc.initializer !== void 0) {
					desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
					desc.initializer = undefined;
				}

				if (desc.initializer === void 0) {
					Object['define' + 'Property'](target, property, desc);
					desc = null;
				}

				return desc;
			}

			var Tile = (_class = function (_Component) {
				_inherits(Tile, _Component);

				function Tile() {
					_classCallCheck(this, Tile);

					return _possibleConstructorReturn(this, (Tile.__proto__ || Object.getPrototypeOf(Tile)).apply(this, arguments));
				}

				_createClass(Tile, [{
					key: 'handleClick',
					value: function handleClick() {
						var _props = this.props,
						    index = _props.index,
						    onClick = _props.onClick;

						onClick(index);
					}
				}, {
					key: 'render',
					value: function render() {
						var _this2 = this;

						var _props2 = this.props,
						    index = _props2.index,
						    number = _props2.number,
						    rows = _props2.rows,
						    cols = _props2.cols,
						    hole = _props2.hole,
						    width = _props2.width,
						    height = _props2.height,
						    margin = _props2.margin,
						    color = _props2.color,
						    src = _props2.src;

						var tileWidth = Math.round(width / cols);
						var tileHeight = Math.round(height / rows);
						var numberMatrixPos = (0, _utils.getMatrixPosition)(number, rows, cols);
						var numberVisualPos = (0, _utils.getVisualPosition)(numberMatrixPos, tileWidth, tileHeight, margin);
						var indexMatrixPos = (0, _utils.getMatrixPosition)(index, rows, cols);
						var indexVisualPos = (0, _utils.getVisualPosition)(indexMatrixPos, tileWidth, tileHeight, margin);

						var motionStyle = {
							translateX: (0, _reactMotion.spring)(indexVisualPos.x),
							translateY: (0, _reactMotion.spring)(indexVisualPos.y)
						};
						var sizeStyle = {
							width: tileWidth - margin * 2,
							height: tileHeight - margin * 2,
							fontSize: Math.min(tileWidth, tileHeight) / 4,
							padding: Math.min(tileWidth, tileHeight) / 8,
							backgroundColor: color,
							backgroundImage: !!src && 'url(' + src + ')',
							backgroundSize: !!src && width + 'px ' + height + 'px',
							backgroundPosition: !!src && -numberVisualPos.x + 'px ' + -numberVisualPos.y + 'px'
						};

						return _react2.default.createElement(_reactMotion.Motion, { style: motionStyle }, function (_ref) {
							var translateX = _ref.translateX,
							    translateY = _ref.translateY;
							return _react2.default.createElement('li', { className: _styles2.default[number === hole ? 'tileWithHole' : 'tile'],
								style: _extends({}, sizeStyle, { transform: 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0)' }),
								onClick: _this2.handleClick
							}, number + 1);
						});
					}
				}]);

				return Tile;
			}(_react.Component), _applyDecoratedDescriptor(_class.prototype, 'handleClick', [_autobind2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleClick'), _class.prototype), _class);
			Tile.propTypes = {
				index: _react.PropTypes.number.isRequired,
				number: _react.PropTypes.number.isRequired,
				rows: _react.PropTypes.number.isRequired,
				cols: _react.PropTypes.number.isRequired,
				hole: _react.PropTypes.number.isRequired,
				width: _react.PropTypes.number.isRequired,
				height: _react.PropTypes.number.isRequired,
				margin: _react.PropTypes.number.isRequired,
				color: _react.PropTypes.string,
				src: _react.PropTypes.string,
				onClick: _react.PropTypes.func.isRequired
			};
			exports.default = Tile;

			/***/
		},
		/* 54 */
		/*!******************************!*\
    !*** ./src/sliding/tiles.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			exports.default = undefined;

			var _extends = Object.assign || function (target) {
				for (var i = 1; i < arguments.length; i++) {
					var source = arguments[i];for (var key in source) {
						if (Object.prototype.hasOwnProperty.call(source, key)) {
							target[key] = source[key];
						}
					}
				}return target;
			};

			var _createClass = function () {
				function defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
					}
				}return function (Constructor, protoProps, staticProps) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
				};
			}();

			var _desc, _value, _class;

			var _react = __webpack_require__( /*! react */15);

			var _react2 = _interopRequireDefault(_react);

			var _autobind = __webpack_require__( /*! core-decorators/lib/autobind */6);

			var _autobind2 = _interopRequireDefault(_autobind);

			var _tile = __webpack_require__( /*! ./tile */53);

			var _tile2 = _interopRequireDefault(_tile);

			var _styles = __webpack_require__( /*! ./styles.css */23);

			var _styles2 = _interopRequireDefault(_styles);

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { default: obj };
			}

			function _classCallCheck(instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			}

			function _possibleConstructorReturn(self, call) {
				if (!self) {
					throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
				}return call && (typeof call === "object" || typeof call === "function") ? call : self;
			}

			function _inherits(subClass, superClass) {
				if (typeof superClass !== "function" && superClass !== null) {
					throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
				}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
			}

			function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
				var desc = {};
				Object['ke' + 'ys'](descriptor).forEach(function (key) {
					desc[key] = descriptor[key];
				});
				desc.enumerable = !!desc.enumerable;
				desc.configurable = !!desc.configurable;

				if ('value' in desc || desc.initializer) {
					desc.writable = true;
				}

				desc = decorators.slice().reverse().reduce(function (desc, decorator) {
					return decorator(target, property, desc) || desc;
				}, desc);

				if (context && desc.initializer !== void 0) {
					desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
					desc.initializer = undefined;
				}

				if (desc.initializer === void 0) {
					Object['define' + 'Property'](target, property, desc);
					desc = null;
				}

				return desc;
			}

			var Tiles = (_class = function (_Component) {
				_inherits(Tiles, _Component);

				function Tiles() {
					_classCallCheck(this, Tiles);

					return _possibleConstructorReturn(this, (Tiles.__proto__ || Object.getPrototypeOf(Tiles)).apply(this, arguments));
				}

				_createClass(Tiles, [{
					key: 'handleTileClick',
					value: function handleTileClick(index) {
						var onClick = this.props.onClick;

						if (onClick) {
							onClick(index);
						}
					}
				}, {
					key: 'render',
					value: function render() {
						var _this2 = this;

						var _props = this.props,
						    numbers = _props.numbers,
						    width = _props.width,
						    height = _props.height,
						    src = _props.src,
						    showNumbers = _props.showNumbers,
						    showOriginal = _props.showOriginal;

						var sizeStyle = {
							width: width,
							height: height
						};

						return _react2.default.createElement('div', { className: _styles2.default.container, style: sizeStyle }, _react2.default.createElement('ul', { className: _styles2.default[showNumbers ? 'tilesWithNumbers' : 'tiles'], style: sizeStyle }, numbers.map(function (number, index) {
							return _react2.default.createElement(_tile2.default, _extends({}, _this2.props, {
								key: number,
								number: number,
								index: index,
								onClick: _this2.handleTileClick
							}));
						})), !!src && _react2.default.createElement('img', { className: _styles2.default[showOriginal ? 'backgroundWithOriginal' : 'background'],
							style: sizeStyle,
							src: src
						}));
					}
				}]);

				return Tiles;
			}(_react.Component), _applyDecoratedDescriptor(_class.prototype, 'handleTileClick', [_autobind2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTileClick'), _class.prototype), _class);
			Tiles.propTypes = {
				numbers: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired,
				rows: _react.PropTypes.number.isRequired,
				cols: _react.PropTypes.number.isRequired,
				hole: _react.PropTypes.number.isRequired,
				width: _react.PropTypes.number.isRequired,
				height: _react.PropTypes.number.isRequired,
				margin: _react.PropTypes.number.isRequired,
				color: _react.PropTypes.string,
				src: _react.PropTypes.string,
				showNumbers: _react.PropTypes.bool,
				showOriginal: _react.PropTypes.bool,
				onClick: _react.PropTypes.func
			};
			exports.default = Tiles;

			/***/
		},
		/* 55 */
		/*!********************************!*\
    !*** ./src/sliding/wrapper.js ***!
    \********************************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			exports.default = undefined;

			var _createClass = function () {
				function defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
					}
				}return function (Constructor, protoProps, staticProps) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
				};
			}();

			var _desc, _value, _class;

			var _react = __webpack_require__( /*! react */15);

			var _react2 = _interopRequireDefault(_react);

			var _autobind = __webpack_require__( /*! core-decorators/lib/autobind */6);

			var _autobind2 = _interopRequireDefault(_autobind);

			var _clamp = __webpack_require__( /*! lodash/clamp */44);

			var _clamp2 = _interopRequireDefault(_clamp);

			var _range = __webpack_require__( /*! lodash/range */156);

			var _range2 = _interopRequireDefault(_range);

			var _tiles = __webpack_require__( /*! ./tiles */54);

			var _tiles2 = _interopRequireDefault(_tiles);

			var _utils = __webpack_require__( /*! ./utils */25);

			var _styles = __webpack_require__( /*! ./styles.css */23);

			var _styles2 = _interopRequireDefault(_styles);

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { default: obj };
			}

			function _classCallCheck(instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			}

			function _possibleConstructorReturn(self, call) {
				if (!self) {
					throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
				}return call && (typeof call === "object" || typeof call === "function") ? call : self;
			}

			function _inherits(subClass, superClass) {
				if (typeof superClass !== "function" && superClass !== null) {
					throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
				}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
			}

			function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
				var desc = {};
				Object['ke' + 'ys'](descriptor).forEach(function (key) {
					desc[key] = descriptor[key];
				});
				desc.enumerable = !!desc.enumerable;
				desc.configurable = !!desc.configurable;

				if ('value' in desc || desc.initializer) {
					desc.writable = true;
				}

				desc = decorators.slice().reverse().reduce(function (desc, decorator) {
					return decorator(target, property, desc) || desc;
				}, desc);

				if (context && desc.initializer !== void 0) {
					desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
					desc.initializer = undefined;
				}

				if (desc.initializer === void 0) {
					Object['define' + 'Property'](target, property, desc);
					desc = null;
				}

				return desc;
			}

			var Wrapper = (_class = function (_Component) {
				_inherits(Wrapper, _Component);

				function Wrapper(props) {
					_classCallCheck(this, Wrapper);

					var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props));

					var _this$props = _this.props,
					    rows = _this$props.rows,
					    cols = _this$props.cols;

					_this.state = { numbers: (0, _range2.default)(0, rows * cols), solved: true };
					return _this;
				}

				_createClass(Wrapper, [{
					key: 'handleImageRef',
					value: function handleImageRef(image) {
						this._image = image;
					}
				}, {
					key: 'handleImageLoad',
					value: function handleImageLoad() {
						var _image = this._image,
						    naturalWidth = _image.naturalWidth,
						    naturalHeight = _image.naturalHeight;
						var _props = this.props,
						    minWidth = _props.minWidth,
						    minHeight = _props.minHeight,
						    maxWidth = _props.maxWidth,
						    maxHeight = _props.maxHeight,
						    onLoad = _props.onLoad;

						var clampedWidth = (0, _clamp2.default)(naturalWidth, minWidth, maxWidth);
						var clampedHeight = (0, _clamp2.default)(naturalHeight, minHeight, maxHeight);
						var ratioWidth = clampedWidth / naturalWidth;
						var ratioHeight = clampedHeight / naturalHeight;
						var ratio = Math.min(ratioWidth, ratioHeight);
						var resizedWidth = Math.round(naturalWidth * ratio);
						var resizedHeight = Math.round(naturalHeight * ratio);

						this.setState({ width: resizedWidth, height: resizedHeight });

						if (onLoad) {
							onLoad();
						}
					}
				}, {
					key: 'handleTileClick',
					value: function handleTileClick(index) {
						this.swap(index);
					}
				}, {
					key: 'swap',
					value: function swap(tileIndex) {
						var _props2 = this.props,
						    rows = _props2.rows,
						    cols = _props2.cols,
						    hole = _props2.hole,
						    onMove = _props2.onMove,
						    onSolve = _props2.onSolve;
						var _state = this.state,
						    numbers = _state.numbers,
						    solved = _state.solved;

						var holeIndex = numbers.indexOf(hole);

						if (solved) {
							return;
						}

						if ((0, _utils.canSwapNumbers)(tileIndex, holeIndex, rows, cols)) {
							var newNumbers = (0, _utils.swapNumbers)(numbers, tileIndex, holeIndex);
							var newSolved = (0, _utils.isSolved)(newNumbers);
							this.setState({ numbers: newNumbers, solved: newSolved });

							if (onMove) {
								onMove();
							}

							if (newSolved && onSolve) {
								onSolve();
							}
						}
					}
				}, {
					key: 'shuffle',
					value: function shuffle() {
						var _props3 = this.props,
						    rows = _props3.rows,
						    cols = _props3.cols,
						    hole = _props3.hole;
						var numbers = this.state.numbers;

						var shuffledNumbers = (0, _utils.shuffleNumbers)(numbers, rows, cols, hole);
						this.setState({ numbers: shuffledNumbers, solved: false });
					}
				}, {
					key: 'render',
					value: function render() {
						var _state2 = this.state,
						    numbers = _state2.numbers,
						    width = _state2.width,
						    height = _state2.height;
						var _props4 = this.props,
						    rows = _props4.rows,
						    cols = _props4.cols,
						    hole = _props4.hole,
						    minWidth = _props4.minWidth,
						    minHeight = _props4.minHeight,
						    margin = _props4.margin;
						var _props5 = this.props,
						    src = _props5.src,
						    color = _props5.color,
						    showNumbers = _props5.showNumbers,
						    showOriginal = _props5.showOriginal,
						    onError = _props5.onError;

						var finalWidth = Math.round((width || minWidth) / cols) * cols;
						var finalHeight = Math.round((height || minHeight) / rows) * rows;

						var sizeStyle = {
							width: finalWidth,
							height: finalHeight
						};

						return _react2.default.createElement('div', { className: _styles2.default.container, style: sizeStyle }, (!src || !!width && !!height) && _react2.default.createElement(_tiles2.default, {
							numbers: numbers,
							rows: rows,
							cols: cols,
							hole: hole,
							width: finalWidth,
							height: finalHeight,
							margin: margin,
							color: color,
							src: src,
							showNumbers: !!showNumbers,
							showOriginal: !!showOriginal,
							onClick: this.handleTileClick
						}), !!src && _react2.default.createElement('img', { className: _styles2.default.hidden,
							src: src,
							ref: this.handleImageRef,
							onLoad: this.handleImageLoad,
							onError: onError
						}));
					}
				}]);

				return Wrapper;
			}(_react.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleImageRef', [_autobind2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleImageRef'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleImageLoad', [_autobind2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleImageLoad'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTileClick', [_autobind2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTileClick'), _class.prototype)), _class);
			Wrapper.propTypes = {
				rows: _react.PropTypes.number,
				cols: _react.PropTypes.number,
				hole: _react.PropTypes.number,
				minWidth: _react.PropTypes.number,
				minHeight: _react.PropTypes.number,
				maxWidth: _react.PropTypes.number,
				maxHeight: _react.PropTypes.number,
				margin: _react.PropTypes.number,
				color: _react.PropTypes.string,
				src: _react.PropTypes.string,
				showNumbers: _react.PropTypes.bool,
				showOriginal: _react.PropTypes.bool,
				onLoad: _react.PropTypes.func,
				onMove: _react.PropTypes.func,
				onSolve: _react.PropTypes.func,
				onError: _react.PropTypes.func
			};
			exports.default = Wrapper;

			/***/
		},
		/* 56 */
		/*!**************************************************!*\
    !*** ./~/core-decorators/lib/lazy-initialize.js ***!
    \**************************************************/
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			Object.defineProperty(exports, '__esModule', {
				value: true
			});
			exports['default'] = lazyInitialize;

			var _privateUtils = __webpack_require__( /*! ./private/utils */26);

			var defineProperty = Object.defineProperty;

			function handleDescriptor(target, key, descriptor) {
				var configurable = descriptor.configurable;
				var enumerable = descriptor.enumerable;
				var initializer = descriptor.initializer;
				var value = descriptor.value;

				return {
					configurable: configurable,
					enumerable: enumerable,

					get: function get() {
						// This happens if someone accesses the
						// property directly on the prototype
						if (this === target) {
							return;
						}

						var ret = initializer ? initializer.call(this) : value;

						defineProperty(this, key, {
							configurable: configurable,
							enumerable: enumerable,
							writable: true,
							value: ret
						});

						return ret;
					},

					set: (0, _privateUtils.createDefaultSetter)(key)
				};
			}

			function lazyInitialize() {
				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}

				return (0, _privateUtils.decorate)(handleDescriptor, args);
			}

			module.exports = exports['default'];

			/***/
		},
		/* 57 */
		/*!*******************************************************!*\
    !*** ./~/css-loader?modules!./src/sliding/styles.css ***!
    \*******************************************************/
		/***/function (module, exports, __webpack_require__) {

			exports = module.exports = __webpack_require__( /*! ./../../~/css-loader/lib/css-base.js */58)();
			// imports


			// module
			exports.push([module.id, "._3TN9baOvkXxdh5NDhbo_cq {\n  position: relative;\n  margin: 0 auto;\n}\n\n._1-0tGUggRRlARE07iJ_Wmt {\n  display: none;\n}\n\n._3NrMR0zYBMWrqKfv3bSFeU {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  opacity: .1;\n  transition: all .6s ease-in-out;\n}\n._18cdhdYQHXXoblafJWEPA8 {\n  z-index: 3;\n  opacity: 1;\n}\n\n._2EDN-NuqH6MCJwmK3xkR61 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  color: transparent;\n  list-style: none;\n  transition: all .2s ease-in-out;\n}\n._1df_LDRhF6TZ-E8lprI3YC {\n  color: white;\n  text-shadow: 0 0 4px rgba(0,0,0, .15);\n}\n\n._2pCaKivXm5HZ24WUHT_9B3 {\n  position: absolute;\n  display: block;\n  box-sizing: border-box;\n  margin: 0;\n  cursor: pointer;\n  box-shadow: inset 0 0 4px 0 rgba(0,0,0, .15);\n}\n._2AYm_jvSTI-dIMqVGR2uEv {\n  cursor: default;\n  opacity: 0;\n}\n", ""]);

			// exports
			exports.locals = {
				"container": "_3TN9baOvkXxdh5NDhbo_cq",
				"hidden": "_1-0tGUggRRlARE07iJ_Wmt",
				"background": "_3NrMR0zYBMWrqKfv3bSFeU",
				"backgroundWithOriginal": "_18cdhdYQHXXoblafJWEPA8 _3NrMR0zYBMWrqKfv3bSFeU",
				"tiles": "_2EDN-NuqH6MCJwmK3xkR61",
				"tilesWithNumbers": "_1df_LDRhF6TZ-E8lprI3YC _2EDN-NuqH6MCJwmK3xkR61",
				"tile": "_2pCaKivXm5HZ24WUHT_9B3",
				"tileWithHole": "_2AYm_jvSTI-dIMqVGR2uEv _2pCaKivXm5HZ24WUHT_9B3"
			};

			/***/
		},
		/* 58 */
		/*!**************************************!*\
    !*** ./~/css-loader/lib/css-base.js ***!
    \**************************************/
		/***/function (module, exports) {

			/*
   	MIT License http://www.opensource.org/licenses/mit-license.php
   	Author Tobias Koppers @sokra
   */
			// css base code, injected by the css-loader
			module.exports = function () {
				var list = [];

				// return the list of modules as css string
				list.toString = function toString() {
					var result = [];
					for (var i = 0; i < this.length; i++) {
						var item = this[i];
						if (item[2]) {
							result.push("@media " + item[2] + "{" + item[1] + "}");
						} else {
							result.push(item[1]);
						}
					}
					return result.join("");
				};

				// import a list of modules into the list
				list.i = function (modules, mediaQuery) {
					if (typeof modules === "string") modules = [[null, modules, ""]];
					var alreadyImportedModules = {};
					for (var i = 0; i < this.length; i++) {
						var id = this[i][0];
						if (typeof id === "number") alreadyImportedModules[id] = true;
					}
					for (i = 0; i < modules.length; i++) {
						var item = modules[i];
						// skip already imported module
						// this implementation is not 100% perfect for weird media query combinations
						//  when a module is imported multiple times with different media queries.
						//  I hope this will never occur (Hey this way we have smaller bundles)
						if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
							if (mediaQuery && !item[2]) {
								item[2] = mediaQuery;
							} else if (mediaQuery) {
								item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
							}
							list.push(item);
						}
					}
				};
				return list;
			};

			/***/
		},
		/* 59 */
		/*!*******************************!*\
    !*** ./~/lodash/_DataView.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var getNative = __webpack_require__( /*! ./_getNative */2),
			    root = __webpack_require__( /*! ./_root */1);

			/* Built-in method references that are verified to be native. */
			var DataView = getNative(root, 'DataView');

			module.exports = DataView;

			/***/
		},
		/* 60 */
		/*!***************************!*\
    !*** ./~/lodash/_Hash.js ***!
    \***************************/
		/***/function (module, exports, __webpack_require__) {

			var hashClear = __webpack_require__( /*! ./_hashClear */112),
			    hashDelete = __webpack_require__( /*! ./_hashDelete */113),
			    hashGet = __webpack_require__( /*! ./_hashGet */114),
			    hashHas = __webpack_require__( /*! ./_hashHas */115),
			    hashSet = __webpack_require__( /*! ./_hashSet */116);

			/**
    * Creates a hash object.
    *
    * @private
    * @constructor
    * @param {Array} [entries] The key-value pairs to cache.
    */
			function Hash(entries) {
				var index = -1,
				    length = entries == null ? 0 : entries.length;

				this.clear();
				while (++index < length) {
					var entry = entries[index];
					this.set(entry[0], entry[1]);
				}
			}

			// Add methods to `Hash`.
			Hash.prototype.clear = hashClear;
			Hash.prototype['delete'] = hashDelete;
			Hash.prototype.get = hashGet;
			Hash.prototype.has = hashHas;
			Hash.prototype.set = hashSet;

			module.exports = Hash;

			/***/
		},
		/* 61 */
		/*!******************************!*\
    !*** ./~/lodash/_Promise.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			var getNative = __webpack_require__( /*! ./_getNative */2),
			    root = __webpack_require__( /*! ./_root */1);

			/* Built-in method references that are verified to be native. */
			var Promise = getNative(root, 'Promise');

			module.exports = Promise;

			/***/
		},
		/* 62 */
		/*!**************************!*\
    !*** ./~/lodash/_Set.js ***!
    \**************************/
		/***/function (module, exports, __webpack_require__) {

			var getNative = __webpack_require__( /*! ./_getNative */2),
			    root = __webpack_require__( /*! ./_root */1);

			/* Built-in method references that are verified to be native. */
			var Set = getNative(root, 'Set');

			module.exports = Set;

			/***/
		},
		/* 63 */
		/*!*******************************!*\
    !*** ./~/lodash/_SetCache.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var MapCache = __webpack_require__( /*! ./_MapCache */27),
			    setCacheAdd = __webpack_require__( /*! ./_setCacheAdd */139),
			    setCacheHas = __webpack_require__( /*! ./_setCacheHas */140);

			/**
    *
    * Creates an array cache object to store unique values.
    *
    * @private
    * @constructor
    * @param {Array} [values] The values to cache.
    */
			function SetCache(values) {
				var index = -1,
				    length = values == null ? 0 : values.length;

				this.__data__ = new MapCache();
				while (++index < length) {
					this.add(values[index]);
				}
			}

			// Add methods to `SetCache`.
			SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
			SetCache.prototype.has = setCacheHas;

			module.exports = SetCache;

			/***/
		},
		/* 64 */
		/*!****************************!*\
    !*** ./~/lodash/_Stack.js ***!
    \****************************/
		/***/function (module, exports, __webpack_require__) {

			var ListCache = __webpack_require__( /*! ./_ListCache */7),
			    stackClear = __webpack_require__( /*! ./_stackClear */144),
			    stackDelete = __webpack_require__( /*! ./_stackDelete */145),
			    stackGet = __webpack_require__( /*! ./_stackGet */146),
			    stackHas = __webpack_require__( /*! ./_stackHas */147),
			    stackSet = __webpack_require__( /*! ./_stackSet */148);

			/**
    * Creates a stack cache object to store key-value pairs.
    *
    * @private
    * @constructor
    * @param {Array} [entries] The key-value pairs to cache.
    */
			function Stack(entries) {
				var data = this.__data__ = new ListCache(entries);
				this.size = data.size;
			}

			// Add methods to `Stack`.
			Stack.prototype.clear = stackClear;
			Stack.prototype['delete'] = stackDelete;
			Stack.prototype.get = stackGet;
			Stack.prototype.has = stackHas;
			Stack.prototype.set = stackSet;

			module.exports = Stack;

			/***/
		},
		/* 65 */
		/*!*********************************!*\
    !*** ./~/lodash/_Uint8Array.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var root = __webpack_require__( /*! ./_root */1);

			/** Built-in value references. */
			var Uint8Array = root.Uint8Array;

			module.exports = Uint8Array;

			/***/
		},
		/* 66 */
		/*!******************************!*\
    !*** ./~/lodash/_WeakMap.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			var getNative = __webpack_require__( /*! ./_getNative */2),
			    root = __webpack_require__( /*! ./_root */1);

			/* Built-in method references that are verified to be native. */
			var WeakMap = getNative(root, 'WeakMap');

			module.exports = WeakMap;

			/***/
		},
		/* 67 */
		/*!**********************************!*\
    !*** ./~/lodash/_addMapEntry.js ***!
    \**********************************/
		/***/function (module, exports) {

			/**
    * Adds the key-value `pair` to `map`.
    *
    * @private
    * @param {Object} map The map to modify.
    * @param {Array} pair The key-value pair to add.
    * @returns {Object} Returns `map`.
    */
			function addMapEntry(map, pair) {
				// Don't return `map.set` because it's not chainable in IE 11.
				map.set(pair[0], pair[1]);
				return map;
			}

			module.exports = addMapEntry;

			/***/
		},
		/* 68 */
		/*!**********************************!*\
    !*** ./~/lodash/_addSetEntry.js ***!
    \**********************************/
		/***/function (module, exports) {

			/**
    * Adds `value` to `set`.
    *
    * @private
    * @param {Object} set The set to modify.
    * @param {*} value The value to add.
    * @returns {Object} Returns `set`.
    */
			function addSetEntry(set, value) {
				// Don't return `set.add` because it's not chainable in IE 11.
				set.add(value);
				return set;
			}

			module.exports = addSetEntry;

			/***/
		},
		/* 69 */
		/*!****************************!*\
    !*** ./~/lodash/_apply.js ***!
    \****************************/
		/***/function (module, exports) {

			/**
    * A faster alternative to `Function#apply`, this function invokes `func`
    * with the `this` binding of `thisArg` and the arguments of `args`.
    *
    * @private
    * @param {Function} func The function to invoke.
    * @param {*} thisArg The `this` binding of `func`.
    * @param {Array} args The arguments to invoke `func` with.
    * @returns {*} Returns the result of `func`.
    */
			function apply(func, thisArg, args) {
				switch (args.length) {
					case 0:
						return func.call(thisArg);
					case 1:
						return func.call(thisArg, args[0]);
					case 2:
						return func.call(thisArg, args[0], args[1]);
					case 3:
						return func.call(thisArg, args[0], args[1], args[2]);
				}
				return func.apply(thisArg, args);
			}

			module.exports = apply;

			/***/
		},
		/* 70 */
		/*!********************************!*\
    !*** ./~/lodash/_arrayEach.js ***!
    \********************************/
		/***/function (module, exports) {

			/**
    * A specialized version of `_.forEach` for arrays without support for
    * iteratee shorthands.
    *
    * @private
    * @param {Array} [array] The array to iterate over.
    * @param {Function} iteratee The function invoked per iteration.
    * @returns {Array} Returns `array`.
    */
			function arrayEach(array, iteratee) {
				var index = -1,
				    length = array == null ? 0 : array.length;

				while (++index < length) {
					if (iteratee(array[index], index, array) === false) {
						break;
					}
				}
				return array;
			}

			module.exports = arrayEach;

			/***/
		},
		/* 71 */
		/*!************************************!*\
    !*** ./~/lodash/_arrayIncludes.js ***!
    \************************************/
		/***/function (module, exports, __webpack_require__) {

			var baseIndexOf = __webpack_require__( /*! ./_baseIndexOf */81);

			/**
    * A specialized version of `_.includes` for arrays without support for
    * specifying an index to search from.
    *
    * @private
    * @param {Array} [array] The array to inspect.
    * @param {*} target The value to search for.
    * @returns {boolean} Returns `true` if `target` is found, else `false`.
    */
			function arrayIncludes(array, value) {
				var length = array == null ? 0 : array.length;
				return !!length && baseIndexOf(array, value, 0) > -1;
			}

			module.exports = arrayIncludes;

			/***/
		},
		/* 72 */
		/*!****************************************!*\
    !*** ./~/lodash/_arrayIncludesWith.js ***!
    \****************************************/
		/***/function (module, exports) {

			/**
    * This function is like `arrayIncludes` except that it accepts a comparator.
    *
    * @private
    * @param {Array} [array] The array to inspect.
    * @param {*} target The value to search for.
    * @param {Function} comparator The comparator invoked per element.
    * @returns {boolean} Returns `true` if `target` is found, else `false`.
    */
			function arrayIncludesWith(array, value, comparator) {
				var index = -1,
				    length = array == null ? 0 : array.length;

				while (++index < length) {
					if (comparator(value, array[index])) {
						return true;
					}
				}
				return false;
			}

			module.exports = arrayIncludesWith;

			/***/
		},
		/* 73 */
		/*!***********************************!*\
    !*** ./~/lodash/_arrayShuffle.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var copyArray = __webpack_require__( /*! ./_copyArray */36),
			    shuffleSelf = __webpack_require__( /*! ./_shuffleSelf */42);

			/**
    * A specialized version of `_.shuffle` for arrays.
    *
    * @private
    * @param {Array} array The array to shuffle.
    * @returns {Array} Returns the new shuffled array.
    */
			function arrayShuffle(array) {
				return shuffleSelf(copyArray(array));
			}

			module.exports = arrayShuffle;

			/***/
		},
		/* 74 */
		/*!*********************************!*\
    !*** ./~/lodash/_baseAssign.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var copyObject = __webpack_require__( /*! ./_copyObject */9),
			    keys = __webpack_require__( /*! ./keys */14);

			/**
    * The base implementation of `_.assign` without support for multiple sources
    * or `customizer` functions.
    *
    * @private
    * @param {Object} object The destination object.
    * @param {Object} source The source object.
    * @returns {Object} Returns `object`.
    */
			function baseAssign(object, source) {
				return object && copyObject(source, keys(source), object);
			}

			module.exports = baseAssign;

			/***/
		},
		/* 75 */
		/*!***********************************!*\
    !*** ./~/lodash/_baseAssignIn.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var copyObject = __webpack_require__( /*! ./_copyObject */9),
			    keysIn = __webpack_require__( /*! ./keysIn */49);

			/**
    * The base implementation of `_.assignIn` without support for multiple sources
    * or `customizer` functions.
    *
    * @private
    * @param {Object} object The destination object.
    * @param {Object} source The source object.
    * @returns {Object} Returns `object`.
    */
			function baseAssignIn(object, source) {
				return object && copyObject(source, keysIn(source), object);
			}

			module.exports = baseAssignIn;

			/***/
		},
		/* 76 */
		/*!********************************!*\
    !*** ./~/lodash/_baseClamp.js ***!
    \********************************/
		/***/function (module, exports) {

			/**
    * The base implementation of `_.clamp` which doesn't coerce arguments.
    *
    * @private
    * @param {number} number The number to clamp.
    * @param {number} [lower] The lower bound.
    * @param {number} upper The upper bound.
    * @returns {number} Returns the clamped number.
    */
			function baseClamp(number, lower, upper) {
				if (number === number) {
					if (upper !== undefined) {
						number = number <= upper ? number : upper;
					}
					if (lower !== undefined) {
						number = number >= lower ? number : lower;
					}
				}
				return number;
			}

			module.exports = baseClamp;

			/***/
		},
		/* 77 */
		/*!********************************!*\
    !*** ./~/lodash/_baseClone.js ***!
    \********************************/
		/***/function (module, exports, __webpack_require__) {

			var Stack = __webpack_require__( /*! ./_Stack */64),
			    arrayEach = __webpack_require__( /*! ./_arrayEach */70),
			    assignValue = __webpack_require__( /*! ./_assignValue */32),
			    baseAssign = __webpack_require__( /*! ./_baseAssign */74),
			    baseAssignIn = __webpack_require__( /*! ./_baseAssignIn */75),
			    cloneBuffer = __webpack_require__( /*! ./_cloneBuffer */96),
			    copyArray = __webpack_require__( /*! ./_copyArray */36),
			    copySymbols = __webpack_require__( /*! ./_copySymbols */103),
			    copySymbolsIn = __webpack_require__( /*! ./_copySymbolsIn */104),
			    getAllKeys = __webpack_require__( /*! ./_getAllKeys */107),
			    getAllKeysIn = __webpack_require__( /*! ./_getAllKeysIn */108),
			    getTag = __webpack_require__( /*! ./_getTag */110),
			    initCloneArray = __webpack_require__( /*! ./_initCloneArray */117),
			    initCloneByTag = __webpack_require__( /*! ./_initCloneByTag */118),
			    initCloneObject = __webpack_require__( /*! ./_initCloneObject */119),
			    isArray = __webpack_require__( /*! ./isArray */12),
			    isBuffer = __webpack_require__( /*! ./isBuffer */46),
			    isObject = __webpack_require__( /*! ./isObject */3),
			    keys = __webpack_require__( /*! ./keys */14);

			/** Used to compose bitmasks for cloning. */
			var CLONE_DEEP_FLAG = 1,
			    CLONE_FLAT_FLAG = 2,
			    CLONE_SYMBOLS_FLAG = 4;

			/** `Object#toString` result references. */
			var argsTag = '[object Arguments]',
			    arrayTag = '[object Array]',
			    boolTag = '[object Boolean]',
			    dateTag = '[object Date]',
			    errorTag = '[object Error]',
			    funcTag = '[object Function]',
			    genTag = '[object GeneratorFunction]',
			    mapTag = '[object Map]',
			    numberTag = '[object Number]',
			    objectTag = '[object Object]',
			    regexpTag = '[object RegExp]',
			    setTag = '[object Set]',
			    stringTag = '[object String]',
			    symbolTag = '[object Symbol]',
			    weakMapTag = '[object WeakMap]';

			var arrayBufferTag = '[object ArrayBuffer]',
			    dataViewTag = '[object DataView]',
			    float32Tag = '[object Float32Array]',
			    float64Tag = '[object Float64Array]',
			    int8Tag = '[object Int8Array]',
			    int16Tag = '[object Int16Array]',
			    int32Tag = '[object Int32Array]',
			    uint8Tag = '[object Uint8Array]',
			    uint8ClampedTag = '[object Uint8ClampedArray]',
			    uint16Tag = '[object Uint16Array]',
			    uint32Tag = '[object Uint32Array]';

			/** Used to identify `toStringTag` values supported by `_.clone`. */
			var cloneableTags = {};
			cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
			cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

			/**
    * The base implementation of `_.clone` and `_.cloneDeep` which tracks
    * traversed objects.
    *
    * @private
    * @param {*} value The value to clone.
    * @param {boolean} bitmask The bitmask flags.
    *  1 - Deep clone
    *  2 - Flatten inherited properties
    *  4 - Clone symbols
    * @param {Function} [customizer] The function to customize cloning.
    * @param {string} [key] The key of `value`.
    * @param {Object} [object] The parent object of `value`.
    * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
    * @returns {*} Returns the cloned value.
    */
			function baseClone(value, bitmask, customizer, key, object, stack) {
				var result,
				    isDeep = bitmask & CLONE_DEEP_FLAG,
				    isFlat = bitmask & CLONE_FLAT_FLAG,
				    isFull = bitmask & CLONE_SYMBOLS_FLAG;

				if (customizer) {
					result = object ? customizer(value, key, object, stack) : customizer(value);
				}
				if (result !== undefined) {
					return result;
				}
				if (!isObject(value)) {
					return value;
				}
				var isArr = isArray(value);
				if (isArr) {
					result = initCloneArray(value);
					if (!isDeep) {
						return copyArray(value, result);
					}
				} else {
					var tag = getTag(value),
					    isFunc = tag == funcTag || tag == genTag;

					if (isBuffer(value)) {
						return cloneBuffer(value, isDeep);
					}
					if (tag == objectTag || tag == argsTag || isFunc && !object) {
						result = isFlat || isFunc ? {} : initCloneObject(value);
						if (!isDeep) {
							return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
						}
					} else {
						if (!cloneableTags[tag]) {
							return object ? value : {};
						}
						result = initCloneByTag(value, tag, baseClone, isDeep);
					}
				}
				// Check for circular references and return its corresponding clone.
				stack || (stack = new Stack());
				var stacked = stack.get(value);
				if (stacked) {
					return stacked;
				}
				stack.set(value, result);

				var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;

				var props = isArr ? undefined : keysFunc(value);
				arrayEach(props || value, function (subValue, key) {
					if (props) {
						key = subValue;
						subValue = value[key];
					}
					// Recursively populate clone (susceptible to call stack limits).
					assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
				});
				return result;
			}

			module.exports = baseClone;

			/***/
		},
		/* 78 */
		/*!*********************************!*\
    !*** ./~/lodash/_baseCreate.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var isObject = __webpack_require__( /*! ./isObject */3);

			/** Built-in value references. */
			var objectCreate = Object.create;

			/**
    * The base implementation of `_.create` without support for assigning
    * properties to the created object.
    *
    * @private
    * @param {Object} proto The object to inherit from.
    * @returns {Object} Returns the new object.
    */
			var baseCreate = function () {
				function object() {}
				return function (proto) {
					if (!isObject(proto)) {
						return {};
					}
					if (objectCreate) {
						return objectCreate(proto);
					}
					object.prototype = proto;
					var result = new object();
					object.prototype = undefined;
					return result;
				};
			}();

			module.exports = baseCreate;

			/***/
		},
		/* 79 */
		/*!*************************************!*\
    !*** ./~/lodash/_baseDifference.js ***!
    \*************************************/
		/***/function (module, exports, __webpack_require__) {

			var SetCache = __webpack_require__( /*! ./_SetCache */63),
			    arrayIncludes = __webpack_require__( /*! ./_arrayIncludes */71),
			    arrayIncludesWith = __webpack_require__( /*! ./_arrayIncludesWith */72),
			    arrayMap = __webpack_require__( /*! ./_arrayMap */29),
			    baseUnary = __webpack_require__( /*! ./_baseUnary */35),
			    cacheHas = __webpack_require__( /*! ./_cacheHas */95);

			/** Used as the size to enable large array optimizations. */
			var LARGE_ARRAY_SIZE = 200;

			/**
    * The base implementation of methods like `_.difference` without support
    * for excluding multiple arrays or iteratee shorthands.
    *
    * @private
    * @param {Array} array The array to inspect.
    * @param {Array} values The values to exclude.
    * @param {Function} [iteratee] The iteratee invoked per element.
    * @param {Function} [comparator] The comparator invoked per element.
    * @returns {Array} Returns the new array of filtered values.
    */
			function baseDifference(array, values, iteratee, comparator) {
				var index = -1,
				    includes = arrayIncludes,
				    isCommon = true,
				    length = array.length,
				    result = [],
				    valuesLength = values.length;

				if (!length) {
					return result;
				}
				if (iteratee) {
					values = arrayMap(values, baseUnary(iteratee));
				}
				if (comparator) {
					includes = arrayIncludesWith;
					isCommon = false;
				} else if (values.length >= LARGE_ARRAY_SIZE) {
					includes = cacheHas;
					isCommon = false;
					values = new SetCache(values);
				}
				outer: while (++index < length) {
					var value = array[index],
					    computed = iteratee == null ? value : iteratee(value);

					value = comparator || value !== 0 ? value : 0;
					if (isCommon && computed === computed) {
						var valuesIndex = valuesLength;
						while (valuesIndex--) {
							if (values[valuesIndex] === computed) {
								continue outer;
							}
						}
						result.push(value);
					} else if (!includes(values, computed, comparator)) {
						result.push(value);
					}
				}
				return result;
			}

			module.exports = baseDifference;

			/***/
		},
		/* 80 */
		/*!************************************!*\
    !*** ./~/lodash/_baseFindIndex.js ***!
    \************************************/
		/***/function (module, exports) {

			/**
    * The base implementation of `_.findIndex` and `_.findLastIndex` without
    * support for iteratee shorthands.
    *
    * @private
    * @param {Array} array The array to inspect.
    * @param {Function} predicate The function invoked per iteration.
    * @param {number} fromIndex The index to search from.
    * @param {boolean} [fromRight] Specify iterating from right to left.
    * @returns {number} Returns the index of the matched value, else `-1`.
    */
			function baseFindIndex(array, predicate, fromIndex, fromRight) {
				var length = array.length,
				    index = fromIndex + (fromRight ? 1 : -1);

				while (fromRight ? index-- : ++index < length) {
					if (predicate(array[index], index, array)) {
						return index;
					}
				}
				return -1;
			}

			module.exports = baseFindIndex;

			/***/
		},
		/* 81 */
		/*!**********************************!*\
    !*** ./~/lodash/_baseIndexOf.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseFindIndex = __webpack_require__( /*! ./_baseFindIndex */80),
			    baseIsNaN = __webpack_require__( /*! ./_baseIsNaN */83),
			    strictIndexOf = __webpack_require__( /*! ./_strictIndexOf */149);

			/**
    * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
    *
    * @private
    * @param {Array} array The array to inspect.
    * @param {*} value The value to search for.
    * @param {number} fromIndex The index to search from.
    * @returns {number} Returns the index of the matched value, else `-1`.
    */
			function baseIndexOf(array, value, fromIndex) {
				return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
			}

			module.exports = baseIndexOf;

			/***/
		},
		/* 82 */
		/*!**************************************!*\
    !*** ./~/lodash/_baseIsArguments.js ***!
    \**************************************/
		/***/function (module, exports, __webpack_require__) {

			var baseGetTag = __webpack_require__( /*! ./_baseGetTag */4),
			    isObjectLike = __webpack_require__( /*! ./isObjectLike */5);

			/** `Object#toString` result references. */
			var argsTag = '[object Arguments]';

			/**
    * The base implementation of `_.isArguments`.
    *
    * @private
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is an `arguments` object,
    */
			function baseIsArguments(value) {
				return isObjectLike(value) && baseGetTag(value) == argsTag;
			}

			module.exports = baseIsArguments;

			/***/
		},
		/* 83 */
		/*!********************************!*\
    !*** ./~/lodash/_baseIsNaN.js ***!
    \********************************/
		/***/function (module, exports) {

			/**
    * The base implementation of `_.isNaN` without support for number objects.
    *
    * @private
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
    */
			function baseIsNaN(value) {
				return value !== value;
			}

			module.exports = baseIsNaN;

			/***/
		},
		/* 84 */
		/*!***********************************!*\
    !*** ./~/lodash/_baseIsNative.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var isFunction = __webpack_require__( /*! ./isFunction */47),
			    isMasked = __webpack_require__( /*! ./_isMasked */122),
			    isObject = __webpack_require__( /*! ./isObject */3),
			    toSource = __webpack_require__( /*! ./_toSource */43);

			/**
    * Used to match `RegExp`
    * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
    */
			var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

			/** Used to detect host constructors (Safari). */
			var reIsHostCtor = /^\[object .+?Constructor\]$/;

			/** Used for built-in method references. */
			var funcProto = Function.prototype,
			    objectProto = Object.prototype;

			/** Used to resolve the decompiled source of functions. */
			var funcToString = funcProto.toString;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/** Used to detect if a method is native. */
			var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

			/**
    * The base implementation of `_.isNative` without bad shim checks.
    *
    * @private
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is a native function,
    *  else `false`.
    */
			function baseIsNative(value) {
				if (!isObject(value) || isMasked(value)) {
					return false;
				}
				var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
				return pattern.test(toSource(value));
			}

			module.exports = baseIsNative;

			/***/
		},
		/* 85 */
		/*!***************************************!*\
    !*** ./~/lodash/_baseIsTypedArray.js ***!
    \***************************************/
		/***/function (module, exports, __webpack_require__) {

			var baseGetTag = __webpack_require__( /*! ./_baseGetTag */4),
			    isLength = __webpack_require__( /*! ./isLength */48),
			    isObjectLike = __webpack_require__( /*! ./isObjectLike */5);

			/** `Object#toString` result references. */
			var argsTag = '[object Arguments]',
			    arrayTag = '[object Array]',
			    boolTag = '[object Boolean]',
			    dateTag = '[object Date]',
			    errorTag = '[object Error]',
			    funcTag = '[object Function]',
			    mapTag = '[object Map]',
			    numberTag = '[object Number]',
			    objectTag = '[object Object]',
			    regexpTag = '[object RegExp]',
			    setTag = '[object Set]',
			    stringTag = '[object String]',
			    weakMapTag = '[object WeakMap]';

			var arrayBufferTag = '[object ArrayBuffer]',
			    dataViewTag = '[object DataView]',
			    float32Tag = '[object Float32Array]',
			    float64Tag = '[object Float64Array]',
			    int8Tag = '[object Int8Array]',
			    int16Tag = '[object Int16Array]',
			    int32Tag = '[object Int32Array]',
			    uint8Tag = '[object Uint8Array]',
			    uint8ClampedTag = '[object Uint8ClampedArray]',
			    uint16Tag = '[object Uint16Array]',
			    uint32Tag = '[object Uint32Array]';

			/** Used to identify `toStringTag` values of typed arrays. */
			var typedArrayTags = {};
			typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
			typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

			/**
    * The base implementation of `_.isTypedArray` without Node.js optimizations.
    *
    * @private
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
    */
			function baseIsTypedArray(value) {
				return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
			}

			module.exports = baseIsTypedArray;

			/***/
		},
		/* 86 */
		/*!*******************************!*\
    !*** ./~/lodash/_baseKeys.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var isPrototype = __webpack_require__( /*! ./_isPrototype */20),
			    nativeKeys = __webpack_require__( /*! ./_nativeKeys */134);

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/**
    * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
    *
    * @private
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of property names.
    */
			function baseKeys(object) {
				if (!isPrototype(object)) {
					return nativeKeys(object);
				}
				var result = [];
				for (var key in Object(object)) {
					if (hasOwnProperty.call(object, key) && key != 'constructor') {
						result.push(key);
					}
				}
				return result;
			}

			module.exports = baseKeys;

			/***/
		},
		/* 87 */
		/*!*********************************!*\
    !*** ./~/lodash/_baseKeysIn.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var isObject = __webpack_require__( /*! ./isObject */3),
			    isPrototype = __webpack_require__( /*! ./_isPrototype */20),
			    nativeKeysIn = __webpack_require__( /*! ./_nativeKeysIn */135);

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/**
    * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
    *
    * @private
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of property names.
    */
			function baseKeysIn(object) {
				if (!isObject(object)) {
					return nativeKeysIn(object);
				}
				var isProto = isPrototype(object),
				    result = [];

				for (var key in object) {
					if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
						result.push(key);
					}
				}
				return result;
			}

			module.exports = baseKeysIn;

			/***/
		},
		/* 88 */
		/*!*********************************!*\
    !*** ./~/lodash/_baseRandom.js ***!
    \*********************************/
		/***/function (module, exports) {

			/* Built-in method references for those with the same name as other `lodash` methods. */
			var nativeFloor = Math.floor,
			    nativeRandom = Math.random;

			/**
    * The base implementation of `_.random` without support for returning
    * floating-point numbers.
    *
    * @private
    * @param {number} lower The lower bound.
    * @param {number} upper The upper bound.
    * @returns {number} Returns the random number.
    */
			function baseRandom(lower, upper) {
				return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
			}

			module.exports = baseRandom;

			/***/
		},
		/* 89 */
		/*!********************************!*\
    !*** ./~/lodash/_baseRange.js ***!
    \********************************/
		/***/function (module, exports) {

			/* Built-in method references for those with the same name as other `lodash` methods. */
			var nativeCeil = Math.ceil,
			    nativeMax = Math.max;

			/**
    * The base implementation of `_.range` and `_.rangeRight` which doesn't
    * coerce arguments.
    *
    * @private
    * @param {number} start The start of the range.
    * @param {number} end The end of the range.
    * @param {number} step The value to increment or decrement by.
    * @param {boolean} [fromRight] Specify iterating from right to left.
    * @returns {Array} Returns the range of numbers.
    */
			function baseRange(start, end, step, fromRight) {
				var index = -1,
				    length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
				    result = Array(length);

				while (length--) {
					result[fromRight ? length : ++index] = start;
					start += step;
				}
				return result;
			}

			module.exports = baseRange;

			/***/
		},
		/* 90 */
		/*!*******************************!*\
    !*** ./~/lodash/_baseRest.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var identity = __webpack_require__( /*! ./identity */45),
			    overRest = __webpack_require__( /*! ./_overRest */138),
			    setToString = __webpack_require__( /*! ./_setToString */142);

			/**
    * The base implementation of `_.rest` which doesn't validate or coerce arguments.
    *
    * @private
    * @param {Function} func The function to apply a rest parameter to.
    * @param {number} [start=func.length-1] The start position of the rest parameter.
    * @returns {Function} Returns the new function.
    */
			function baseRest(func, start) {
				return setToString(overRest(func, start, identity), func + '');
			}

			module.exports = baseRest;

			/***/
		},
		/* 91 */
		/*!**************************************!*\
    !*** ./~/lodash/_baseSetToString.js ***!
    \**************************************/
		/***/function (module, exports, __webpack_require__) {

			var constant = __webpack_require__( /*! ./constant */151),
			    defineProperty = __webpack_require__( /*! ./_defineProperty */37),
			    identity = __webpack_require__( /*! ./identity */45);

			/**
    * The base implementation of `setToString` without support for hot loop shorting.
    *
    * @private
    * @param {Function} func The function to modify.
    * @param {Function} string The `toString` result.
    * @returns {Function} Returns `func`.
    */
			var baseSetToString = !defineProperty ? identity : function (func, string) {
				return defineProperty(func, 'toString', {
					'configurable': true,
					'enumerable': false,
					'value': constant(string),
					'writable': true
				});
			};

			module.exports = baseSetToString;

			/***/
		},
		/* 92 */
		/*!**********************************!*\
    !*** ./~/lodash/_baseShuffle.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var shuffleSelf = __webpack_require__( /*! ./_shuffleSelf */42),
			    values = __webpack_require__( /*! ./values */160);

			/**
    * The base implementation of `_.shuffle`.
    *
    * @private
    * @param {Array|Object} collection The collection to shuffle.
    * @returns {Array} Returns the new shuffled array.
    */
			function baseShuffle(collection) {
				return shuffleSelf(values(collection));
			}

			module.exports = baseShuffle;

			/***/
		},
		/* 93 */
		/*!********************************!*\
    !*** ./~/lodash/_baseTimes.js ***!
    \********************************/
		/***/function (module, exports) {

			/**
    * The base implementation of `_.times` without support for iteratee shorthands
    * or max array length checks.
    *
    * @private
    * @param {number} n The number of times to invoke `iteratee`.
    * @param {Function} iteratee The function invoked per iteration.
    * @returns {Array} Returns the array of results.
    */
			function baseTimes(n, iteratee) {
				var index = -1,
				    result = Array(n);

				while (++index < n) {
					result[index] = iteratee(index);
				}
				return result;
			}

			module.exports = baseTimes;

			/***/
		},
		/* 94 */
		/*!*********************************!*\
    !*** ./~/lodash/_baseValues.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var arrayMap = __webpack_require__( /*! ./_arrayMap */29);

			/**
    * The base implementation of `_.values` and `_.valuesIn` which creates an
    * array of `object` property values corresponding to the property names
    * of `props`.
    *
    * @private
    * @param {Object} object The object to query.
    * @param {Array} props The property names to get values for.
    * @returns {Object} Returns the array of property values.
    */
			function baseValues(object, props) {
				return arrayMap(props, function (key) {
					return object[key];
				});
			}

			module.exports = baseValues;

			/***/
		},
		/* 95 */
		/*!*******************************!*\
    !*** ./~/lodash/_cacheHas.js ***!
    \*******************************/
		/***/function (module, exports) {

			/**
    * Checks if a `cache` value for `key` exists.
    *
    * @private
    * @param {Object} cache The cache to query.
    * @param {string} key The key of the entry to check.
    * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    */
			function cacheHas(cache, key) {
				return cache.has(key);
			}

			module.exports = cacheHas;

			/***/
		},
		/* 96 */
		/*!**********************************!*\
    !*** ./~/lodash/_cloneBuffer.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			/* WEBPACK VAR INJECTION */(function (module) {
				var root = __webpack_require__( /*! ./_root */1);

				/** Detect free variable `exports`. */
				var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

				/** Detect free variable `module`. */
				var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

				/** Detect the popular CommonJS extension `module.exports`. */
				var moduleExports = freeModule && freeModule.exports === freeExports;

				/** Built-in value references. */
				var Buffer = moduleExports ? root.Buffer : undefined,
				    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

				/**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
				function cloneBuffer(buffer, isDeep) {
					if (isDeep) {
						return buffer.slice();
					}
					var length = buffer.length,
					    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

					buffer.copy(result);
					return result;
				}

				module.exports = cloneBuffer;

				/* WEBPACK VAR INJECTION */
			}).call(exports, __webpack_require__( /*! ./../webpack/buildin/module.js */24)(module));

			/***/
		},
		/* 97 */
		/*!************************************!*\
    !*** ./~/lodash/_cloneDataView.js ***!
    \************************************/
		/***/function (module, exports, __webpack_require__) {

			var cloneArrayBuffer = __webpack_require__( /*! ./_cloneArrayBuffer */18);

			/**
    * Creates a clone of `dataView`.
    *
    * @private
    * @param {Object} dataView The data view to clone.
    * @param {boolean} [isDeep] Specify a deep clone.
    * @returns {Object} Returns the cloned data view.
    */
			function cloneDataView(dataView, isDeep) {
				var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
				return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
			}

			module.exports = cloneDataView;

			/***/
		},
		/* 98 */
		/*!*******************************!*\
    !*** ./~/lodash/_cloneMap.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var addMapEntry = __webpack_require__( /*! ./_addMapEntry */67),
			    arrayReduce = __webpack_require__( /*! ./_arrayReduce */31),
			    mapToArray = __webpack_require__( /*! ./_mapToArray */133);

			/** Used to compose bitmasks for cloning. */
			var CLONE_DEEP_FLAG = 1;

			/**
    * Creates a clone of `map`.
    *
    * @private
    * @param {Object} map The map to clone.
    * @param {Function} cloneFunc The function to clone values.
    * @param {boolean} [isDeep] Specify a deep clone.
    * @returns {Object} Returns the cloned map.
    */
			function cloneMap(map, isDeep, cloneFunc) {
				var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
				return arrayReduce(array, addMapEntry, new map.constructor());
			}

			module.exports = cloneMap;

			/***/
		},
		/* 99 */
		/*!**********************************!*\
    !*** ./~/lodash/_cloneRegExp.js ***!
    \**********************************/
		/***/function (module, exports) {

			/** Used to match `RegExp` flags from their coerced string values. */
			var reFlags = /\w*$/;

			/**
    * Creates a clone of `regexp`.
    *
    * @private
    * @param {Object} regexp The regexp to clone.
    * @returns {Object} Returns the cloned regexp.
    */
			function cloneRegExp(regexp) {
				var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
				result.lastIndex = regexp.lastIndex;
				return result;
			}

			module.exports = cloneRegExp;

			/***/
		},
		/* 100 */
		/*!*******************************!*\
    !*** ./~/lodash/_cloneSet.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var addSetEntry = __webpack_require__( /*! ./_addSetEntry */68),
			    arrayReduce = __webpack_require__( /*! ./_arrayReduce */31),
			    setToArray = __webpack_require__( /*! ./_setToArray */141);

			/** Used to compose bitmasks for cloning. */
			var CLONE_DEEP_FLAG = 1;

			/**
    * Creates a clone of `set`.
    *
    * @private
    * @param {Object} set The set to clone.
    * @param {Function} cloneFunc The function to clone values.
    * @param {boolean} [isDeep] Specify a deep clone.
    * @returns {Object} Returns the cloned set.
    */
			function cloneSet(set, isDeep, cloneFunc) {
				var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
				return arrayReduce(array, addSetEntry, new set.constructor());
			}

			module.exports = cloneSet;

			/***/
		},
		/* 101 */
		/*!**********************************!*\
    !*** ./~/lodash/_cloneSymbol.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var Symbol = __webpack_require__( /*! ./_Symbol */17);

			/** Used to convert symbols to primitives and strings. */
			var symbolProto = Symbol ? Symbol.prototype : undefined,
			    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

			/**
    * Creates a clone of the `symbol` object.
    *
    * @private
    * @param {Object} symbol The symbol object to clone.
    * @returns {Object} Returns the cloned symbol object.
    */
			function cloneSymbol(symbol) {
				return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
			}

			module.exports = cloneSymbol;

			/***/
		},
		/* 102 */
		/*!**************************************!*\
    !*** ./~/lodash/_cloneTypedArray.js ***!
    \**************************************/
		/***/function (module, exports, __webpack_require__) {

			var cloneArrayBuffer = __webpack_require__( /*! ./_cloneArrayBuffer */18);

			/**
    * Creates a clone of `typedArray`.
    *
    * @private
    * @param {Object} typedArray The typed array to clone.
    * @param {boolean} [isDeep] Specify a deep clone.
    * @returns {Object} Returns the cloned typed array.
    */
			function cloneTypedArray(typedArray, isDeep) {
				var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
				return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
			}

			module.exports = cloneTypedArray;

			/***/
		},
		/* 103 */
		/*!**********************************!*\
    !*** ./~/lodash/_copySymbols.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var copyObject = __webpack_require__( /*! ./_copyObject */9),
			    getSymbols = __webpack_require__( /*! ./_getSymbols */19);

			/**
    * Copies own symbols of `source` to `object`.
    *
    * @private
    * @param {Object} source The object to copy symbols from.
    * @param {Object} [object={}] The object to copy symbols to.
    * @returns {Object} Returns `object`.
    */
			function copySymbols(source, object) {
				return copyObject(source, getSymbols(source), object);
			}

			module.exports = copySymbols;

			/***/
		},
		/* 104 */
		/*!************************************!*\
    !*** ./~/lodash/_copySymbolsIn.js ***!
    \************************************/
		/***/function (module, exports, __webpack_require__) {

			var copyObject = __webpack_require__( /*! ./_copyObject */9),
			    getSymbolsIn = __webpack_require__( /*! ./_getSymbolsIn */40);

			/**
    * Copies own and inherited symbols of `source` to `object`.
    *
    * @private
    * @param {Object} source The object to copy symbols from.
    * @param {Object} [object={}] The object to copy symbols to.
    * @returns {Object} Returns `object`.
    */
			function copySymbolsIn(source, object) {
				return copyObject(source, getSymbolsIn(source), object);
			}

			module.exports = copySymbolsIn;

			/***/
		},
		/* 105 */
		/*!*********************************!*\
    !*** ./~/lodash/_coreJsData.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var root = __webpack_require__( /*! ./_root */1);

			/** Used to detect overreaching core-js shims. */
			var coreJsData = root['__core-js_shared__'];

			module.exports = coreJsData;

			/***/
		},
		/* 106 */
		/*!**********************************!*\
    !*** ./~/lodash/_createRange.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseRange = __webpack_require__( /*! ./_baseRange */89),
			    isIterateeCall = __webpack_require__( /*! ./_isIterateeCall */120),
			    toFinite = __webpack_require__( /*! ./toFinite */159);

			/**
    * Creates a `_.range` or `_.rangeRight` function.
    *
    * @private
    * @param {boolean} [fromRight] Specify iterating from right to left.
    * @returns {Function} Returns the new range function.
    */
			function createRange(fromRight) {
				return function (start, end, step) {
					if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
						end = step = undefined;
					}
					// Ensure the sign of `-0` is preserved.
					start = toFinite(start);
					if (end === undefined) {
						end = start;
						start = 0;
					} else {
						end = toFinite(end);
					}
					step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
					return baseRange(start, end, step, fromRight);
				};
			}

			module.exports = createRange;

			/***/
		},
		/* 107 */
		/*!*********************************!*\
    !*** ./~/lodash/_getAllKeys.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseGetAllKeys = __webpack_require__( /*! ./_baseGetAllKeys */34),
			    getSymbols = __webpack_require__( /*! ./_getSymbols */19),
			    keys = __webpack_require__( /*! ./keys */14);

			/**
    * Creates an array of own enumerable property names and symbols of `object`.
    *
    * @private
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of property names and symbols.
    */
			function getAllKeys(object) {
				return baseGetAllKeys(object, keys, getSymbols);
			}

			module.exports = getAllKeys;

			/***/
		},
		/* 108 */
		/*!***********************************!*\
    !*** ./~/lodash/_getAllKeysIn.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseGetAllKeys = __webpack_require__( /*! ./_baseGetAllKeys */34),
			    getSymbolsIn = __webpack_require__( /*! ./_getSymbolsIn */40),
			    keysIn = __webpack_require__( /*! ./keysIn */49);

			/**
    * Creates an array of own and inherited enumerable property names and
    * symbols of `object`.
    *
    * @private
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of property names and symbols.
    */
			function getAllKeysIn(object) {
				return baseGetAllKeys(object, keysIn, getSymbolsIn);
			}

			module.exports = getAllKeysIn;

			/***/
		},
		/* 109 */
		/*!********************************!*\
    !*** ./~/lodash/_getRawTag.js ***!
    \********************************/
		/***/function (module, exports, __webpack_require__) {

			var Symbol = __webpack_require__( /*! ./_Symbol */17);

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/**
    * Used to resolve the
    * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
    * of values.
    */
			var nativeObjectToString = objectProto.toString;

			/** Built-in value references. */
			var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

			/**
    * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
    *
    * @private
    * @param {*} value The value to query.
    * @returns {string} Returns the raw `toStringTag`.
    */
			function getRawTag(value) {
				var isOwn = hasOwnProperty.call(value, symToStringTag),
				    tag = value[symToStringTag];

				try {
					value[symToStringTag] = undefined;
					var unmasked = true;
				} catch (e) {}

				var result = nativeObjectToString.call(value);
				if (unmasked) {
					if (isOwn) {
						value[symToStringTag] = tag;
					} else {
						delete value[symToStringTag];
					}
				}
				return result;
			}

			module.exports = getRawTag;

			/***/
		},
		/* 110 */
		/*!*****************************!*\
    !*** ./~/lodash/_getTag.js ***!
    \*****************************/
		/***/function (module, exports, __webpack_require__) {

			var DataView = __webpack_require__( /*! ./_DataView */59),
			    Map = __webpack_require__( /*! ./_Map */16),
			    Promise = __webpack_require__( /*! ./_Promise */61),
			    Set = __webpack_require__( /*! ./_Set */62),
			    WeakMap = __webpack_require__( /*! ./_WeakMap */66),
			    baseGetTag = __webpack_require__( /*! ./_baseGetTag */4),
			    toSource = __webpack_require__( /*! ./_toSource */43);

			/** `Object#toString` result references. */
			var mapTag = '[object Map]',
			    objectTag = '[object Object]',
			    promiseTag = '[object Promise]',
			    setTag = '[object Set]',
			    weakMapTag = '[object WeakMap]';

			var dataViewTag = '[object DataView]';

			/** Used to detect maps, sets, and weakmaps. */
			var dataViewCtorString = toSource(DataView),
			    mapCtorString = toSource(Map),
			    promiseCtorString = toSource(Promise),
			    setCtorString = toSource(Set),
			    weakMapCtorString = toSource(WeakMap);

			/**
    * Gets the `toStringTag` of `value`.
    *
    * @private
    * @param {*} value The value to query.
    * @returns {string} Returns the `toStringTag`.
    */
			var getTag = baseGetTag;

			// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
			if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
				getTag = function getTag(value) {
					var result = baseGetTag(value),
					    Ctor = result == objectTag ? value.constructor : undefined,
					    ctorString = Ctor ? toSource(Ctor) : '';

					if (ctorString) {
						switch (ctorString) {
							case dataViewCtorString:
								return dataViewTag;
							case mapCtorString:
								return mapTag;
							case promiseCtorString:
								return promiseTag;
							case setCtorString:
								return setTag;
							case weakMapCtorString:
								return weakMapTag;
						}
					}
					return result;
				};
			}

			module.exports = getTag;

			/***/
		},
		/* 111 */
		/*!*******************************!*\
    !*** ./~/lodash/_getValue.js ***!
    \*******************************/
		/***/function (module, exports) {

			/**
    * Gets the value at `key` of `object`.
    *
    * @private
    * @param {Object} [object] The object to query.
    * @param {string} key The key of the property to get.
    * @returns {*} Returns the property value.
    */
			function getValue(object, key) {
				return object == null ? undefined : object[key];
			}

			module.exports = getValue;

			/***/
		},
		/* 112 */
		/*!********************************!*\
    !*** ./~/lodash/_hashClear.js ***!
    \********************************/
		/***/function (module, exports, __webpack_require__) {

			var nativeCreate = __webpack_require__( /*! ./_nativeCreate */11);

			/**
    * Removes all key-value entries from the hash.
    *
    * @private
    * @name clear
    * @memberOf Hash
    */
			function hashClear() {
				this.__data__ = nativeCreate ? nativeCreate(null) : {};
				this.size = 0;
			}

			module.exports = hashClear;

			/***/
		},
		/* 113 */
		/*!*********************************!*\
    !*** ./~/lodash/_hashDelete.js ***!
    \*********************************/
		/***/function (module, exports) {

			/**
    * Removes `key` and its value from the hash.
    *
    * @private
    * @name delete
    * @memberOf Hash
    * @param {Object} hash The hash to modify.
    * @param {string} key The key of the value to remove.
    * @returns {boolean} Returns `true` if the entry was removed, else `false`.
    */
			function hashDelete(key) {
				var result = this.has(key) && delete this.__data__[key];
				this.size -= result ? 1 : 0;
				return result;
			}

			module.exports = hashDelete;

			/***/
		},
		/* 114 */
		/*!******************************!*\
    !*** ./~/lodash/_hashGet.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			var nativeCreate = __webpack_require__( /*! ./_nativeCreate */11);

			/** Used to stand-in for `undefined` hash values. */
			var HASH_UNDEFINED = '__lodash_hash_undefined__';

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/**
    * Gets the hash value for `key`.
    *
    * @private
    * @name get
    * @memberOf Hash
    * @param {string} key The key of the value to get.
    * @returns {*} Returns the entry value.
    */
			function hashGet(key) {
				var data = this.__data__;
				if (nativeCreate) {
					var result = data[key];
					return result === HASH_UNDEFINED ? undefined : result;
				}
				return hasOwnProperty.call(data, key) ? data[key] : undefined;
			}

			module.exports = hashGet;

			/***/
		},
		/* 115 */
		/*!******************************!*\
    !*** ./~/lodash/_hashHas.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			var nativeCreate = __webpack_require__( /*! ./_nativeCreate */11);

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/**
    * Checks if a hash value for `key` exists.
    *
    * @private
    * @name has
    * @memberOf Hash
    * @param {string} key The key of the entry to check.
    * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    */
			function hashHas(key) {
				var data = this.__data__;
				return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
			}

			module.exports = hashHas;

			/***/
		},
		/* 116 */
		/*!******************************!*\
    !*** ./~/lodash/_hashSet.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			var nativeCreate = __webpack_require__( /*! ./_nativeCreate */11);

			/** Used to stand-in for `undefined` hash values. */
			var HASH_UNDEFINED = '__lodash_hash_undefined__';

			/**
    * Sets the hash `key` to `value`.
    *
    * @private
    * @name set
    * @memberOf Hash
    * @param {string} key The key of the value to set.
    * @param {*} value The value to set.
    * @returns {Object} Returns the hash instance.
    */
			function hashSet(key, value) {
				var data = this.__data__;
				this.size += this.has(key) ? 0 : 1;
				data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
				return this;
			}

			module.exports = hashSet;

			/***/
		},
		/* 117 */
		/*!*************************************!*\
    !*** ./~/lodash/_initCloneArray.js ***!
    \*************************************/
		/***/function (module, exports) {

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/**
    * Initializes an array clone.
    *
    * @private
    * @param {Array} array The array to clone.
    * @returns {Array} Returns the initialized clone.
    */
			function initCloneArray(array) {
				var length = array.length,
				    result = array.constructor(length);

				// Add properties assigned by `RegExp#exec`.
				if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
					result.index = array.index;
					result.input = array.input;
				}
				return result;
			}

			module.exports = initCloneArray;

			/***/
		},
		/* 118 */
		/*!*************************************!*\
    !*** ./~/lodash/_initCloneByTag.js ***!
    \*************************************/
		/***/function (module, exports, __webpack_require__) {

			var cloneArrayBuffer = __webpack_require__( /*! ./_cloneArrayBuffer */18),
			    cloneDataView = __webpack_require__( /*! ./_cloneDataView */97),
			    cloneMap = __webpack_require__( /*! ./_cloneMap */98),
			    cloneRegExp = __webpack_require__( /*! ./_cloneRegExp */99),
			    cloneSet = __webpack_require__( /*! ./_cloneSet */100),
			    cloneSymbol = __webpack_require__( /*! ./_cloneSymbol */101),
			    cloneTypedArray = __webpack_require__( /*! ./_cloneTypedArray */102);

			/** `Object#toString` result references. */
			var boolTag = '[object Boolean]',
			    dateTag = '[object Date]',
			    mapTag = '[object Map]',
			    numberTag = '[object Number]',
			    regexpTag = '[object RegExp]',
			    setTag = '[object Set]',
			    stringTag = '[object String]',
			    symbolTag = '[object Symbol]';

			var arrayBufferTag = '[object ArrayBuffer]',
			    dataViewTag = '[object DataView]',
			    float32Tag = '[object Float32Array]',
			    float64Tag = '[object Float64Array]',
			    int8Tag = '[object Int8Array]',
			    int16Tag = '[object Int16Array]',
			    int32Tag = '[object Int32Array]',
			    uint8Tag = '[object Uint8Array]',
			    uint8ClampedTag = '[object Uint8ClampedArray]',
			    uint16Tag = '[object Uint16Array]',
			    uint32Tag = '[object Uint32Array]';

			/**
    * Initializes an object clone based on its `toStringTag`.
    *
    * **Note:** This function only supports cloning values with tags of
    * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
    *
    * @private
    * @param {Object} object The object to clone.
    * @param {string} tag The `toStringTag` of the object to clone.
    * @param {Function} cloneFunc The function to clone values.
    * @param {boolean} [isDeep] Specify a deep clone.
    * @returns {Object} Returns the initialized clone.
    */
			function initCloneByTag(object, tag, cloneFunc, isDeep) {
				var Ctor = object.constructor;
				switch (tag) {
					case arrayBufferTag:
						return cloneArrayBuffer(object);

					case boolTag:
					case dateTag:
						return new Ctor(+object);

					case dataViewTag:
						return cloneDataView(object, isDeep);

					case float32Tag:case float64Tag:
					case int8Tag:case int16Tag:case int32Tag:
					case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
						return cloneTypedArray(object, isDeep);

					case mapTag:
						return cloneMap(object, isDeep, cloneFunc);

					case numberTag:
					case stringTag:
						return new Ctor(object);

					case regexpTag:
						return cloneRegExp(object);

					case setTag:
						return cloneSet(object, isDeep, cloneFunc);

					case symbolTag:
						return cloneSymbol(object);
				}
			}

			module.exports = initCloneByTag;

			/***/
		},
		/* 119 */
		/*!**************************************!*\
    !*** ./~/lodash/_initCloneObject.js ***!
    \**************************************/
		/***/function (module, exports, __webpack_require__) {

			var baseCreate = __webpack_require__( /*! ./_baseCreate */78),
			    getPrototype = __webpack_require__( /*! ./_getPrototype */39),
			    isPrototype = __webpack_require__( /*! ./_isPrototype */20);

			/**
    * Initializes an object clone.
    *
    * @private
    * @param {Object} object The object to clone.
    * @returns {Object} Returns the initialized clone.
    */
			function initCloneObject(object) {
				return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
			}

			module.exports = initCloneObject;

			/***/
		},
		/* 120 */
		/*!*************************************!*\
    !*** ./~/lodash/_isIterateeCall.js ***!
    \*************************************/
		/***/function (module, exports, __webpack_require__) {

			var eq = __webpack_require__( /*! ./eq */22),
			    isArrayLike = __webpack_require__( /*! ./isArrayLike */13),
			    isIndex = __webpack_require__( /*! ./_isIndex */41),
			    isObject = __webpack_require__( /*! ./isObject */3);

			/**
    * Checks if the given arguments are from an iteratee call.
    *
    * @private
    * @param {*} value The potential iteratee value argument.
    * @param {*} index The potential iteratee index or key argument.
    * @param {*} object The potential iteratee object argument.
    * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
    *  else `false`.
    */
			function isIterateeCall(value, index, object) {
				if (!isObject(object)) {
					return false;
				}
				var type = typeof index;
				if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
					return eq(object[index], value);
				}
				return false;
			}

			module.exports = isIterateeCall;

			/***/
		},
		/* 121 */
		/*!********************************!*\
    !*** ./~/lodash/_isKeyable.js ***!
    \********************************/
		/***/function (module, exports) {

			/**
    * Checks if `value` is suitable for use as unique object key.
    *
    * @private
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
    */
			function isKeyable(value) {
				var type = typeof value;
				return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
			}

			module.exports = isKeyable;

			/***/
		},
		/* 122 */
		/*!*******************************!*\
    !*** ./~/lodash/_isMasked.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var coreJsData = __webpack_require__( /*! ./_coreJsData */105);

			/** Used to detect methods masquerading as native. */
			var maskSrcKey = function () {
				var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
				return uid ? 'Symbol(src)_1.' + uid : '';
			}();

			/**
    * Checks if `func` has its source masked.
    *
    * @private
    * @param {Function} func The function to check.
    * @returns {boolean} Returns `true` if `func` is masked, else `false`.
    */
			function isMasked(func) {
				return !!maskSrcKey && maskSrcKey in func;
			}

			module.exports = isMasked;

			/***/
		},
		/* 123 */
		/*!*************************************!*\
    !*** ./~/lodash/_listCacheClear.js ***!
    \*************************************/
		/***/function (module, exports) {

			/**
    * Removes all key-value entries from the list cache.
    *
    * @private
    * @name clear
    * @memberOf ListCache
    */
			function listCacheClear() {
				this.__data__ = [];
				this.size = 0;
			}

			module.exports = listCacheClear;

			/***/
		},
		/* 124 */
		/*!**************************************!*\
    !*** ./~/lodash/_listCacheDelete.js ***!
    \**************************************/
		/***/function (module, exports, __webpack_require__) {

			var assocIndexOf = __webpack_require__( /*! ./_assocIndexOf */8);

			/** Used for built-in method references. */
			var arrayProto = Array.prototype;

			/** Built-in value references. */
			var splice = arrayProto.splice;

			/**
    * Removes `key` and its value from the list cache.
    *
    * @private
    * @name delete
    * @memberOf ListCache
    * @param {string} key The key of the value to remove.
    * @returns {boolean} Returns `true` if the entry was removed, else `false`.
    */
			function listCacheDelete(key) {
				var data = this.__data__,
				    index = assocIndexOf(data, key);

				if (index < 0) {
					return false;
				}
				var lastIndex = data.length - 1;
				if (index == lastIndex) {
					data.pop();
				} else {
					splice.call(data, index, 1);
				}
				--this.size;
				return true;
			}

			module.exports = listCacheDelete;

			/***/
		},
		/* 125 */
		/*!***********************************!*\
    !*** ./~/lodash/_listCacheGet.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var assocIndexOf = __webpack_require__( /*! ./_assocIndexOf */8);

			/**
    * Gets the list cache value for `key`.
    *
    * @private
    * @name get
    * @memberOf ListCache
    * @param {string} key The key of the value to get.
    * @returns {*} Returns the entry value.
    */
			function listCacheGet(key) {
				var data = this.__data__,
				    index = assocIndexOf(data, key);

				return index < 0 ? undefined : data[index][1];
			}

			module.exports = listCacheGet;

			/***/
		},
		/* 126 */
		/*!***********************************!*\
    !*** ./~/lodash/_listCacheHas.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var assocIndexOf = __webpack_require__( /*! ./_assocIndexOf */8);

			/**
    * Checks if a list cache value for `key` exists.
    *
    * @private
    * @name has
    * @memberOf ListCache
    * @param {string} key The key of the entry to check.
    * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    */
			function listCacheHas(key) {
				return assocIndexOf(this.__data__, key) > -1;
			}

			module.exports = listCacheHas;

			/***/
		},
		/* 127 */
		/*!***********************************!*\
    !*** ./~/lodash/_listCacheSet.js ***!
    \***********************************/
		/***/function (module, exports, __webpack_require__) {

			var assocIndexOf = __webpack_require__( /*! ./_assocIndexOf */8);

			/**
    * Sets the list cache `key` to `value`.
    *
    * @private
    * @name set
    * @memberOf ListCache
    * @param {string} key The key of the value to set.
    * @param {*} value The value to set.
    * @returns {Object} Returns the list cache instance.
    */
			function listCacheSet(key, value) {
				var data = this.__data__,
				    index = assocIndexOf(data, key);

				if (index < 0) {
					++this.size;
					data.push([key, value]);
				} else {
					data[index][1] = value;
				}
				return this;
			}

			module.exports = listCacheSet;

			/***/
		},
		/* 128 */
		/*!************************************!*\
    !*** ./~/lodash/_mapCacheClear.js ***!
    \************************************/
		/***/function (module, exports, __webpack_require__) {

			var Hash = __webpack_require__( /*! ./_Hash */60),
			    ListCache = __webpack_require__( /*! ./_ListCache */7),
			    Map = __webpack_require__( /*! ./_Map */16);

			/**
    * Removes all key-value entries from the map.
    *
    * @private
    * @name clear
    * @memberOf MapCache
    */
			function mapCacheClear() {
				this.size = 0;
				this.__data__ = {
					'hash': new Hash(),
					'map': new (Map || ListCache)(),
					'string': new Hash()
				};
			}

			module.exports = mapCacheClear;

			/***/
		},
		/* 129 */
		/*!*************************************!*\
    !*** ./~/lodash/_mapCacheDelete.js ***!
    \*************************************/
		/***/function (module, exports, __webpack_require__) {

			var getMapData = __webpack_require__( /*! ./_getMapData */10);

			/**
    * Removes `key` and its value from the map.
    *
    * @private
    * @name delete
    * @memberOf MapCache
    * @param {string} key The key of the value to remove.
    * @returns {boolean} Returns `true` if the entry was removed, else `false`.
    */
			function mapCacheDelete(key) {
				var result = getMapData(this, key)['delete'](key);
				this.size -= result ? 1 : 0;
				return result;
			}

			module.exports = mapCacheDelete;

			/***/
		},
		/* 130 */
		/*!**********************************!*\
    !*** ./~/lodash/_mapCacheGet.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var getMapData = __webpack_require__( /*! ./_getMapData */10);

			/**
    * Gets the map value for `key`.
    *
    * @private
    * @name get
    * @memberOf MapCache
    * @param {string} key The key of the value to get.
    * @returns {*} Returns the entry value.
    */
			function mapCacheGet(key) {
				return getMapData(this, key).get(key);
			}

			module.exports = mapCacheGet;

			/***/
		},
		/* 131 */
		/*!**********************************!*\
    !*** ./~/lodash/_mapCacheHas.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var getMapData = __webpack_require__( /*! ./_getMapData */10);

			/**
    * Checks if a map value for `key` exists.
    *
    * @private
    * @name has
    * @memberOf MapCache
    * @param {string} key The key of the entry to check.
    * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    */
			function mapCacheHas(key) {
				return getMapData(this, key).has(key);
			}

			module.exports = mapCacheHas;

			/***/
		},
		/* 132 */
		/*!**********************************!*\
    !*** ./~/lodash/_mapCacheSet.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var getMapData = __webpack_require__( /*! ./_getMapData */10);

			/**
    * Sets the map `key` to `value`.
    *
    * @private
    * @name set
    * @memberOf MapCache
    * @param {string} key The key of the value to set.
    * @param {*} value The value to set.
    * @returns {Object} Returns the map cache instance.
    */
			function mapCacheSet(key, value) {
				var data = getMapData(this, key),
				    size = data.size;

				data.set(key, value);
				this.size += data.size == size ? 0 : 1;
				return this;
			}

			module.exports = mapCacheSet;

			/***/
		},
		/* 133 */
		/*!*********************************!*\
    !*** ./~/lodash/_mapToArray.js ***!
    \*********************************/
		/***/function (module, exports) {

			/**
    * Converts `map` to its key-value pairs.
    *
    * @private
    * @param {Object} map The map to convert.
    * @returns {Array} Returns the key-value pairs.
    */
			function mapToArray(map) {
				var index = -1,
				    result = Array(map.size);

				map.forEach(function (value, key) {
					result[++index] = [key, value];
				});
				return result;
			}

			module.exports = mapToArray;

			/***/
		},
		/* 134 */
		/*!*********************************!*\
    !*** ./~/lodash/_nativeKeys.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var overArg = __webpack_require__( /*! ./_overArg */21);

			/* Built-in method references for those with the same name as other `lodash` methods. */
			var nativeKeys = overArg(Object.keys, Object);

			module.exports = nativeKeys;

			/***/
		},
		/* 135 */
		/*!***********************************!*\
    !*** ./~/lodash/_nativeKeysIn.js ***!
    \***********************************/
		/***/function (module, exports) {

			/**
    * This function is like
    * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
    * except that it includes inherited enumerable properties.
    *
    * @private
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of property names.
    */
			function nativeKeysIn(object) {
				var result = [];
				if (object != null) {
					for (var key in Object(object)) {
						result.push(key);
					}
				}
				return result;
			}

			module.exports = nativeKeysIn;

			/***/
		},
		/* 136 */
		/*!*******************************!*\
    !*** ./~/lodash/_nodeUtil.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			/* WEBPACK VAR INJECTION */(function (module) {
				var freeGlobal = __webpack_require__( /*! ./_freeGlobal */38);

				/** Detect free variable `exports`. */
				var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

				/** Detect free variable `module`. */
				var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

				/** Detect the popular CommonJS extension `module.exports`. */
				var moduleExports = freeModule && freeModule.exports === freeExports;

				/** Detect free variable `process` from Node.js. */
				var freeProcess = moduleExports && freeGlobal.process;

				/** Used to access faster Node.js helpers. */
				var nodeUtil = function () {
					try {
						return freeProcess && freeProcess.binding && freeProcess.binding('util');
					} catch (e) {}
				}();

				module.exports = nodeUtil;

				/* WEBPACK VAR INJECTION */
			}).call(exports, __webpack_require__( /*! ./../webpack/buildin/module.js */24)(module));

			/***/
		},
		/* 137 */
		/*!*************************************!*\
    !*** ./~/lodash/_objectToString.js ***!
    \*************************************/
		/***/function (module, exports) {

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/**
    * Used to resolve the
    * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
    * of values.
    */
			var nativeObjectToString = objectProto.toString;

			/**
    * Converts `value` to a string using `Object.prototype.toString`.
    *
    * @private
    * @param {*} value The value to convert.
    * @returns {string} Returns the converted string.
    */
			function objectToString(value) {
				return nativeObjectToString.call(value);
			}

			module.exports = objectToString;

			/***/
		},
		/* 138 */
		/*!*******************************!*\
    !*** ./~/lodash/_overRest.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var apply = __webpack_require__( /*! ./_apply */69);

			/* Built-in method references for those with the same name as other `lodash` methods. */
			var nativeMax = Math.max;

			/**
    * A specialized version of `baseRest` which transforms the rest array.
    *
    * @private
    * @param {Function} func The function to apply a rest parameter to.
    * @param {number} [start=func.length-1] The start position of the rest parameter.
    * @param {Function} transform The rest array transform.
    * @returns {Function} Returns the new function.
    */
			function overRest(func, start, transform) {
				start = nativeMax(start === undefined ? func.length - 1 : start, 0);
				return function () {
					var args = arguments,
					    index = -1,
					    length = nativeMax(args.length - start, 0),
					    array = Array(length);

					while (++index < length) {
						array[index] = args[start + index];
					}
					index = -1;
					var otherArgs = Array(start + 1);
					while (++index < start) {
						otherArgs[index] = args[index];
					}
					otherArgs[start] = transform(array);
					return apply(func, this, otherArgs);
				};
			}

			module.exports = overRest;

			/***/
		},
		/* 139 */
		/*!**********************************!*\
    !*** ./~/lodash/_setCacheAdd.js ***!
    \**********************************/
		/***/function (module, exports) {

			/** Used to stand-in for `undefined` hash values. */
			var HASH_UNDEFINED = '__lodash_hash_undefined__';

			/**
    * Adds `value` to the array cache.
    *
    * @private
    * @name add
    * @memberOf SetCache
    * @alias push
    * @param {*} value The value to cache.
    * @returns {Object} Returns the cache instance.
    */
			function setCacheAdd(value) {
				this.__data__.set(value, HASH_UNDEFINED);
				return this;
			}

			module.exports = setCacheAdd;

			/***/
		},
		/* 140 */
		/*!**********************************!*\
    !*** ./~/lodash/_setCacheHas.js ***!
    \**********************************/
		/***/function (module, exports) {

			/**
    * Checks if `value` is in the array cache.
    *
    * @private
    * @name has
    * @memberOf SetCache
    * @param {*} value The value to search for.
    * @returns {number} Returns `true` if `value` is found, else `false`.
    */
			function setCacheHas(value) {
				return this.__data__.has(value);
			}

			module.exports = setCacheHas;

			/***/
		},
		/* 141 */
		/*!*********************************!*\
    !*** ./~/lodash/_setToArray.js ***!
    \*********************************/
		/***/function (module, exports) {

			/**
    * Converts `set` to an array of its values.
    *
    * @private
    * @param {Object} set The set to convert.
    * @returns {Array} Returns the values.
    */
			function setToArray(set) {
				var index = -1,
				    result = Array(set.size);

				set.forEach(function (value) {
					result[++index] = value;
				});
				return result;
			}

			module.exports = setToArray;

			/***/
		},
		/* 142 */
		/*!**********************************!*\
    !*** ./~/lodash/_setToString.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseSetToString = __webpack_require__( /*! ./_baseSetToString */91),
			    shortOut = __webpack_require__( /*! ./_shortOut */143);

			/**
    * Sets the `toString` method of `func` to return `string`.
    *
    * @private
    * @param {Function} func The function to modify.
    * @param {Function} string The `toString` result.
    * @returns {Function} Returns `func`.
    */
			var setToString = shortOut(baseSetToString);

			module.exports = setToString;

			/***/
		},
		/* 143 */
		/*!*******************************!*\
    !*** ./~/lodash/_shortOut.js ***!
    \*******************************/
		/***/function (module, exports) {

			/** Used to detect hot functions by number of calls within a span of milliseconds. */
			var HOT_COUNT = 800,
			    HOT_SPAN = 16;

			/* Built-in method references for those with the same name as other `lodash` methods. */
			var nativeNow = Date.now;

			/**
    * Creates a function that'll short out and invoke `identity` instead
    * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
    * milliseconds.
    *
    * @private
    * @param {Function} func The function to restrict.
    * @returns {Function} Returns the new shortable function.
    */
			function shortOut(func) {
				var count = 0,
				    lastCalled = 0;

				return function () {
					var stamp = nativeNow(),
					    remaining = HOT_SPAN - (stamp - lastCalled);

					lastCalled = stamp;
					if (remaining > 0) {
						if (++count >= HOT_COUNT) {
							return arguments[0];
						}
					} else {
						count = 0;
					}
					return func.apply(undefined, arguments);
				};
			}

			module.exports = shortOut;

			/***/
		},
		/* 144 */
		/*!*********************************!*\
    !*** ./~/lodash/_stackClear.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var ListCache = __webpack_require__( /*! ./_ListCache */7);

			/**
    * Removes all key-value entries from the stack.
    *
    * @private
    * @name clear
    * @memberOf Stack
    */
			function stackClear() {
				this.__data__ = new ListCache();
				this.size = 0;
			}

			module.exports = stackClear;

			/***/
		},
		/* 145 */
		/*!**********************************!*\
    !*** ./~/lodash/_stackDelete.js ***!
    \**********************************/
		/***/function (module, exports) {

			/**
    * Removes `key` and its value from the stack.
    *
    * @private
    * @name delete
    * @memberOf Stack
    * @param {string} key The key of the value to remove.
    * @returns {boolean} Returns `true` if the entry was removed, else `false`.
    */
			function stackDelete(key) {
				var data = this.__data__,
				    result = data['delete'](key);

				this.size = data.size;
				return result;
			}

			module.exports = stackDelete;

			/***/
		},
		/* 146 */
		/*!*******************************!*\
    !*** ./~/lodash/_stackGet.js ***!
    \*******************************/
		/***/function (module, exports) {

			/**
    * Gets the stack value for `key`.
    *
    * @private
    * @name get
    * @memberOf Stack
    * @param {string} key The key of the value to get.
    * @returns {*} Returns the entry value.
    */
			function stackGet(key) {
				return this.__data__.get(key);
			}

			module.exports = stackGet;

			/***/
		},
		/* 147 */
		/*!*******************************!*\
    !*** ./~/lodash/_stackHas.js ***!
    \*******************************/
		/***/function (module, exports) {

			/**
    * Checks if a stack value for `key` exists.
    *
    * @private
    * @name has
    * @memberOf Stack
    * @param {string} key The key of the entry to check.
    * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    */
			function stackHas(key) {
				return this.__data__.has(key);
			}

			module.exports = stackHas;

			/***/
		},
		/* 148 */
		/*!*******************************!*\
    !*** ./~/lodash/_stackSet.js ***!
    \*******************************/
		/***/function (module, exports, __webpack_require__) {

			var ListCache = __webpack_require__( /*! ./_ListCache */7),
			    Map = __webpack_require__( /*! ./_Map */16),
			    MapCache = __webpack_require__( /*! ./_MapCache */27);

			/** Used as the size to enable large array optimizations. */
			var LARGE_ARRAY_SIZE = 200;

			/**
    * Sets the stack `key` to `value`.
    *
    * @private
    * @name set
    * @memberOf Stack
    * @param {string} key The key of the value to set.
    * @param {*} value The value to set.
    * @returns {Object} Returns the stack cache instance.
    */
			function stackSet(key, value) {
				var data = this.__data__;
				if (data instanceof ListCache) {
					var pairs = data.__data__;
					if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
						pairs.push([key, value]);
						this.size = ++data.size;
						return this;
					}
					data = this.__data__ = new MapCache(pairs);
				}
				data.set(key, value);
				this.size = data.size;
				return this;
			}

			module.exports = stackSet;

			/***/
		},
		/* 149 */
		/*!************************************!*\
    !*** ./~/lodash/_strictIndexOf.js ***!
    \************************************/
		/***/function (module, exports) {

			/**
    * A specialized version of `_.indexOf` which performs strict equality
    * comparisons of values, i.e. `===`.
    *
    * @private
    * @param {Array} array The array to inspect.
    * @param {*} value The value to search for.
    * @param {number} fromIndex The index to search from.
    * @returns {number} Returns the index of the matched value, else `-1`.
    */
			function strictIndexOf(array, value, fromIndex) {
				var index = fromIndex - 1,
				    length = array.length;

				while (++index < length) {
					if (array[index] === value) {
						return index;
					}
				}
				return -1;
			}

			module.exports = strictIndexOf;

			/***/
		},
		/* 150 */
		/*!***************************!*\
    !*** ./~/lodash/clone.js ***!
    \***************************/
		/***/function (module, exports, __webpack_require__) {

			var baseClone = __webpack_require__( /*! ./_baseClone */77);

			/** Used to compose bitmasks for cloning. */
			var CLONE_SYMBOLS_FLAG = 4;

			/**
    * Creates a shallow clone of `value`.
    *
    * **Note:** This method is loosely based on the
    * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
    * and supports cloning arrays, array buffers, booleans, date objects, maps,
    * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
    * arrays. The own enumerable properties of `arguments` objects are cloned
    * as plain objects. An empty object is returned for uncloneable values such
    * as error objects, functions, DOM nodes, and WeakMaps.
    *
    * @static
    * @memberOf _
    * @since 0.1.0
    * @category Lang
    * @param {*} value The value to clone.
    * @returns {*} Returns the cloned value.
    * @see _.cloneDeep
    * @example
    *
    * var objects = [{ 'a': 1 }, { 'b': 2 }];
    *
    * var shallow = _.clone(objects);
    * console.log(shallow[0] === objects[0]);
    * // => true
    */
			function clone(value) {
				return baseClone(value, CLONE_SYMBOLS_FLAG);
			}

			module.exports = clone;

			/***/
		},
		/* 151 */
		/*!******************************!*\
    !*** ./~/lodash/constant.js ***!
    \******************************/
		/***/function (module, exports) {

			/**
    * Creates a function that returns `value`.
    *
    * @static
    * @memberOf _
    * @since 2.4.0
    * @category Util
    * @param {*} value The value to return from the new function.
    * @returns {Function} Returns the new constant function.
    * @example
    *
    * var objects = _.times(2, _.constant({ 'a': 1 }));
    *
    * console.log(objects);
    * // => [{ 'a': 1 }, { 'a': 1 }]
    *
    * console.log(objects[0] === objects[1]);
    * // => true
    */
			function constant(value) {
				return function () {
					return value;
				};
			}

			module.exports = constant;

			/***/
		},
		/* 152 */
		/*!*********************************!*\
    !*** ./~/lodash/isArguments.js ***!
    \*********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseIsArguments = __webpack_require__( /*! ./_baseIsArguments */82),
			    isObjectLike = __webpack_require__( /*! ./isObjectLike */5);

			/** Used for built-in method references. */
			var objectProto = Object.prototype;

			/** Used to check objects for own properties. */
			var hasOwnProperty = objectProto.hasOwnProperty;

			/** Built-in value references. */
			var propertyIsEnumerable = objectProto.propertyIsEnumerable;

			/**
    * Checks if `value` is likely an `arguments` object.
    *
    * @static
    * @memberOf _
    * @since 0.1.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is an `arguments` object,
    *  else `false`.
    * @example
    *
    * _.isArguments(function() { return arguments; }());
    * // => true
    *
    * _.isArguments([1, 2, 3]);
    * // => false
    */
			var isArguments = baseIsArguments(function () {
				return arguments;
			}()) ? baseIsArguments : function (value) {
				return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
			};

			module.exports = isArguments;

			/***/
		},
		/* 153 */
		/*!***************************************!*\
    !*** ./~/lodash/isArrayLikeObject.js ***!
    \***************************************/
		/***/function (module, exports, __webpack_require__) {

			var isArrayLike = __webpack_require__( /*! ./isArrayLike */13),
			    isObjectLike = __webpack_require__( /*! ./isObjectLike */5);

			/**
    * This method is like `_.isArrayLike` except that it also checks if `value`
    * is an object.
    *
    * @static
    * @memberOf _
    * @since 4.0.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is an array-like object,
    *  else `false`.
    * @example
    *
    * _.isArrayLikeObject([1, 2, 3]);
    * // => true
    *
    * _.isArrayLikeObject(document.body.children);
    * // => true
    *
    * _.isArrayLikeObject('abc');
    * // => false
    *
    * _.isArrayLikeObject(_.noop);
    * // => false
    */
			function isArrayLikeObject(value) {
				return isObjectLike(value) && isArrayLike(value);
			}

			module.exports = isArrayLikeObject;

			/***/
		},
		/* 154 */
		/*!******************************!*\
    !*** ./~/lodash/isSymbol.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			var baseGetTag = __webpack_require__( /*! ./_baseGetTag */4),
			    isObjectLike = __webpack_require__( /*! ./isObjectLike */5);

			/** `Object#toString` result references. */
			var symbolTag = '[object Symbol]';

			/**
    * Checks if `value` is classified as a `Symbol` primitive or object.
    *
    * @static
    * @memberOf _
    * @since 4.0.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
    * @example
    *
    * _.isSymbol(Symbol.iterator);
    * // => true
    *
    * _.isSymbol('abc');
    * // => false
    */
			function isSymbol(value) {
				return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
			}

			module.exports = isSymbol;

			/***/
		},
		/* 155 */
		/*!**********************************!*\
    !*** ./~/lodash/isTypedArray.js ***!
    \**********************************/
		/***/function (module, exports, __webpack_require__) {

			var baseIsTypedArray = __webpack_require__( /*! ./_baseIsTypedArray */85),
			    baseUnary = __webpack_require__( /*! ./_baseUnary */35),
			    nodeUtil = __webpack_require__( /*! ./_nodeUtil */136);

			/* Node.js helper references. */
			var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

			/**
    * Checks if `value` is classified as a typed array.
    *
    * @static
    * @memberOf _
    * @since 3.0.0
    * @category Lang
    * @param {*} value The value to check.
    * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
    * @example
    *
    * _.isTypedArray(new Uint8Array);
    * // => true
    *
    * _.isTypedArray([]);
    * // => false
    */
			var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

			module.exports = isTypedArray;

			/***/
		},
		/* 156 */
		/*!***************************!*\
    !*** ./~/lodash/range.js ***!
    \***************************/
		/***/function (module, exports, __webpack_require__) {

			var createRange = __webpack_require__( /*! ./_createRange */106);

			/**
    * Creates an array of numbers (positive and/or negative) progressing from
    * `start` up to, but not including, `end`. A step of `-1` is used if a negative
    * `start` is specified without an `end` or `step`. If `end` is not specified,
    * it's set to `start` with `start` then set to `0`.
    *
    * **Note:** JavaScript follows the IEEE-754 standard for resolving
    * floating-point values which can produce unexpected results.
    *
    * @static
    * @since 0.1.0
    * @memberOf _
    * @category Util
    * @param {number} [start=0] The start of the range.
    * @param {number} end The end of the range.
    * @param {number} [step=1] The value to increment or decrement by.
    * @returns {Array} Returns the range of numbers.
    * @see _.inRange, _.rangeRight
    * @example
    *
    * _.range(4);
    * // => [0, 1, 2, 3]
    *
    * _.range(-4);
    * // => [0, -1, -2, -3]
    *
    * _.range(1, 5);
    * // => [1, 2, 3, 4]
    *
    * _.range(0, 20, 5);
    * // => [0, 5, 10, 15]
    *
    * _.range(0, -4, -1);
    * // => [0, -1, -2, -3]
    *
    * _.range(1, 4, 0);
    * // => [1, 1, 1]
    *
    * _.range(0);
    * // => []
    */
			var range = createRange();

			module.exports = range;

			/***/
		},
		/* 157 */
		/*!*****************************!*\
    !*** ./~/lodash/shuffle.js ***!
    \*****************************/
		/***/function (module, exports, __webpack_require__) {

			var arrayShuffle = __webpack_require__( /*! ./_arrayShuffle */73),
			    baseShuffle = __webpack_require__( /*! ./_baseShuffle */92),
			    isArray = __webpack_require__( /*! ./isArray */12);

			/**
    * Creates an array of shuffled values, using a version of the
    * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
    *
    * @static
    * @memberOf _
    * @since 0.1.0
    * @category Collection
    * @param {Array|Object} collection The collection to shuffle.
    * @returns {Array} Returns the new shuffled array.
    * @example
    *
    * _.shuffle([1, 2, 3, 4]);
    * // => [4, 1, 3, 2]
    */
			function shuffle(collection) {
				var func = isArray(collection) ? arrayShuffle : baseShuffle;
				return func(collection);
			}

			module.exports = shuffle;

			/***/
		},
		/* 158 */
		/*!*******************************!*\
    !*** ./~/lodash/stubFalse.js ***!
    \*******************************/
		/***/function (module, exports) {

			/**
    * This method returns `false`.
    *
    * @static
    * @memberOf _
    * @since 4.13.0
    * @category Util
    * @returns {boolean} Returns `false`.
    * @example
    *
    * _.times(2, _.stubFalse);
    * // => [false, false]
    */
			function stubFalse() {
				return false;
			}

			module.exports = stubFalse;

			/***/
		},
		/* 159 */
		/*!******************************!*\
    !*** ./~/lodash/toFinite.js ***!
    \******************************/
		/***/function (module, exports, __webpack_require__) {

			var toNumber = __webpack_require__( /*! ./toNumber */51);

			/** Used as references for various `Number` constants. */
			var INFINITY = 1 / 0,
			    MAX_INTEGER = 1.7976931348623157e+308;

			/**
    * Converts `value` to a finite number.
    *
    * @static
    * @memberOf _
    * @since 4.12.0
    * @category Lang
    * @param {*} value The value to convert.
    * @returns {number} Returns the converted number.
    * @example
    *
    * _.toFinite(3.2);
    * // => 3.2
    *
    * _.toFinite(Number.MIN_VALUE);
    * // => 5e-324
    *
    * _.toFinite(Infinity);
    * // => 1.7976931348623157e+308
    *
    * _.toFinite('3.2');
    * // => 3.2
    */
			function toFinite(value) {
				if (!value) {
					return value === 0 ? value : 0;
				}
				value = toNumber(value);
				if (value === INFINITY || value === -INFINITY) {
					var sign = value < 0 ? -1 : 1;
					return sign * MAX_INTEGER;
				}
				return value === value ? value : 0;
			}

			module.exports = toFinite;

			/***/
		},
		/* 160 */
		/*!****************************!*\
    !*** ./~/lodash/values.js ***!
    \****************************/
		/***/function (module, exports, __webpack_require__) {

			var baseValues = __webpack_require__( /*! ./_baseValues */94),
			    keys = __webpack_require__( /*! ./keys */14);

			/**
    * Creates an array of the own enumerable string keyed property values of `object`.
    *
    * **Note:** Non-object values are coerced to objects.
    *
    * @static
    * @since 0.1.0
    * @memberOf _
    * @category Object
    * @param {Object} object The object to query.
    * @returns {Array} Returns the array of property values.
    * @example
    *
    * function Foo() {
    *   this.a = 1;
    *   this.b = 2;
    * }
    *
    * Foo.prototype.c = 3;
    *
    * _.values(new Foo);
    * // => [1, 2] (iteration order is not guaranteed)
    *
    * _.values('hi');
    * // => ['h', 'i']
    */
			function values(object) {
				return object == null ? [] : baseValues(object, keys(object));
			}

			module.exports = values;

			/***/
		},
		/* 161 */
		/*!*****************************!*\
    !*** ./~/lodash/without.js ***!
    \*****************************/
		/***/function (module, exports, __webpack_require__) {

			var baseDifference = __webpack_require__( /*! ./_baseDifference */79),
			    baseRest = __webpack_require__( /*! ./_baseRest */90),
			    isArrayLikeObject = __webpack_require__( /*! ./isArrayLikeObject */153);

			/**
    * Creates an array excluding all given values using
    * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    * for equality comparisons.
    *
    * **Note:** Unlike `_.pull`, this method returns a new array.
    *
    * @static
    * @memberOf _
    * @since 0.1.0
    * @category Array
    * @param {Array} array The array to inspect.
    * @param {...*} [values] The values to exclude.
    * @returns {Array} Returns the new array of filtered values.
    * @see _.difference, _.xor
    * @example
    *
    * _.without([2, 1, 2, 3], 1, 2);
    * // => [3]
    */
			var without = baseRest(function (array, values) {
				return isArrayLikeObject(array) ? baseDifference(array, values) : [];
			});

			module.exports = without;

			/***/
		},
		/* 162 */
		/*!*************************************!*\
    !*** ./~/style-loader/addStyles.js ***!
    \*************************************/
		/***/function (module, exports, __webpack_require__) {

			/*
   	MIT License http://www.opensource.org/licenses/mit-license.php
   	Author Tobias Koppers @sokra
   */
			var stylesInDom = {},
			    memoize = function memoize(fn) {
				var memo;
				return function () {
					if (typeof memo === "undefined") memo = fn.apply(this, arguments);
					return memo;
				};
			},
			    isOldIE = memoize(function () {
				return (/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())
				);
			}),
			    getHeadElement = memoize(function () {
				return document.head || document.getElementsByTagName("head")[0];
			}),
			    singletonElement = null,
			    singletonCounter = 0,
			    styleElementsInsertedAtTop = [];

			module.exports = function (list, options) {
				if (false) {
					if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
				}

				options = options || {};
				// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
				// tags it will allow on a page
				if (typeof options.singleton === "undefined") options.singleton = isOldIE();

				// By default, add <style> tags to the bottom of <head>.
				if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

				var styles = listToStyles(list);
				addStylesToDom(styles, options);

				return function update(newList) {
					var mayRemove = [];
					for (var i = 0; i < styles.length; i++) {
						var item = styles[i];
						var domStyle = stylesInDom[item.id];
						domStyle.refs--;
						mayRemove.push(domStyle);
					}
					if (newList) {
						var newStyles = listToStyles(newList);
						addStylesToDom(newStyles, options);
					}
					for (var i = 0; i < mayRemove.length; i++) {
						var domStyle = mayRemove[i];
						if (domStyle.refs === 0) {
							for (var j = 0; j < domStyle.parts.length; j++) {
								domStyle.parts[j]();
							}delete stylesInDom[domStyle.id];
						}
					}
				};
			};

			function addStylesToDom(styles, options) {
				for (var i = 0; i < styles.length; i++) {
					var item = styles[i];
					var domStyle = stylesInDom[item.id];
					if (domStyle) {
						domStyle.refs++;
						for (var j = 0; j < domStyle.parts.length; j++) {
							domStyle.parts[j](item.parts[j]);
						}
						for (; j < item.parts.length; j++) {
							domStyle.parts.push(addStyle(item.parts[j], options));
						}
					} else {
						var parts = [];
						for (var j = 0; j < item.parts.length; j++) {
							parts.push(addStyle(item.parts[j], options));
						}
						stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
					}
				}
			}

			function listToStyles(list) {
				var styles = [];
				var newStyles = {};
				for (var i = 0; i < list.length; i++) {
					var item = list[i];
					var id = item[0];
					var css = item[1];
					var media = item[2];
					var sourceMap = item[3];
					var part = { css: css, media: media, sourceMap: sourceMap };
					if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
				}
				return styles;
			}

			function insertStyleElement(options, styleElement) {
				var head = getHeadElement();
				var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
				if (options.insertAt === "top") {
					if (!lastStyleElementInsertedAtTop) {
						head.insertBefore(styleElement, head.firstChild);
					} else if (lastStyleElementInsertedAtTop.nextSibling) {
						head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
					} else {
						head.appendChild(styleElement);
					}
					styleElementsInsertedAtTop.push(styleElement);
				} else if (options.insertAt === "bottom") {
					head.appendChild(styleElement);
				} else {
					throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
				}
			}

			function removeStyleElement(styleElement) {
				styleElement.parentNode.removeChild(styleElement);
				var idx = styleElementsInsertedAtTop.indexOf(styleElement);
				if (idx >= 0) {
					styleElementsInsertedAtTop.splice(idx, 1);
				}
			}

			function createStyleElement(options) {
				var styleElement = document.createElement("style");
				styleElement.type = "text/css";
				insertStyleElement(options, styleElement);
				return styleElement;
			}

			function createLinkElement(options) {
				var linkElement = document.createElement("link");
				linkElement.rel = "stylesheet";
				insertStyleElement(options, linkElement);
				return linkElement;
			}

			function addStyle(obj, options) {
				var styleElement, update, remove;

				if (options.singleton) {
					var styleIndex = singletonCounter++;
					styleElement = singletonElement || (singletonElement = createStyleElement(options));
					update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
					remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
				} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
					styleElement = createLinkElement(options);
					update = updateLink.bind(null, styleElement);
					remove = function remove() {
						removeStyleElement(styleElement);
						if (styleElement.href) URL.revokeObjectURL(styleElement.href);
					};
				} else {
					styleElement = createStyleElement(options);
					update = applyToTag.bind(null, styleElement);
					remove = function remove() {
						removeStyleElement(styleElement);
					};
				}

				update(obj);

				return function updateStyle(newObj) {
					if (newObj) {
						if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
						update(obj = newObj);
					} else {
						remove();
					}
				};
			}

			var replaceText = function () {
				var textStore = [];

				return function (index, replacement) {
					textStore[index] = replacement;
					return textStore.filter(Boolean).join('\n');
				};
			}();

			function applyToSingletonTag(styleElement, index, remove, obj) {
				var css = remove ? "" : obj.css;

				if (styleElement.styleSheet) {
					styleElement.styleSheet.cssText = replaceText(index, css);
				} else {
					var cssNode = document.createTextNode(css);
					var childNodes = styleElement.childNodes;
					if (childNodes[index]) styleElement.removeChild(childNodes[index]);
					if (childNodes.length) {
						styleElement.insertBefore(cssNode, childNodes[index]);
					} else {
						styleElement.appendChild(cssNode);
					}
				}
			}

			function applyToTag(styleElement, obj) {
				var css = obj.css;
				var media = obj.media;

				if (media) {
					styleElement.setAttribute("media", media);
				}

				if (styleElement.styleSheet) {
					styleElement.styleSheet.cssText = css;
				} else {
					while (styleElement.firstChild) {
						styleElement.removeChild(styleElement.firstChild);
					}
					styleElement.appendChild(document.createTextNode(css));
				}
			}

			function updateLink(linkElement, obj) {
				var css = obj.css;
				var sourceMap = obj.sourceMap;

				if (sourceMap) {
					// http://stackoverflow.com/a/26603875
					css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
				}

				var blob = new Blob([css], { type: "text/css" });

				var oldSrc = linkElement.href;

				linkElement.href = URL.createObjectURL(blob);

				if (oldSrc) URL.revokeObjectURL(oldSrc);
			}

			/***/
		},
		/* 163 */
		/*!*****************************************************************************************************************!*\
    !*** external {"root":"ReactMotion","amd":"react-motion","commonjs":"react-motion","commonjs2":"react-motion"} ***!
    \*****************************************************************************************************************/
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_163__;

			/***/
		}
		/******/])
	);
});
;

/***/ }),

/***/ "qZLH":
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var PREACT_TAG_MAP = exports.PREACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),

/***/ "sW0/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__("p7hS");

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ "u4m+":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}
})();

/***/ }),

/***/ "uEG6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ "uXl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("EBst");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "xRMi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),

/***/ "y+SO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("EBst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.5fd7c.js